<template>
    <el-container>
        <el-header style="text-align: center;height: 100px;">
            <h1 style="margin-bottom: 4px;">OPPO批搭 </h1>
            <div style="font-size: 12px; color: #909399;">版本号: v1.0.10</div>
        </el-header>

        <!-- 步骤条 - 悬浮显示任务进度 -->
        <div class="ad-flow" v-if="showProgress">
            <el-steps :active="activeStep" finish-status="success" direction="vertical" align-center>
                <el-step v-for="(item, index) in steps" :key="index" :title="item.name"
                    :status="getStepStatus(item.status)">
                    <template #description>
                        <div class="step-detail">{{ item.detail }}</div>
                    </template>
                </el-step>
            </el-steps>
            <div class="progress-percent">总体进度: {{ uploadPercent }}%</div>
        </div>

        <el-main>
            <div class="plan-container">
                <!-- 任务列表卡片 -->
                <el-card class="task-card" v-if="tasks.length > 0">
                    <div slot="header" class="task-header">
                        <span>批量任务列表</span>
                        <div>
                            <el-button type="text" @click="opencreatedanyuanlist">查看全部任务</el-button>
                            <el-button type="text" @click="clearCompletedTasks">清除已完成</el-button>
                        </div>
                    </div>

                    <div class="task-list">
                        <div v-for="task in tasks.slice(0, 3)" :key="task.id" class="task-item">
                            <div class="task-title">
                                <el-row type="flex" align="middle">
                                    <el-col :span="12">
                                        <i class="el-icon-s-order"></i>
                                        {{ task.name }}
                                        <el-tag :type="getTaskStatusType(task.status)" size="mini" class="status-tag">
                                            {{ getTaskStatusText(task.status) }}
                                        </el-tag>
                                    </el-col>
                                    <el-col :span="12" class="task-actions">
                                        <el-button v-if="task.status === 'running'" @click="stopTask(task.id)" size="mini"
                                            type="warning" plain>
                                            停止
                                        </el-button>
                                        <el-button v-if="task.status === 'running'" @click="pauseTask(task.id)" size="mini"
                                            type="info" plain>
                                            暂停
                                        </el-button>
                                        <el-button v-if="task.status === 'paused'" @click="resumeTask(task.id)" size="mini"
                                            type="success" plain>
                                            继续
                                        </el-button>
                                    </el-col>
                                </el-row>
                            </div>
                            <div class="task-progress">
                                <span>进度: {{ task.currentIndex }}/{{ task.totalItems }}</span>
                                <el-progress :percentage="Math.round(task.currentIndex / task.totalItems * 100)"
                                    :status="getProgressStatus(task.status)" :stroke-width="6">
                                </el-progress>
                            </div>
                        </div>
                    </div>
                </el-card>

                <el-form :model="form" label-position="right" class="demo-ruleForm">
                    <div class="adgroup-item">快速搭建</div>

                    <el-form-item label="查询指令:" label-width="160px">
                        <el-button type="primary" @click="templateDialogVisibleChange">历史模板</el-button>
                        <el-button type="primary" @click="dsDialogVisibleChange">管理定时任务</el-button>
                        <el-button type="primary" @click="GetRoChange">刷新</el-button>
                    </el-form-item>

                    <div class="adgroup-item">账户信息</div>
                    <el-form-item label="项目名:" label-width="160px">
                        <el-select v-model="btgjc" filterable clearable placeholder="请选择" @change="recordsChange">
                            <el-option v-for="(items, i) in listname" :key="i" :value="items.username">
                            </el-option>
                        </el-select>

                        <el-select v-model="towName" filterable clearable placeholder="请选择" @change="GetRoChange">
                            <el-option v-for="(items, i) in two" :key="i" :value="items.twoname">
                            </el-option>
                        </el-select>

                        <div class="item-orient">
                            <el-tag v-for="(item, index) in ids_list" :key="index" type="success">
                                {{ item.idsname }}
                            </el-tag>
                        </div>
                    </el-form-item>

                    <div class="adgroup-item">广告计划</div>
                    <div class="adgroup-item2">计划设置</div>

                    <el-form-item label="推广目标:" label-width="160px">
                        <el-radio-group v-model="form.extension_type" @input="extensionTypeChange">
                            <el-radio-button v-for="item in extensionType_goal_group" :key="item.value"
                                :label="item.value">{{ item.label }}</el-radio-button>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="竞价策略" label-width="160px">
                        <el-radio-group v-model="form.delivery_mode">
                            <el-radio-button label="0">稳定成本</el-radio-button>
                            <el-radio-button label="1">最大转化</el-radio-button>
                            <el-radio-button label="2">最优成本</el-radio-button>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="投放预算(元/天)" label-width="160px">
                        <el-radio-group v-model="form.dayLimit">
                            <el-radio-button label="0">无</el-radio-button>
                            <el-radio-button label="1">预算设置</el-radio-button>
                        </el-radio-group>
                        <el-input v-model="form.dayBudget" placeholder="请输入投放预算" v-if="form.dayLimit == 1">
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>

                    <el-form-item label="计划开关" label-width="160px">
                        <el-radio-group v-model="form.switchPlan">
                            <el-radio-button label="1">关闭</el-radio-button>
                            <el-radio-button label="0">开启</el-radio-button>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="广告计划名称" label-width="160px">
                        <el-input v-model="form.campaign_name" placeholder="请输入广告计划名称"></el-input>
                    </el-form-item>

                    <el-form-item label="是否使用最新广告计划" prop="useLatestPlan" label-width="192px">
                        <el-switch v-model="form.useLatestPlan" active-color="#13ce66" inactive-color="#ff4949"
                            @change="useLatestPlanChange">
                        </el-switch>
                        <span class="switch-tip" style="margin-left: 10px; color: #909399; font-size: 12px;">
                            勾选后将自动获取最新计划ID，否则创建新计划
                        </span>
                    </el-form-item>

                    <div class="adgroup-item">广告组</div>

                    <el-form-item label="广告组搭建数量" prop="adgroupNumber" label-width="152px">
                        <el-input type="number" v-model="form.adgroupNumber" placeholder="请输入搭建数量" min="1" step="1">
                        </el-input>
                    </el-form-item>

                    <div class="adgroup-item2">时段</div>
                    <el-form-item label="是否限制推广时段">
                        <el-select v-model="timeLimit" placeholder="请选择" @change="handleTimeLimitChange">
                            <el-option label="否" :value="0"></el-option>
                            <el-option label="是" :value="1"></el-option>
                        </el-select>
                    </el-form-item>

                    <div v-if="timeLimit === 1">
                        <el-form-item label="设置推广时间：">
                            <el-row :gutter="20">
                                <el-col :span="12" style="width: 150px">
                                    <el-time-select style="width: 150px" v-model="startTime" :picker-options="pickerOptions"
                                        placeholder="开始时间" @change="validateAndGenerateTimeSet"></el-time-select>
                                </el-col>
                                <el-col :span="12" style="width: 150px">
                                    <el-time-select style="width: 150px" v-model="endTime" :picker-options="pickerOptions"
                                        placeholder="结束时间" @change="validateAndGenerateTimeSet"></el-time-select>
                                </el-col>
                            </el-row>
                            <span v-if="errorMessage" class="error">{{ errorMessage }}</span>
                        </el-form-item>
                    </div>

                    <div class="adgroup-item2">流量</div>
                    <el-form-item label="推广流量" prop="extensionFlow" label-width="152px">
                        <el-radio-group v-model="form2.extensionFlow" @input="changeextensionFlow">
                            <el-radio-button label="1" v-if="form.extension_type == 2">全流量场景</el-radio-button>
                            <el-radio-button label="2">自有流量</el-radio-button>
                            <el-radio-button label="3">联盟流量</el-radio-button>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="流量场景" prop="flowScene" label-width="152px">
                        <el-radio-group v-model="form2.flowScene" @input="flowScenechange">
                            <el-radio-button v-for="item in form2.flowScene_choose_list" :key="item.value"
                                :label="item.value">{{ item.label }}</el-radio-button>
                        </el-radio-group>
                    </el-form-item>

                    <div class="adgroup-item2">目标</div>

                    <el-form-item label="广告类型" prop="dpaProductType" label-width="152px"
                        v-if="form2.flowScene == 6 || form2.flowScene == 7 || form2.flowScene == 9 || form2.flowScene == 10">
                        <el-radio-group v-model="form2.dpaProductType">
                            <el-radio-button label="0">产品化投放</el-radio-button>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="是否自动获取落地页url" prop="price" label-width="192px">
                        <el-switch v-model="parsestatus" active-color="#13ce66" inactive-color="#ff4949"
                            @change="parsestatusChang"></el-switch>
                    </el-form-item>

                    <el-form-item label="网页地址类型" prop="pageType" label-width="152px">
                        <el-select v-model="form2.pageTypelabel" filterable :label="form2.pageTypelabel" clearable
                            placeholder="请选择" @change="pageTypechang">
                            <el-option v-for="(items, i) in pageType_list" :key="i" :value="items.value"
                                :label="items.label">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="模板名称" prop="templateName" label-width="152px" v-if="form2.pageType == 11">
                        <el-input v-model="form2.templateName" placeholder="请输入模板名称" clearable />
                        <div style="font-size: 12px; color: #909399; margin-top: 4px;">
                            输入模板名称后，系统将自动匹配对应的模板ID和URL
                        </div>
                    </el-form-item>

                    <el-form-item label="Deeplink类型" prop="Deeplinktype" label-width="152px"
                        v-if="form.extension_type == 1">
                        <el-radio-group v-model="form2.Deeplinktype">
                            <el-radio-button label="0">应用DP</el-radio-button>
                            <el-radio-button label="3">快应用DP</el-radio-button>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="Deeplink链接启用" prop="linkDeskFlag" label-width="152px"
                        v-if="form2.Deeplinktype == 0 && form.extension_type == 1">
                        <el-switch v-model="form2.Deeplinkstatus" :active-value="1" :inactive-value="0"
                            active-color="#13ce66" inactive-color="#ff4949">
                        </el-switch>
                    </el-form-item>

                    <el-form-item label="打开并加桌" prop="linkDeskFlag" label-width="152px"
                        v-if="form2.flowScene == 6 && form.extension_type == 3">
                        <el-switch v-model="form2.linkDeskFlag" :active-value="1" :inactive-value="0" active-color="#13ce66"
                            inactive-color="#ff4949">
                        </el-switch>
                    </el-form-item>

                    <div class="adgroup-item2">出价</div>

                    <el-form-item label="出价方式" prop="billingType" label-width="152px">
                        <el-radio-group v-model="form2.billingType">
                            <el-radio-button label="2">CPC</el-radio-button>
                            <el-radio-button label="5"
                                v-if="(form2.flowScene != '13') || (form.extension_type == 2 && form2.flowScene == '13')">OCPC</el-radio-button>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="广告免一阶" prop="defaultSecondStage" label-width="152px" v-if="form2.billingType == 5">
                        <el-switch v-model="form2.defaultSecondStage" :active-value="1" :inactive-value="0"
                            active-color="#13ce66" inactive-color="#ff4949">
                        </el-switch>
                    </el-form-item>

                    <el-form-item label="是否使用最新广告组出价" prop="price" label-width="192px">
                        <el-switch v-model="isoldgroupprice" active-color="#13ce66" inactive-color="#ff4949"
                            @change="isoldgrouppriceChang"></el-switch>
                    </el-form-item>

                    <el-form-item label="基础出价" prop="price" label-width="152px">
                        <el-input v-model="form2.price" :placeholder="form2.billingType == 2 ? '最低出价0.1元' : '最低出价1.2元'">
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>

                    <el-form-item label="转化类型" prop="price" label-width="152px" v-if="form2.billingType == 5">
                        <el-select v-model="form2.ocpcType" filterable placeholder="请选择" @change="ocpcTypechange">
                            <el-option v-for="item in form2.ocpcTypeoptions" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="转化出价" prop="price" label-width="152px"
                        v-if="form2.billingType == 5 && form2.ocpcType != 47">
                        <el-input v-model="form2.ocpcPrice" placeholder="请输入转化出价">
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>

                    <el-form-item label="目标ROI系数" prop="price" label-width="152px" v-if="form2.ocpcType == 47">
                        <el-input v-model="form2.targetROI" placeholder="请输入0.0001到10之间的数字">
                        </el-input>
                    </el-form-item>

                    <el-form-item label="深度转化投放" prop="defaultSecondStage" label-width="152px"
                        v-if="form2.billingType == '5' && form.extension_type == '2'">
                        <el-switch v-model="form2.deepOcpcStatus" active-color="#13ce66" inactive-color="#ff4949">
                        </el-switch>
                    </el-form-item>

                    <el-form-item label="深度转化类型" prop="deepOcpcType" label-width="152px"
                        v-if="form2.billingType == '5' && form.extension_type == '2' && form2.deepOcpcStatus">
                        <el-select v-model="form2.deepOcpcType" filterable placeholder="请选择">
                            <el-option v-for="item in form2.deepOcpcTypeoptions" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="深度转化出价" prop="deepOcpcPrice" label-width="152px"
                        v-if="form2.billingType == '5' && form.extension_type == '2' && form2.deepOcpcStatus">
                        <el-input v-model="form2.deepOcpcPrice" placeholder="请输入深度转化出价">
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>

                    <div class="adgroup-item">创意基础信息</div>

                    <el-form-item label="是否开启混搭" prop="number" label-width="152px">
                        <el-switch v-model="mixminvalue" active-color="#13ce66" inactive-color="#ff4949">
                        </el-switch>
                    </el-form-item>

                    <el-form-item label="搭建策略" prop="number" label-width="152px">
                        <el-radio-group v-model="mixminvaluelate">
                            <el-radio-button label="重复"></el-radio-button>
                            <el-radio-button label="轮询"></el-radio-button>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="创意搭建数量" prop="number" label-width="152px">
                        <el-input type="number" v-model="form3.number" placeholder="请输入搭建数量" min="1" step="1"
                            @change="form3Numberchange">
                        </el-input>
                    </el-form-item>

                    <el-form-item label="创意第二种搭建数量" prop="number" label-width="152px"
                        v-if="form.extension_type == 2 && form2.extensionFlow == 1 && form2.flowScene == 1">
                        <el-input type="number" v-model="form3.number2" placeholder="请输入搭建数量" min="1" step="1"
                            @change="form4Numberchange">
                        </el-input>
                    </el-form-item>

                    <el-form-item label="创意样式" prop="type" label-width="152px">
                        <div class="el-form-item__content">
                            <el-select v-model="material_type" disabled>
                            </el-select>
                            <el-button type="primary" plain style="margin-left: 16px;" @click="openStyleDialog">
                                点击选择
                            </el-button>
                        </div>
                    </el-form-item>

                    <div class="adgroup-item2">创意规格</div>

                    <el-form-item label="素材" prop="app_logo" label-width="152px">
                        <el-button type="primary" @click="handleMaterialsdialog">
                            选择素材
                        </el-button>
                        <span class="material-stats" v-if="hasMaterials">
                            <el-tag size="small" type="success" class="material-tag">LOGO: {{ txfileList.length }}</el-tag>
                            <el-tag size="small" type="success" class="material-tag">图片: {{ tpfileList.length }}</el-tag>
                            <el-tag size="small" type="success" class="material-tag">封面: {{ videotpfileList.length
                            }}</el-tag>
                            <el-tag size="small" type="success" class="material-tag">视频: {{ videofileList.length }}</el-tag>
                        </span>
                    </el-form-item>

                    <el-form-item label="按钮文案" label-width="152px">
                        <el-select v-model="form3.buttonTxt" filterable placeholder="请选择">
                            <el-option v-for="item in buttonTxtOptions" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <!-- 衍生视频创意（仅当流量场景为信息流 6 时显示） -->
<el-form-item label="衍生视频创意" v-if="form2.flowScene == 6" label-width="152px">
  <el-switch v-model="enableDeriveVideo" active-text="开启" inactive-text="关闭" />
</el-form-item>

<!-- 多选衍生模板（开启 + 信息流 + 横版大图） -->
<el-form-item v-if="enableDeriveVideo && form2.flowScene == 6 && form3.type == 1" label="选择衍生模板" label-width="152px">
  <el-select
    v-model="selectedDeriveTemplates"
    multiple
    filterable
    placeholder="可多选，最多3个"
    :multiple-limit="3"
  >
    <el-option
      v-for="tpl in deriveTemplateList"
      :key="tpl.id"
      :label="tpl.tplName"
      :value="tpl.id"
    />
  </el-select>
  <span class="switch-tip" style="margin-left: 10px; color: #909399; font-size: 12px;">
    最多选择3个模板，选中后将自动生成衍生视频
  </span>
</el-form-item>

                    <el-form-item label="品牌名称" prop="brandName" label-width="152px">
                        <el-input v-model="form3.brandName" placeholder="请输入品牌名称">
                        </el-input>
                    </el-form-item>

                    <el-form-item :label="'文案：' + form3.title.length + '个'" label-width="152px">
                        <el-input type="textarea" style="width: 440px;" v-model="titlesString" placeholder="请输入标题（每行一个）"
                            :rows="9" @input="handleInput"></el-input>
                        <div style="display: block;">
                            <div v-for="(line, index) in linesWithLimitError" :key="index"
                                style="color: red; font-size: 12px; margin-top: 5px;">
                                <div>第{{ index + 1 }}行字符限制在0-35个字 {{ line }} </div>
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>

        </el-main>

        <!-- 创意样式选择对话框 -->
        <el-dialog title="选择创意样式" :visible.sync="createTypedialog" width="728px">
            <div class="el-form-item__content">
                <div class="style-selector">
                    <div class="category" v-for="category in styleCategories" :key="category.title">
                        <div class="category-title">{{ category.title }}</div>
                        <ul class="style-list">
                            <li v-for="style in category.styles" :key="style.value" :class="{
                                'selected': selectedStyle === style.value,
                                'recommended': style.recommended
                            }" @click="selectStyle(style)">
                                <img :src="style.image" class="bg-image">
                                <span class="style-info">{{ style.label }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="createTypedialog = false">取 消</el-button>
                <el-button type="primary" @click="CreativeTypechang">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 素材上传对话框 - 显示上传进度列表 -->
        <el-dialog title="选择创意素材" :visible.sync="creativeMaterials" width="1160px" append-to-body>
            <div class="m-header" style="height: 600px;overflow-y: auto;">
                <!-- 上传进度列表 -->
                <div class="upload-progress-panel" v-if="uploadingMaterials.length > 0">
                    <div class="progress-title">
                        <i class="el-icon-upload"></i> 素材上传进度
                        <span class="progress-stats">{{ completedUploadCount }}/{{ uploadingMaterials.length }} 已完成</span>
                    </div>

                    <!-- LOGO 组 -->
                    <div v-if="getMaterialsByType('logo').length > 0" class="progress-type-group">
                        <div class="type-group-title">
                            <i class="el-icon-picture"></i> LOGO素材
                            <span class="type-stats">{{ getTypeSuccessCount('logo') }}/{{ getMaterialsByType('logo').length
                            }}</span>
                        </div>
                        <div v-for="material in getMaterialsByType('logo')" :key="material.id" class="upload-progress-item">
                            <!-- 进度条内容 -->
                            <div class="progress-info">
                                <span class="material-name">{{ material.name }}</span>
                                <span class="material-status" :class="material.status">
                                    {{ getMaterialStatusText(material.status) }}
                                </span>
                            </div>
                            <el-progress :percentage="material.progress" :stroke-width="8"
                                :status="material.status === 'error' ? 'exception' : (material.status === 'success' ? 'success' : null)">
                            </el-progress>
                            <div class="progress-detail" v-if="material.detail">{{ material.detail }}</div>
                        </div>
                    </div>

                    <!-- 图片组 -->
                    <div v-if="getMaterialsByType('image').length > 0" class="progress-type-group">
                        <div class="type-group-title">
                            <i class="el-icon-picture"></i> 图片素材
                            <span class="type-stats">{{ getTypeSuccessCount('image') }}/{{
                                getMaterialsByType('image').length }}</span>
                        </div>
                        <div v-for="material in getMaterialsByType('image')" :key="material.id"
                            class="upload-progress-item">
                            <div class="progress-info">
                                <span class="material-name">{{ material.name }}</span>
                                <span class="material-status" :class="material.status">
                                    {{ getMaterialStatusText(material.status) }}
                                </span>
                            </div>
                            <el-progress :percentage="material.progress" :stroke-width="8"
                                :status="material.status === 'error' ? 'exception' : (material.status === 'success' ? 'success' : null)">
                            </el-progress>
                            <div class="progress-detail" v-if="material.detail">{{ material.detail }}</div>
                        </div>
                    </div>

                    <!-- 封面的组 -->
                    <div v-if="getMaterialsByType('cover').length > 0" class="progress-type-group">
                        <div class="type-group-title">
                            <i class="el-icon-picture"></i> 封面素材
                            <span class="type-stats">{{ getTypeSuccessCount('cover') }}/{{
                                getMaterialsByType('cover').length }}</span>
                        </div>
                        <div v-for="material in getMaterialsByType('cover')" :key="material.id"
                            class="upload-progress-item">
                            <div class="progress-info">
                                <span class="material-name">{{ material.name }}</span>
                                <span class="material-status" :class="material.status">
                                    {{ getMaterialStatusText(material.status) }}
                                </span>
                            </div>
                            <el-progress :percentage="material.progress" :stroke-width="8"
                                :status="material.status === 'error' ? 'exception' : (material.status === 'success' ? 'success' : null)">
                            </el-progress>
                            <div class="progress-detail" v-if="material.detail">{{ material.detail }}</div>
                        </div>
                    </div>

                    <!-- 视频组 -->
                    <div v-if="getMaterialsByType('video').length > 0" class="progress-type-group">
                        <div class="type-group-title">
                            <i class="el-icon-video-camera"></i> 视频素材
                            <span class="type-stats">{{ getTypeSuccessCount('video') }}/{{
                                getMaterialsByType('video').length }}</span>
                        </div>
                        <div v-for="material in getMaterialsByType('video')" :key="material.id"
                            class="upload-progress-item">
                            <div class="progress-info">
                                <span class="material-name">{{ material.name }}</span>
                                <span class="material-status" :class="material.status">
                                    {{ getMaterialStatusText(material.status) }}
                                </span>
                            </div>
                            <el-progress :percentage="material.progress" :stroke-width="8"
                                :status="material.status === 'error' ? 'exception' : (material.status === 'success' ? 'success' : null)">
                            </el-progress>
                            <div class="progress-detail" v-if="material.detail">{{ material.detail }}</div>
                        </div>
                    </div>
                </div>

                <el-tabs v-model="activeTab" type="card">
                    <!-- 品牌LOGO -->
                    <el-tab-pane label="品牌LOGO" name="private">
                        <div class="image-header">
                            <div class="image-count">
                                <i class="el-icon-picture"></i> LOGO数量: {{ txfileList.length }}
                            </div>
                            <div>
                                <el-button v-if="txfileList.length > 0" size="mini" type="danger" icon="el-icon-delete"
                                    @click="clearMaterial('logo')">
                                    清空
                                </el-button>
                            </div>
                        </div>
                        <el-upload ref="uploadLogo" multiple action="#" list-type="picture-card" :file-list="txfileList"
                            :on-change="txhandleFileChange" :auto-upload="false" accept="image/*">
                            <div slot="trigger" class="upload-trigger">
                                <el-tag>选择品牌LOGO</el-tag>
                            </div>
                            <template slot="file" slot-scope="{ file }">
                                <div class="file-item">
                                    <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                                    <span class="el-upload-list__item-actions">
                                        <span class="el-upload-list__item-preview"
                                            @click.stop="handlePictureCardPreview(file)">
                                            <i class="el-icon-zoom-in"></i>
                                        </span>
                                        <span class="el-upload-list__item-delete" @click.stop="handleRemove(file)">
                                            <i class="el-icon-delete"></i>
                                        </span>
                                    </span>
                                </div>
                            </template>
                        </el-upload>
                    </el-tab-pane>

                    <!-- 图片素材 -->
                    <el-tab-pane label="图片" name="img">
                        <div class="image-header">
                            <div class="image-count">
                                <i class="el-icon-picture"></i> 图片数量: {{ tpfileList.length }}
                            </div>
                            <div>
                                <el-button v-if="tpfileList.length > 0" size="mini" type="danger" icon="el-icon-delete"
                                    @click="clearMaterial('image')">
                                    清空全部
                                </el-button>
                            </div>
                        </div>
                        <el-upload ref="uploadImage" multiple action="#" list-type="picture-card" :file-list="tpfileList"
                            :on-change="tphandleFileChange" :auto-upload="false" accept="image/*">
                            <div slot="trigger" class="upload-trigger">
                                <el-tag>选择图片素材</el-tag>
                            </div>
                            <template slot="file" slot-scope="{ file }">
                                <div class="file-item">
                                    <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                                    <span class="el-upload-list__item-actions">
                                        <span class="el-upload-list__item-preview"
                                            @click.stop="tphandlePictureCardPreview(file)">
                                            <i class="el-icon-zoom-in"></i>
                                        </span>
                                        <span class="el-upload-list__item-delete" @click.stop="tphandleRemove(file)">
                                            <i class="el-icon-delete"></i>
                                        </span>
                                    </span>
                                </div>
                            </template>
                        </el-upload>
                    </el-tab-pane>


                    <!-- 视频封面 -->
                    <el-tab-pane label="视频封面" name="imgvideo">
                        <div class="image-header">
                            <div class="image-count">
                                <i class="el-icon-picture"></i> 封面图片数量: {{ videotpfileList.length }}
                            </div>
                            <div>
                                <el-button v-if="videotpfileList.length > 0" size="mini" type="danger" icon="el-icon-delete"
                                    @click="clearMaterial('cover')">
                                    清空全部
                                </el-button>
                            </div>
                        </div>

                        <div class="media-gallery">
                            <div class="media-item" v-for="(file, index) in videotpfileList"
                                :key="file.uid || file.name || index">
                                <div class="media-content">
                                    <img :src="file.url" alt="" class="media-thumbnail">
                                    <div class="file-info">
                                        <span class="file-name">{{ file.name }}</span>
                                    </div>
                                    <div class="media-actions">
                                        <span class="action-preview" @click.stop="videotphandlePictureCardPreview(file)">
                                            <i class="el-icon-zoom-in"></i>
                                        </span>
                                        <span class="action-replace" @click.stop="handleReplaceFile(file, index)">
                                            <i class="el-icon-refresh"></i>
                                        </span>
                                        <span class="action-delete" @click.stop="videotphandleRemove(file)">
                                            <i class="el-icon-close"></i>
                                        </span>
                                    </div>
                                    <div class="position-index">第{{ index + 1 }}个</div>
                                </div>
                            </div>
                        </div>

                        <el-upload ref="uploadCover" multiple action="#" list-type="picture-card"
                            :file-list="videotpfileList" :on-change="videotphandleFileChange" :show-file-list="false"
                            :auto-upload="false" accept="image/*">
                            <div slot="trigger" class="upload-trigger">
                                <el-tag>选择封面图片</el-tag>
                            </div>
                        </el-upload>
                    </el-tab-pane>

                    <!-- 视频素材 -->
                    <el-tab-pane label="视频" name="video">
                        <div class="image-header">
                            <div class="image-count">
                                <i class="el-icon-video-play"></i> 视频数量: {{ videofileList.length }}
                                <span style="margin-left: 10px;">已选: {{ selectedCount }}</span>
                            </div>
                            <div style="display: flex; gap: 10px;">
                                <div class="auto-cover-option">
                                    <!-- <el-checkbox v-model="autoGenerateCover" @change="handleAutoCoverChange">
                                        自动生成视频封面
                                    </el-checkbox> -->
                                    <el-tooltip content="开启后上传视频时会自动提取第一帧作为封面" placement="top">
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </div>
                                <!-- 新增：批量提取封面按钮 -->
                                <el-button type="success" plain icon="el-icon-camera" @click="manualExtractFrames"
                                    size="mini">
                                    批量提取封面
                                </el-button>
                                <el-button type="danger" icon="el-icon-delete" :disabled="selectedCount === 0"
                                    @click="deleteSelected" size="mini">
                                    删除选中
                                </el-button>
                                <el-button type="primary" plain icon="el-icon-delete" @click="clearMaterial('video')"
                                    size="mini">
                                    清空全部
                                </el-button>
                            </div>
                        </div>

                        <el-upload class="upload-wrapper" drag action="#" :auto-upload="false" :multiple="true"
                            ref="uploadVideo" :file-list="videofileList" :on-change="videohandleFileChange"
                            :show-file-list="false" accept="video/*">
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">
                                将文件拖到此处，或<em>点击上传</em>
                            </div>
                            <div class="el-upload__tip" slot="tip">支持 MP4 格式</div>
                        </el-upload>

                        <div class="video-list">
                            <div class="video-item" v-for="(file, index) in videofileList"
                                :key="file.uid || file.name || index">
                                <div class="video-content">
                                    <div class="selection-checkbox">
                                        <input type="checkbox" :checked="file.selected" @click.stop="toggleSelect(file)">
                                    </div>
                                    <span class="video-title">{{ file.name }}</span>
                                    <div class="video-thumbnail">
                                        <video :src="file.url" controls></video>
                                    </div>
                                    <el-button type="text" icon="el-icon-delete" @click="handleRemove2(file)"
                                        class="delete-btn"></el-button>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="creativeMaterials = false">关 闭</el-button>
            </span>
        </el-dialog>

        <!-- 图片预览对话框 -->
        <el-dialog :visible.sync="dialogVisible" width="70%">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>

        <!-- 模板管理对话框 -->
        <el-dialog title="模板管理" :visible.sync="templateDialogVisible" width="70%" @close="handleDialogClose">
            <el-form :inline="true" :model="queryParams" class="query-form">
                <el-form-item label="模板名称">
                    <el-input v-model="queryParams.model_name" placeholder="请输入模板名称" clearable
                        @keyup.enter.native="handletemplateQuery"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handletemplateQuery">查询</el-button>
                    <el-button @click="resettemplateQuery">重置</el-button>
                </el-form-item>
            </el-form>

            <el-table :data="templateList" border stripe style="width: 100%">
                <el-table-column prop="model_name" label="模板名称"></el-table-column>
                <el-table-column label="操作" width="200" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" type="danger" @click="handletemplateDelete(scope.row)">删除</el-button>
                        <el-button size="mini" type="success" @click="templateInfoChange(scope.row)">选中录入</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination @size-change="handleSizeChange" @current-change="handletamplateCurrentChange"
                :current-page="queryParams.page_no" :page-sizes="[10, 20, 50, 100]" :page-size="queryParams.page_size"
                layout="total, sizes, prev, pager, next, jumper" :total="templatetotal" class="pagination">
            </el-pagination>

            <div slot="footer" class="dialog-footer">
                <el-button @click="templateDialogVisible = false">取消</el-button>
            </div>
        </el-dialog>

        <!-- 定时任务设置对话框 -->
        <el-dialog title="设置定时计划" :visible.sync="timerDialogVisible" width="500px" center @close="handleTimerCancel">
            <el-form :model="timerForm" label-width="80px" ref="timerFormRef" :rules="timerRules">
                <el-form-item label="计划名称" prop="name">
                    <el-input v-model="timerForm.name" placeholder="请输入定时计划名称" clearable>
                    </el-input>
                </el-form-item>
                <el-form-item label="执行时间" prop="time">
                    <el-date-picker v-model="timerForm.time" type="datetime" placeholder="选择执行时间"
                        value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm" :picker-options="timerPickerOptions">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleTimerCancel">取 消</el-button>
                <el-button type="primary" @click="handleTimerConfirm">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 定时任务管理对话框 -->
        <el-dialog title="定时任务管理" :visible.sync="dsDialogVisible" width="70%" @close="handleDialogClose">
            <el-form :inline="true" :model="dsqueryParams" class="query-form">
                <el-form-item label="定时任务名称">
                    <el-input v-model="dsqueryParams.taskName" placeholder="请输入任务名称" clearable
                        @keyup.enter.native="dshandletemplateQuery"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="dshandletemplateQuery">查询</el-button>
                </el-form-item>
            </el-form>

            <el-table :data="dstemplateList" border stripe style="width: 100%">
                <el-table-column prop="id" label="任务ID"></el-table-column>
                <el-table-column prop="taskName" label="任务名称"></el-table-column>
                <el-table-column prop="executeTime" label="执行时间" width="180"></el-table-column>
                <el-table-column prop="status" label="任务状态" width="120">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status === 0">待执行</span>
                        <span v-else-if="scope.row.status === 1">执行中</span>
                        <span v-else-if="scope.row.status === 2">成功</span>
                        <span v-else-if="scope.row.status === 3">失败</span>
                        <span v-else>未知</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" type="danger" @click="dshandletemplateDelete(scope.row)">删除</el-button>
                        <el-button size="mini" type="success" @click="templatedsChange(scope.row)">编辑</el-button>
                        <el-button size="mini" type="success" @click="templatedslogChange(scope.row)">查看日志</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination @size-change="handledsSizeChange" @current-change="handledstamplateCurrentChange"
                :current-page="dsqueryParams.current" :page-sizes="[10, 20, 50, 100]" :page-size="dsqueryParams.size"
                layout="total, sizes, prev, pager, next, jumper" :total="dstemplatetotal" class="pagination">
            </el-pagination>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dsDialogVisible = false">取消</el-button>
            </div>
        </el-dialog>

        <!-- 编辑定时任务对话框 -->
        <el-dialog title="编辑定时任务" :visible.sync="dschangeDialogVisible" width="500px" center
            @close="dschangeHandleDialogClose">
            <el-form :model="dschangeForm" :rules="dschangeRules" ref="dschangeFormRef" label-width="80px">
                <el-form-item label="任务名称" prop="dschangeTaskName">
                    <el-input v-model="dschangeForm.dschangeTaskName" placeholder="请输入任务名称" clearable maxlength="50"
                        show-word-limit>
                    </el-input>
                </el-form-item>
                <el-form-item label="执行时间" prop="dschangeExecuteTime">
                    <el-date-picker v-model="dschangeForm.dschangeExecuteTime" type="datetime" placeholder="选择执行时间"
                        value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm" :picker-options="dschangePickerOptions"
                        style="width: 100%">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="当前状态">
                    <el-tag effect="plain">
                        <span v-if="dschangeForm.dschangeStatus === 0">待执行</span>
                        <span v-else-if="dschangeForm.dschangeStatus === 1">执行中</span>
                        <span v-else-if="dschangeForm.dschangeStatus === 2">成功</span>
                        <span v-else-if="dschangeForm.dschangeStatus === 3">失败</span>
                        <span v-else>未知</span>
                    </el-tag>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dschangeDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dschangeHandleSubmit" :loading="dschangeLoading">
                    确 定
                </el-button>
            </span>
        </el-dialog>

        <!-- 任务执行列表对话框 -->
        <el-dialog title="任务执行列表" :visible.sync="opencreatedanyuanliststatus" width="1200px" :close-on-click-modal="false">
            <div class="task-list-container">
                <div v-for="task in tasks" :key="task.id" class="task-detail-card">
                    <div class="task-detail-header">
                        <div class="task-detail-title">
                            <el-tag size="small" :type="getTaskStatusType(task.status)" class="task-tag">
                                {{ getTaskStatusText(task.status) }}
                            </el-tag>
                            <span class="task-name">{{ task.name }}</span>
                        </div>
                        <div class="task-detail-meta">
                            <span class="task-progress">{{ task.currentIndex }}/{{ task.totalItems }}</span>
                            <span class="task-time">{{ task.createdAt }}</span>
                            <div class="task-actions">
                                <el-button v-if="task.status === 'running'" @click="stopTask(task.id)" size="mini"
                                    type="warning" plain>
                                    停止
                                </el-button>
                                <el-button v-if="task.status === 'running'" @click="pauseTask(task.id)" size="mini"
                                    type="info" plain>
                                    暂停
                                </el-button>
                                <el-button v-if="task.status === 'paused'" @click="resumeTask(task.id)" size="mini"
                                    type="success" plain>
                                    继续
                                </el-button>
                                <el-button v-if="['stopped', 'failed', 'done', 'error'].includes(task.status)"
                                    @click="deleteTask(task.id)" size="mini" type="danger" plain>
                                    删除
                                </el-button>
                            </div>
                        </div>
                    </div>

                    <!-- 失败账户汇总区域 -->
                    <div v-if="getFailedAccounts(task).length > 0" class="failed-accounts-summary">
                        <div class="summary-header">
                            <div class="summary-title">
                                <i class="el-icon-warning" style="color: #f56c6c;"></i>
                                失败账户汇总
                                <el-tag type="danger" size="small" style="margin-left: 8px;">{{
                                    getFailedAccounts(task).length }}个</el-tag>
                            </div>
                            <div class="summary-actions">
                                <el-button type="warning" size="small" icon="el-icon-refresh-right"
                                    @click="retryAllFailedAccounts(task.id)" :loading="task.retryingAll">
                                    一键重试所有失败账户
                                </el-button>
                            </div>
                        </div>
                        <div class="failed-accounts-list">
                            <div v-for="(failInfo, idx) in getFailedAccounts(task)" :key="idx" class="failed-account-item">
                                <div class="fail-account-info">
                                    <span class="fail-account-name">{{ failInfo.user.accountName }}</span>
                                    <el-tag size="mini"
                                        :type="failInfo.user.status === 'material_failed' ? 'danger' : 'warning'">
                                        {{ failInfo.user.status === 'material_failed' ? '素材失败' : '搭建失败' }}
                                    </el-tag>
                                    <span class="fail-reason">{{ failInfo.errorDetail || failInfo.user.steps[0].detail ||
                                        '未知错误' }}</span>
                                </div>
                                <el-button type="primary" size="mini" plain
                                    @click="retryFailedAccount(task.id, failInfo.userIndex)"
                                    :loading="failInfo.user.retrying">
                                    重试
                                </el-button>
                            </div>
                        </div>
                    </div>

                    <div class="user-tasks-container">
                        <div v-for="(user, userIndex) in task.userDetails" :key="userIndex" class="user-task-detail">
                            <div class="user-header">
                                <div class="user-info">
                                    <strong class="user-account-name">{{ user.accountName }}</strong>
                                    <span class="user-campaign">({{ user.campaignName }})</span>
                                    <el-tag size="mini" :type="getUserStatusType(user.status)" class="user-status-tag">
                                        {{ getUserStatusText(user.status) }}
                                    </el-tag>
                                    <!-- 添加重试按钮：当账户状态为素材上传失败时显示 -->
                                    <el-button v-if="user.status === 'material_failed'"
                                        @click="retryFailedAccount(task.id, userIndex)" size="mini" type="warning" plain
                                        icon="el-icon-refresh-right" :loading="user.retrying">
                                        重试
                                    </el-button>
                                </div>
                                <div class="user-stats" v-if="user.groupDetails">
                                    <span>广告组: {{ getGroupSuccessCount(user.groupDetails) }}/{{ user.groupDetails.length
                                    }}</span>
                                    <span style="margin-left: 10px;">创意: {{ getCreativeTotalCount(user) }}</span>
                                </div>
                            </div>

                            <div class="user-steps-timeline">
                                <div v-for="(step, stepIndex) in user.steps" :key="stepIndex"
                                    :class="['user-timeline-item', `status-${step.status}`]">
                                    <div class="user-timeline-marker">
                                        <div :class="['user-marker-icon', step.status]">
                                            <i v-if="step.status === 'wait'" class="el-icon-time"></i>
                                            <i v-else-if="step.status === 'doing'" class="el-icon-loading"></i>
                                            <i v-else-if="step.status === 'success'" class="el-icon-success"></i>
                                            <i v-else-if="step.status === 'error'" class="el-icon-error"></i>
                                        </div>
                                        <div class="user-timeline-connector" v-if="stepIndex < user.steps.length - 1"></div>
                                    </div>
                                    <div class="user-timeline-content">
                                        <div class="user-step-header">
                                            <span class="user-step-name">{{ step.name }}</span>
                                            <el-tag size="mini" :type="getStepStatusType(step.status)"
                                                class="user-step-status">
                                                {{ getStepStatusText(step.status) }}
                                            </el-tag>
                                        </div>
                                        <div class="user-step-detail" v-if="step.detail">{{ step.detail }}</div>
                                        <div v-if="step.name === '上传素材' && step.status === 'doing' && step.progress"
                                            class="step-progress">
                                            <el-progress :percentage="step.progress" :stroke-width="4"
                                                :show-text="true"></el-progress>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="user.groupDetails && user.groupDetails.length" class="group-list">
                                <div class="group-title" @click="toggleGroupExpand(user, userIndex)">
                                    <span>
                                        <i :class="user.groupExpanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
                                        广告组列表 ({{ user.groupDetails.length }}组)
                                    </span>
                                    <el-tag size="mini" type="info">
                                        成功: {{ getGroupSuccessCount(user.groupDetails) }} /
                                        失败: {{ getGroupFailCount(user.groupDetails) }}
                                    </el-tag>
                                </div>

                                <div v-show="user.groupExpanded" class="group-items">
                                    <div v-for="(group, groupIndex) in user.groupDetails" :key="groupIndex"
                                        :class="['group-item', `group-status-${group.status}`]">
                                        <div class="group-header" @click="toggleCreativeExpand(group, groupIndex)">
                                            <div class="group-name-wrapper">
                                                <i
                                                    :class="group.creativeExpanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
                                                <span class="group-name">{{ group.name }}</span>
                                            </div>
                                            <div class="group-status-wrapper">
                                                <el-tag size="mini" :type="getGroupStatusType(group.status)"
                                                    class="group-status">
                                                    {{ getGroupStatusText(group.status) }}
                                                </el-tag>
                                                <span class="group-id" v-if="group.detail">{{ group.detail }}</span>
                                            </div>
                                        </div>

                                        <div v-if="group.creatives && group.creatives.length" class="creative-list"
                                            v-show="group.creativeExpanded">
                                            <div class="creative-title">
                                                <span>创意列表 ({{ group.creatives.length }}条)</span>
                                                <el-tag size="mini" type="info">
                                                    成功: {{ getCreativeSuccessCount(group.creatives) }} /
                                                    失败: {{ getCreativeFailCount(group.creatives) }}
                                                </el-tag>
                                            </div>
                                            <div v-for="(creative, creativeIndex) in group.creatives" :key="creativeIndex"
                                                :class="['creative-item', `creative-status-${creative.status}`]">
                                                <div class="creative-header">
                                                    <span class="creative-id">创意 #{{ creative.id }}</span>
                                                    <el-tag size="mini" :type="getCreativeStatusType(creative.status)"
                                                        class="creative-status">
                                                        {{ getCreativeStatusText(creative.status) }}
                                                    </el-tag>
                                                </div>
                                                <div class="creative-steps">
                                                    <div v-for="(step, stepIndex) in creative.steps" :key="stepIndex"
                                                        :class="['creative-step', `step-${step.status}`]">
                                                        <div class="creative-step-marker">
                                                            <div :class="['creative-marker', step.status]">
                                                                <i v-if="step.status === 'wait'" class="el-icon-time"></i>
                                                                <i v-else-if="step.status === 'doing'"
                                                                    class="el-icon-loading"></i>
                                                                <i v-else-if="step.status === 'success'"
                                                                    class="el-icon-success"></i>
                                                                <i v-else-if="step.status === 'error'"
                                                                    class="el-icon-error"></i>
                                                            </div>
                                                        </div>
                                                        <div class="creative-step-content">
                                                            <span class="creative-step-name">{{ step.name }}</span>
                                                            <span class="creative-step-detail" v-if="step.detail">{{
                                                                step.detail }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="tasks.length === 0" class="empty-state">
                    <el-empty description="暂无执行任务" />
                </div>
            </div>
        </el-dialog>

        <!-- 执行日志详情对话框 -->
        <el-dialog title="执行日志详情" :visible.sync="dslogDialogVisible" width="900px" top="5vh" @close="dslogHandleClose">
            <div v-if="dslogLoading" style="text-align: center; padding: 40px;">
                <i class="el-icon-loading" style="font-size: 24px;"></i>
                <p style="margin-top: 16px; color: #909399;">日志加载中...</p>
            </div>

            <div v-else>
                <el-table :data="dslogCurrentData" border stripe style="width: 100%" height="400">
                    <el-table-column prop="idsname" label="账户" width="120" :formatter="formatAccountName">
                    </el-table-column>
                    <el-table-column label="计划" width="200">
                        <template slot-scope="scope">
                            <el-tooltip :content="scope.row.planMsg || '等待执行'" placement="top">
                                <div :class="getStatusClass(scope.row.planMsg)" class="message-content multi-line-ellipsis">
                                    {{ scope.row.planMsg || '等待执行' }}
                                </div>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column label="广告组" width="200">
                        <template slot-scope="scope">
                            <el-tooltip :content="scope.row.groupMsg || '等待执行'" placement="top">
                                <div :class="getStatusClass(scope.row.groupMsg)"
                                    class="message-content multi-line-ellipsis">
                                    {{ scope.row.groupMsg || '等待执行' }}
                                </div>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column label="创意" width="200">
                        <template slot-scope="scope">
                            <el-tooltip :content="scope.row.createMsg || '等待执行'" placement="top">
                                <div :class="getStatusClass(scope.row.createMsg)"
                                    class="message-content multi-line-ellipsis">
                                    {{ scope.row.createMsg || '等待执行' }}
                                </div>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column label="总体状态" width="100" align="center">
                        <template slot-scope="scope">
                            <el-tag :type="getOverallStatusType(scope.row)" effect="plain" size="medium">
                                {{ getOverallStatus(scope.row) }}
                            </el-tag>
                        </template>
                    </el-table-column>
                </el-table>

                <div style="margin-top: 15px; padding: 10px; background: #f5f7fa; border-radius: 4px; text-align: center;">
                    <span>总计: {{ dslogCurrentData.length }} 个账户 | </span>
                    <span style="color: #67c23a;">成功: {{ getSuccessCount() }} | </span>
                    <span style="color: #f56c6c;">失败: {{ getErrorCount() }}</span>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dslogDialogVisible = false">关 闭</el-button>
                <el-button type="primary" @click="dslogExportLog" v-if="dslogCurrentData.length > 0">导出日志</el-button>
            </span>
        </el-dialog>

        <!-- 底部操作栏 -->
        <div class="adgroup-footer">
            <el-button type="primary" @click="templateSave">
                保存模板
            </el-button>
            <el-button type="primary" @click="startBatchTasks" :loading="isLoading">
                {{ isLoading ? '处理中...' : '开始搭建' }}
            </el-button>
            <el-button type="primary" @click="createdsdanyuan" :loading="isdsLoading">
                {{ isdsLoading ? '处理中...' : '创建定时搭建' }}
            </el-button>
            <el-button type="primary" @click="opencreatedanyuanlist" v-if="tasks.length > 0">
                查看任务进度
            </el-button>
            <div style="width: 300px;margin-left: 40px;" v-if="showProgress">
                <el-progress :percentage="uploadPercent" :text-inside="false" :color="customColors" :stroke-width="4" />
            </div>
        </div>
    </el-container>
</template>

<script>
import axios from "axios";
import sha1 from 'js-sha1';
import { Base64 } from 'js-base64';
import qs from 'qs';

export default {
    data() {
        return {
            // ========== 基础配置 ==========
            autoGenerateCover: true,
            customColors: [
                { color: '#f56c6c', percentage: 20 },
                { color: '#e6a23c', percentage: 40 },
                { color: '#5cb87a', percentage: 60 },
                { color: '#1989fa', percentage: 80 },
                { color: '#6f7ad3', percentage: 100 }
            ],
            showProgress: false,
            uploadPercent: 0,
            isLoading: false,
            countdown: 0,
            countdownTimer: null,
            lastClickTime: 0,

            // ========== 任务管理 ==========
            tasks: [],
            taskIdCounter: 1,
            taskControllers: new Map(),
            isTaskStopped: new Map(),
            isTaskPaused: new Map(),
            opencreatedanyuanliststatus: false,

            // ========== 并发控制 ==========
            materialConcurrentLimit: 10, // 素材上传并发数10个
            accountDelay: 1000,           // 账户间隔1秒
            groupDelay: 500,              // 广告组间隔0.5秒
            creativeDelay: 300,           // 创意间隔0.3秒

            // ========== 素材上传进度管理 ==========
            uploadingMaterials: [],        // 正在上传的素材列表
            materialUploadIdCounter: 1,    // 素材上传ID计数器

            // ========== 用户数据 ==========
            userId: '',
            ids_list: [],
            listname: [],
            btgjc: "",
            two: '',
            towName: '',

            // ========== 步骤条 ==========
            activeStep: 0,
            steps: [
                { name: '广告计划', status: 'wait', detail: '' },
                { name: '广告组', status: 'wait', detail: '' },
                { name: '广告创意', status: 'wait', detail: '' }
            ],

            // ========== 定时任务 ==========
            dingshiobj: {
                ids_list: [],
                timerName: "",
                executeTime: "",
                data1: {},
                data2: {},
                data3: [],
            },
            timerDialogVisible: false,
            timerForm: {
                name: '',
                time: ''
            },
            timerResolve: null,
            timerPickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now();
                },
                shortcuts: [{
                    text: '1小时后',
                    onClick(picker) {
                        const date = new Date();
                        date.setHours(date.getHours() + 1);
                        picker.$emit('pick', date);
                    }
                }, {
                    text: '明天此时',
                    onClick(picker) {
                        const date = new Date();
                        date.setDate(date.getDate() + 1);
                        picker.$emit('pick', date);
                    }
                }, {
                    text: '3天后',
                    onClick(picker) {
                        const date = new Date();
                        date.setDate(date.getDate() + 3);
                        picker.$emit('pick', date);
                    }
                }]
            },
            timerRules: {
                name: [
                    { required: true, message: '请输入任务名称', trigger: 'blur' },
                    { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
                ],
                time: [
                    { required: true, message: '请选择执行时间', trigger: 'change' }
                ]
            },
            isdsLoading: false,

            // ========== 任务日志 ==========
            dslogDialogVisible: false,
            dslogLoading: false,
            dslogCurrentData: [],

            // ========== 任务管理 ==========
            dsDialogVisible: false,
            dstemplateList: [],
            dstemplatetotal: 0,
            dsqueryParams: {
                taskName: '',
                current: 1,
                size: 10
            },

            // ========== 模板管理 ==========
            templateDialogVisible: false,
            templateList: [],
            templatetotal: 0,
            queryParams: {
                model_name: '',
                page_no: 1,
                page_size: 10
            },

            // ========== 编辑定时任务 ==========
            dschangeDialogVisible: false,
            dschangeLoading: false,
            dschangeCurrentId: null,
            dschangeCurrentStatus: 0,
            dschangeForm: {
                dschangeTaskName: '',
                dschangeExecuteTime: '',
                dschangeStatus: 0
            },
            dschangeRules: {
                dschangeTaskName: [
                    { required: true, message: '请输入任务名称', trigger: 'blur' },
                    { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
                ],
                dschangeExecuteTime: [
                    { required: true, message: '请选择执行时间', trigger: 'change' }
                ]
            },
            dschangePickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                },
                shortcuts: [{
                    text: '1小时后',
                    onClick(picker) {
                        const date = new Date();
                        date.setHours(date.getHours() + 1);
                        picker.$emit('pick', date);
                    }
                }, {
                    text: '明天此时',
                    onClick(picker) {
                        const date = new Date();
                        date.setDate(date.getDate() + 1);
                        picker.$emit('pick', date);
                    }
                }, {
                    text: '3天后',
                    onClick(picker) {
                        const date = new Date();
                        date.setDate(date.getDate() + 3);
                        picker.$emit('pick', date);
                    }
                }]
            },

            // ========== 表单数据 - 计划层级 ==========
            form: {
                extension_type: 1,
                delivery_mode: 0,
                dayLimit: 0,
                planName: '',
                dayBudget: '',
                switchPlan: 1,
                campaign_name: '',
                adgroupNumber: 1,
                useLatestPlan: false
            },

            // ========== 表单数据 - 广告组层级 ==========
            form2: {
                templateName: '',
                deepOcpcTypeoptions: [],
                Deeplinkstatus: 0,
                linkDeskFlag: 1,
                extensionFlow: '2',
                flowScene: 13,
                pageTypelabel: "",
                targetROI: "",
                flowScene_list: [
                    {
                        value: "2",
                        list: [{ value: "13", label: "展示优选" }, { value: "6", label: "信息流" }]
                    }, {
                        value: "3",
                        list: [
                            { value: "12", label: "联盟通投" },
                            { value: "7", label: "Banner" },
                            { value: "8", label: "开屏" },
                            { value: "9", label: "插屏" },
                            { value: "10", label: "原生" },
                            { value: "11", label: "激励视频" }
                        ]
                    }
                ],
                pageType: '',
                flowScene_choose_list: [],
                dpaProductType: '0',
                Deeplinktype: 0,
                beginTime: [],
                billingType: '2',
                price: null,
                defaultSecondStage: 1,
                ocpcType: null,
                ocpcPrice: null,
                ocpcTypeoptions: [],
                deepOcpcType: null,
                deepOcpcPrice: 0,
                deepOcpcStatus: false,
                plan: '',
                adgroup_name: '',
            },

            // ========== 表单数据 - 创意层级 ==========
            form3: {
                buttonTxt: "",
                brandName: "",
                title: [],
                number: 1,
                number2: 1,
                type: null
            },

            // ========== 选项配置 ==========
            extensionType_goal_group: [
                { value: 1, label: "网页推广" },
                { value: 2, label: "应用推广-应用下载" },
                { value: 6, label: "应用推广-应用调起" },
                { value: 3, label: "快应用推广" },
                { value: 7, label: "小程序推广" },
            ],
            ocpcTypeoptions: [
                { value: "14", label: "deeplink拉活", index: 1 },
                { value: "16", label: "deeplink回传激活", index: 1 },
                { value: "17", label: "deeplink回传注册", index: 1 },
                { value: "18", label: "deeplink应用付费", index: 1 },
                { value: "21", label: "deeplink应用内下单", index: 1 },
                { value: "6", label: "线索提交", index: 1 },
                { value: "2", label: "激活", index: 2 },
                { value: "7", label: "注册", index: 2 },
                { value: "9", label: "应用付费", index: 2 },
                { value: "8", label: "回传激活", index: 2 },
                { value: "1", label: "下载", index: 2 },
                { value: "22", label: "快应用/小程序付费", index: 3 },
                { value: "32", label: "快应用关键行为", index: 3 },
                { value: "47", label: "快应用变现ROI1", index: 3 },
                { value: "51", label: "快游戏付费ROI1", index: 3 },
            ],
            pageType_list: [
                { value: "0", label: "自定义落地页" },
                { value: "4", label: "萤火虫建站" },
                { value: "11", label: "萤火虫应用模板下载页" },
                { value: "7", label: "API线索投放" },
                { value: "6", label: "JS线索投放" },
                { value: "9", label: "应用落地页" }
            ],
            buttonTxtOptions: [
                { value: '打开', label: '打开' },
                { value: '下载', label: '下载' },
                { value: '去看看', label: '去看看' },
                { value: '了解详情', label: '了解详情' },
                { value: '参与活动', label: '参与活动' },
                { value: '领取优惠', label: '领取优惠' },
                { value: '立即打开', label: '立即打开' },
                { value: '立即下载', label: '立即下载' },
                { value: '立即查看', label: '立即查看' },
                { value: '立即体验', label: '立即体验' },
                { value: '立即申请', label: '立即申请' },
                { value: '获取报价', label: '获取报价' },
                { value: '立即领取', label: '立即领取' },
                { value: '点击咨询', label: '点击咨询' },
                { value: '下载抢购', label: '下载抢购' }
            ],
            // 衍生视频创意开关（仅信息流）
enableDeriveVideo: false,
// 选中的衍生模板ID列表（多选，用于横版大图）
selectedDeriveTemplates: [],
// 写死的模板列表
deriveTemplateList: [
  { id: 42, tplName: '雪花飘入' },
  { id: 41, tplName: '满屏泡泡' },
  { id: 31, tplName: '烟雾' },
  { id: 30, tplName: '扫描滤镜' },
  { id: 29, tplName: '雷达' },
  { id: 28, tplName: '下载气泡框' },
  { id: 27, tplName: '弹幕' },
  { id: 26, tplName: '大拇指点赞2' },
  { id: 25, tplName: '大拇指点赞' },
  { id: 24, tplName: '点赞' }
],

            // ========== 素材管理 ==========
            creativeMaterials: false,
            activeTab: 'private',

            txfileList: [],
            txfileCode: [],

            tpfileList: [],
            tpfileListcode: [],

            videotpfileList: [],
            videotpfileListcode: [],

            videofileList: [],
            videofileListcode: [],

            dialogImageUrl: '',
            dialogVisible: false,

            // ========== 创意样式 ==========
            selectedStyle: '63',
            material_type: '',
            selectedStylelabel: '',
            createTypedialog: false,
            styleCategories: [
                {
                    title: '视频类',
                    styles: [
                        { value: '63', label: '竖版视频', image: 'https://demo.nbweiou.cn/img/01.png', recommended: true },
                        { value: '60', label: '横版视频', image: 'https://demo.nbweiou.cn/img/02.png' }
                    ]
                },
                {
                    title: '图文类',
                    styles: [
                        { value: '20', label: '横版小图', image: 'https://demo.nbweiou.cn/img/05.png' },
                        { value: '1', label: '横版大图', image: 'https://demo.nbweiou.cn/img/06.png' },
                        { value: ' 50', label: '竖版大图', image: 'https://demo.nbweiou.cn/img/06.png' },
                        { value: '30', label: '横版组图', image: 'https://demo.nbweiou.cn/img/07.png' },
                        { value: '71', label: '图标大图', image: 'https://demo.nbweiou.cn/img/09.png' },
                        { value: '5', label: '开屏横图', image: 'https://demo.nbweiou.cn/img/10.png' },
                        { value: '34', label: '开屏竖图', image: 'https://demo.nbweiou.cn/img/10.png' }
                    ]
                }
            ],
            styleCategorieslist: [
                {
                    name: "默认",
                    value: 0,
                    list: [
                        {
                            title: '视频类',
                            styles: [
                                { value: '63', label: '竖版视频', image: 'https://demo.nbweiou.cn/img/01.png', recommended: true },
                                { value: '60', label: '横版视频', image: 'https://demo.nbweiou.cn/img/02.png' }
                            ]
                        },
                        {
                            title: '图文类',
                            styles: [
                                { value: '20', label: '横版小图', image: 'https://demo.nbweiou.cn/img/05.png' },
                                { value: '1', label: '横版大图', image: 'https://demo.nbweiou.cn/img/06.png' },
                                { value: ' 50', label: '竖版大图', image: 'https://demo.nbweiou.cn/img/06.png' },
                                { value: '30', label: '横版组图', image: 'https://demo.nbweiou.cn/img/07.png' },
                                { value: '71', label: '图标大图', image: 'https://demo.nbweiou.cn/img/09.png' }
                            ]
                        }
                    ]
                },
                {
                    name: "开屏",
                    value: 8,
                    list: [{
                        title: '视频类',
                        styles: [
                            { value: '63', label: '竖版视频', image: 'https://demo.nbweiou.cn/img/01.png', recommended: true },
                            { value: '60', label: '横版视频', image: 'https://demo.nbweiou.cn/img/02.png' }
                        ]
                    },
                    {
                        title: '图文类',
                        styles: [
                            { value: '5', label: '开屏横图', image: 'https://demo.nbweiou.cn/img/05.png' },
                            { value: '34', label: '开屏竖图', image: 'https://demo.nbweiou.cn/img/06.png' },
                            { value: '71', label: '图标大图', image: 'https://demo.nbweiou.cn/img/09.png' }
                        ]
                    }]
                },
                {
                    name: "原生",
                    value: 10,
                    list: [{
                        title: '视频类',
                        styles: [
                            { value: '63', label: '竖版视频', image: 'https://demo.nbweiou.cn/img/01.png', recommended: true },
                            { value: '60', label: '横版视频', image: 'https://demo.nbweiou.cn/img/02.png' }
                        ]
                    },
                    {
                        title: '图文类',
                        styles: [
                            { value: '20', label: '横版小图', image: 'https://demo.nbweiou.cn/img/05.png' },
                            { value: '1', label: '横版大图', image: 'https://demo.nbweiou.cn/img/06.png' },
                            { value: ' 50', label: '竖版大图', image: 'https://demo.nbweiou.cn/img/06.png' },
                            { value: '30', label: '横版组图', image: 'https://demo.nbweiou.cn/img/07.png' },
                            { value: '71', label: '图标大图', image: 'https://demo.nbweiou.cn/img/09.png' }
                        ]
                    }]
                }, {
                    name: "信息流",
                    value: 6,
                    list: [{
                        title: '视频类',
                        styles: [
                            { value: '63', label: '竖版视频', image: 'https://demo.nbweiou.cn/img/01.png', recommended: true },
                            { value: '60', label: '横版视频', image: 'https://demo.nbweiou.cn/img/02.png' }
                        ]
                    },
                    {
                        title: '图文类',
                        styles: [
                            { value: '20', label: '横版小图', image: 'https://demo.nbweiou.cn/img/05.png' },
                            { value: '1', label: '横版大图', image: 'https://demo.nbweiou.cn/img/06.png' },
                            { value: ' 50', label: '竖版大图', image: 'https://demo.nbweiou.cn/img/06.png' },
                            { value: '30', label: '横版组图', image: 'https://demo.nbweiou.cn/img/07.png' }
                        ]
                    }]
                },
                {
                    name: "不限",
                    value: 12,
                    list: [
                        {
                            title: '视频类',
                            styles: [
                                { value: '63', label: '竖版视频', image: 'https://demo.nbweiou.cn/img/01.png', recommended: true },
                                { value: '60', label: '横版视频', image: 'https://demo.nbweiou.cn/img/02.png' }
                            ]
                        },
                        {
                            title: '图文类',
                            styles: [
                                { value: '20', label: '横版小图', image: 'https://demo.nbweiou.cn/img/05.png' },
                                { value: '1', label: '横版大图', image: 'https://demo.nbweiou.cn/img/06.png' },
                                { value: ' 50', label: '竖版大图', image: 'https://demo.nbweiou.cn/img/06.png' },
                                { value: '30', label: '横版组图', image: 'https://demo.nbweiou.cn/img/07.png' },
                                { value: '71', label: '图标大图', image: 'https://demo.nbweiou.cn/img/09.png' },
                                { value: '5', label: '开屏横图', image: 'https://demo.nbweiou.cn/img/10.png' },
                                { value: '34', label: '开屏竖图', image: 'https://demo.nbweiou.cn/img/10.png' }
                            ]
                        }
                    ]
                }
            ],

            // ========== 文案管理 ==========
            titlesString: '',
            linesWithLimitError: [],

            // ========== 时段设置 ==========
            timeLimit: 1,
            startTime: null,
            endTime: null,
            errorMessage: '',
            timeSet: '',
            pickerOptions: {
                start: '00:00',
                step: '00:30',
                end: '24:00'
            },
            days: ["1", "2", "3", "4", "5", "6", "7"],

            // ========== 其他配置 ==========
            mixminvalue: false,
            mixminvaluelate: '轮询',
            isoldgroupprice: false,
            parsestatus: false,
            currentIndeximg: 0,
            currentIndexvideo: 0,
            currentIndextext: 0,
            copycurrentIndextext: 0,
            replacingIndex: null,

            // ========== 账户素材缓存 ==========
            accountMaterialCache: new Map(),
            materialGlobalIndex: {
                logo: 0,      // LOGO全局索引
                image: 0,     // 图片全局索引
                video: 0,     // 视频全局索引
                cover: 0,     // 封面全局索引
                text: 0       // 文案全局索引
            },
            materialTotalCount: {
                logo: 0,
                image: 0,
                video: 0,
                cover: 0,
                text: 0
            },
            currentTaskMaterialStartIndex: null,
            materialFileList: {
                logo: [],      // LOGO原始文件列表
                image: [],     // 图片原始文件列表
                cover: [],     // 封面原始文件列表
                video: []      // 视频原始文件列表
            },
        };
    },

    computed: {
        getMaterialsByType() {
            return (type) => {
                return this.uploadingMaterials.filter(m => m.type === type);
            };
        },

        // 获取某类型成功数量
        getTypeSuccessCount() {
            return (type) => {
                return this.uploadingMaterials.filter(m => m.type === type && m.status === 'success').length;
            };
        },
        hasMaterials() {
            return this.txfileList.length > 0 || this.tpfileList.length > 0 ||
                this.videotpfileList.length > 0 || this.videofileList.length > 0;
        },

        hasMultipleMaterials() {
            let count = 0;
            if (this.txfileList.length > 0) count++;
            if (this.tpfileList.length > 0) count++;
            if (this.videotpfileList.length > 0) count++;
            if (this.videofileList.length > 0) count++;
            return count > 1;
        },

        selectedCount() {
            return this.videofileList.filter(file => file.selected).length;
        },

        totalAdGroups() {
            return this.ids_list.length * (parseInt(this.form.adgroupNumber) || 1);
        },

        totalCreatives() {
            return this.totalAdGroups * (parseInt(this.form3.number) || 1);
        },

        // 已完成上传数量
        completedUploadCount() {
            return this.uploadingMaterials.filter(m => m.status === 'success' || m.status === 'error').length;
        }
    },

    created() {
        this.loadInitialData();
    },

    methods: {
        // ========== 初始化方法 ==========
        loadInitialData() {
            axios.get('https://test.nbweiou.cn/api/oppo/find_list_name').then(res => {
                this.listname = res.data;
            });
            this.extensionTypeChange(this.form.extension_type);
            this.changeextensionFlow(2);
        },

        // ========== 素材上传进度管理 ==========
        addUploadingMaterial(name, type) {
            const id = this.materialUploadIdCounter++;
            const material = {
                id,
                name,
                type,
                status: 'pending', // pending, uploading, success, error
                progress: 0,
                detail: '等待上传'
            };
            this.uploadingMaterials.push(material);
            return id;
        },

        updateUploadProgress(id, progress, status, detail) {
            const material = this.uploadingMaterials.find(m => m.id === id);
            if (material) {
                if (progress !== undefined) material.progress = progress;
                if (status) material.status = status;
                if (detail) material.detail = detail;
            }
        },

        removeUploadingMaterial(id) {
            const index = this.uploadingMaterials.findIndex(m => m.id === id);
            if (index !== -1) {
                this.uploadingMaterials.splice(index, 1);
            }
        },

        getMaterialStatusText(status) {
            const map = {
                'pending': '等待中',
                'uploading': '上传中',
                'success': '✓ 成功',
                'error': '✗ 失败'
            };
            return map[status] || status;
        },

        // ========== 素材上传（并发10个） ==========
        async uploadMaterialsConcurrent(fileList, type, config, ownerId, onProgress) {
            if (!fileList || fileList.length === 0) return [];

            const results = [];
            const totalFiles = fileList.length;
            let completedCount = 0;
            let hasError = false;  // 新增：标记是否有错误
            let errorMessage = ''; // 新增：错误信息
            const maxConcurrent = this.materialConcurrentLimit;

            // 创建任务队列
            const tasks = fileList.map((file, index) => {
                const materialId = this.addUploadingMaterial(file.name, type);
                return {
                    file,
                    index,
                    materialId,
                    fileObj: file.raw || file.file || file
                };
            });

            return new Promise((resolve, reject) => {
                const resultsMap = new Map();
                let nextIndex = 0;
                let activeCount = 0;

                const uploadOne = async (task) => {
                    // 如果已经有错误，不再上传新任务
                    if (hasError) {
                        activeCount--;
                        if (activeCount === 0) {
                            reject(new Error(errorMessage));
                        }
                        return;
                    }

                    activeCount++;
                    this.updateUploadProgress(task.materialId, 0, 'uploading', '正在上传...');

                    const formData = new FormData();
                    formData.append('files', task.fileObj);
                    formData.append('matSpecId', this.form3.type);
                    if (this.form2.flowScene == 11) {
                        formData.append('matSpecId', 50);
                    } else {
                        formData.append('matSpecId', this.form3.type);
                    }
                    formData.append('ownerId', ownerId);

                    if (type === 'logo') {
                        formData.append('picType', 'brandLogo');
                    } else if (type === 'image') {
                        formData.append('picType', 'imgs');
                    } else if (type === 'cover') {
                        formData.append('picType', 'videoImg');
                    }

                    try {
                        const res = await axios.post('apis/v3/creative/material/communal/upload', formData, {
                            ...config,
                            onUploadProgress: (progressEvent) => {
                                if (progressEvent.total && !hasError) {
                                    const percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                                    this.updateUploadProgress(task.materialId, percent, 'uploading', `上传中 ${percent}%`);
                                    if (onProgress) {
                                        const overallProgress = (completedCount + (percent / 100)) / totalFiles;
                                        onProgress(overallProgress);
                                    }
                                }
                            }
                        });

                        if (res.data.code === 0 && res.data.data && res.data.data.id) {
                            this.updateUploadProgress(task.materialId, 100, 'success', '上传成功');
                            resultsMap.set(task.index, res.data.data.id);
                        } else {
                            // 上传失败，记录错误
                            const errMsg = res.data.msg || '上传失败';
                            this.updateUploadProgress(task.materialId, 0, 'error', errMsg);
                            hasError = true;
                            errorMessage = `${type}素材 "${task.file.name}" 上传失败: ${errMsg}`;
                            this.$message.error(errorMessage);
                        }
                    } catch (error) {
                        const errMsg = error.message || '上传失败';
                        this.updateUploadProgress(task.materialId, 0, 'error', errMsg);
                        hasError = true;
                        errorMessage = `${type}素材 "${task.file.name}" 上传失败: ${errMsg}`;
                        this.$message.error(errorMessage);
                    } finally {
                        completedCount++;
                        activeCount--;

                        // 延迟后移除进度条
                        setTimeout(() => {
                            this.removeUploadingMaterial(task.materialId);
                        }, 3000);

                        // 更新总体进度
                        if (onProgress && !hasError) {
                            onProgress(completedCount / totalFiles);
                        }

                        // 如果有错误，停止所有后续上传
                        if (hasError) {
                            // 清理所有等待中的任务
                            while (nextIndex < tasks.length) {
                                const pendingTask = tasks[nextIndex++];
                                this.updateUploadProgress(pendingTask.materialId, 0, 'error', '因其他素材失败而取消');
                                setTimeout(() => {
                                    this.removeUploadingMaterial(pendingTask.materialId);
                                }, 1000);
                            }
                            if (activeCount === 0) {
                                reject(new Error(errorMessage));
                            }
                            return;
                        }

                        // 启动下一个任务
                        if (nextIndex < tasks.length) {
                            uploadOne(tasks[nextIndex++]);
                        } else if (activeCount === 0) {
                            // 所有任务完成且没有错误
                            const finalResults = [];
                            for (let i = 0; i < tasks.length; i++) {
                                const id = resultsMap.get(i);
                                if (id) finalResults.push(id);
                            }
                            resolve(finalResults);
                        }
                    }
                };

                // 启动初始并发任务
                const initialCount = Math.min(maxConcurrent, tasks.length);
                for (let i = 0; i < initialCount; i++) {
                    uploadOne(tasks[nextIndex++]);
                }
            });
        },

        // ========== 任务管理方法 ==========

        startBatchTasks() {
            if (!this.validateBeforeCreate()) return;

            // 检查是否有需要抽帧的视频
            var needExtractVideos = this.videofileList.filter(function (v) { return !v.coverExtracted; });
            var self = this;

            if (needExtractVideos.length > 0 && this.autoGenerateCover) {
                this.$confirm('检测到 ' + needExtractVideos.length + ' 个视频尚未提取封面，是否现在提取？', '提示', {
                    confirmButtonText: '立即提取',
                    cancelButtonText: '跳过',
                    type: 'info'
                }).then(function () {
                    self.manualExtractFrames().then(function () {
                        self.doStartBatchTasks();
                    }).catch(function () {
                        self.doStartBatchTasks();
                    });
                }).catch(function () {
                    self.doStartBatchTasks();
                });
            } else {
                this.doStartBatchTasks();
            }
        },
        doStartBatchTasks() {
            // ========== 第一步：创建当前配置的深拷贝快照 ==========
            const creativeType = this.form3.type;
            const isVideoCreative = [60, 63].includes(creativeType);
            const isImageCreative = [1, 20, 30, 50, 71, 5, 34].includes(creativeType);

            // 验证素材是否匹配创意类型
            if (isVideoCreative && this.materialFileList.video.length === 0) {
                this.$message.error('当前创意样式为视频类，但没有上传视频素材！');
                return;
            }

            if (isImageCreative && this.materialFileList.image.length === 0) {
                this.$message.warning('当前创意样式为图文类，但没有上传图片素材！');
                // 不阻止继续，只是警告
            }

            // 深拷贝配置快照（关键修复：解决数据污染问题）
            const configSnapshot = {
                // 账户列表
                ids_list: JSON.parse(JSON.stringify(this.ids_list)),

                // 表单配置
                form: JSON.parse(JSON.stringify(this.form)),
                form2: JSON.parse(JSON.stringify(this.form2)),
                form3: JSON.parse(JSON.stringify(this.form3)),

                // 素材文件列表（原始文件对象，需要特殊处理）
                materialFiles: {
                    logo: [...(this.materialFileList.logo || [])],
                    image: [...(this.materialFileList.image || [])],
                    video: [...(this.materialFileList.video || [])],
                    cover: [...(this.materialFileList.cover || [])]
                },
                 enableDeriveVideo: this.enableDeriveVideo,
                selectedDeriveTemplates: [...this.selectedDeriveTemplates],   // 拷贝数组

                // 文案
                titlesString: this.titlesString,

                // 时段配置
                timeLimit: this.timeLimit,
                timeSet: this.timeSet,

                // 创意配置
                mixminvalue: this.mixminvalue,
                mixminvaluelate: this.mixminvaluelate,
                isoldgroupprice: this.isoldgroupprice,
                parsestatus: this.parsestatus,

                // 素材数量统计
                materialCounts: {
                    logo: this.materialFileList.logo.length,
                    image: this.materialFileList.image.length,
                    video: this.materialFileList.video.length,
                    cover: this.materialFileList.cover.length,
                    text: this.titlesString.split('\n').filter(l => l.trim()).length
                }
            };

            // 打印快照信息用于调试
            console.log('创建任务快照:', {
                creativeType: creativeType,
                isVideo: isVideoCreative,
                materialCounts: configSnapshot.materialCounts,
                materialFiles: {
                    logo: configSnapshot.materialFiles.logo.length,
                    image: configSnapshot.materialFiles.image.length,
                    video: configSnapshot.materialFiles.video.length,
                    cover: configSnapshot.materialFiles.cover.length
                }
            });

            // 重置素材全局索引（每个任务独立）
            const materialGlobalIndex = {
                logo: 0,
                image: 0,
                video: 0,
                cover: 0,
                text: 0
            };

            const totalItems = configSnapshot.ids_list.length;
            const id = this.taskIdCounter++;

            // 创建新任务，存储快照
            const newTask = {
                id: id,
                name: '批量任务 #' + id + ' - ' + totalItems + '个账户',
                status: 'waiting',
                createdAt: new Date().toLocaleString(),
                currentIndex: 0,
                totalItems: totalItems,
                userDetails: configSnapshot.ids_list.map(user => this.createUserTaskDetail(user)),
                steps: [
                    { name: '批量处理', status: 'wait', detail: null },
                    { name: '完成', status: 'wait', detail: null }
                ],
                // 存储快照和独立索引
                configSnapshot: configSnapshot,
                materialGlobalIndex: { ...materialGlobalIndex },
                retryingAll: false  // 一键重试加载状态
            };

            this.tasks.unshift(newTask);
            this.$nextTick(() => { this.executeBatchTaskSerial(id); });
        },
        showMaterialProgress() {
            const progress = {
                logo: {
                    used: this.materialGlobalIndex.logo,
                    total: this.materialTotalCount.logo,
                    remaining: Math.max(0, this.materialTotalCount.logo - this.materialGlobalIndex.logo)
                },
                image: {
                    used: this.materialGlobalIndex.image,
                    total: this.materialTotalCount.image,
                    remaining: Math.max(0, this.materialTotalCount.image - this.materialGlobalIndex.image)
                },
                video: {
                    used: this.materialGlobalIndex.video,
                    total: this.materialTotalCount.video,
                    remaining: Math.max(0, this.materialTotalCount.video - this.materialGlobalIndex.video)
                },
                cover: {
                    used: this.materialGlobalIndex.cover,
                    total: this.materialTotalCount.cover,
                    remaining: Math.max(0, this.materialTotalCount.cover - this.materialGlobalIndex.cover)
                },
                text: {
                    used: this.materialGlobalIndex.text,
                    total: this.materialTotalCount.text,
                    remaining: Math.max(0, this.materialTotalCount.text - this.materialGlobalIndex.text)
                }
            };

            console.table(progress);
            return progress;
        },
        createUserTaskDetail(user) {
            return {
                accountName: user.idsname,
                campaignName: this.form.campaign_name,
                accountId: user.accountId,
                ownerId: user.zzownerid,
                status: 'waiting',
                retrying: false,
                createdPlanId: null,  // 🔧 新增：存储创建的计划ID，用于重试时复用
                groupExpanded: true,
                steps: [
                    { name: '上传素材', status: 'wait', detail: null, progress: 0 },
                    { name: '创建计划', status: 'wait', detail: null },
                    { name: '创建广告组', status: 'wait', detail: null },
                    { name: '创建创意', status: 'wait', detail: null },
                    { name: '完成', status: 'wait', detail: null }
                ],
                groupDetails: [],
                creativeCount: 0
            };
        },

        initGroupLogs(taskId, userIndex, groupCount) {
            const task = this.tasks.find(t => t.id === taskId);
            if (!task || !task.userDetails) return;

            const user = task.userDetails[userIndex];
            if (!user) return;

            groupCount = parseInt(groupCount) || 1;
            this.$set(user, 'groupDetails', []);

            for (let i = 0; i < groupCount; i++) {
                user.groupDetails.push({
                    id: i + 1,
                    name: `${user.accountName}_广告组${i + 1}`,
                    status: 'waiting',
                    detail: null,
                    creativeExpanded: true,
                    creatives: []
                });
            }
        },

        setGroupStep(taskId, userIndex, groupIndex, status, detail) {
            const task = this.tasks.find(t => t.id === taskId);
            if (!task || !task.userDetails) return;

            const user = task.userDetails[userIndex];
            if (!user || !user.groupDetails) return;

            const group = user.groupDetails[groupIndex];
            if (!group) return;

            group.status = status;
            if (detail) group.detail = detail;
        },

        initCreativeLogsInGroup(taskId, userIndex, groupIndex, creativeCount) {
            const task = this.tasks.find(t => t.id === taskId);
            if (!task || !task.userDetails) return;

            const user = task.userDetails[userIndex];
            if (!user || !user.groupDetails) return;

            const group = user.groupDetails[groupIndex];
            if (!group) return;

            creativeCount = parseInt(creativeCount) || 0;
            this.$set(group, 'creatives', []);

            for (let i = 0; i < creativeCount; i++) {
                group.creatives.push({
                    id: i + 1,
                    status: 'waiting',
                    steps: [
                        { name: '素材准备', status: 'wait', detail: null },
                        { name: '创意搭建', status: 'wait', detail: null }
                    ]
                });
            }
        },

        setCreativeStepInGroup(taskId, userIndex, groupIndex, creativeIndex, stepIndex, status, detail) {
            const task = this.tasks.find(t => t.id === taskId);
            if (!task || !task.userDetails) return;

            const user = task.userDetails[userIndex];
            if (!user || !user.groupDetails) return;

            const group = user.groupDetails[groupIndex];
            if (!group || !group.creatives) return;

            const creative = group.creatives[creativeIndex];
            if (!creative || !creative.steps) return;

            const step = creative.steps[stepIndex];
            if (!step) return;

            step.status = status;
            step.detail = this.formatDetail(detail);

            if (status === 'doing') creative.status = 'running';
            if (status === 'error') creative.status = 'failed';
            if (status === 'success' && creative.steps.every(s => s.status === 'success')) {
                creative.status = 'done';
            }

            const allCreativesDone = group.creatives.every(c => c.status === 'done' || c.status === 'failed');
            if (allCreativesDone) {
                const hasFailed = group.creatives.some(c => c.status === 'failed');
                this.setGroupStep(taskId, userIndex, groupIndex, hasFailed ? 'failed' : 'done', group.detail);
            }
        },

        // 串行执行账户任务
        async executeBatchTaskSerial(taskId) {
            const controller = new AbortController();
            const signal = controller.signal;
            this.taskControllers.set(taskId, controller);
            this.isTaskStopped.set(taskId, false);
            this.isTaskPaused.set(taskId, false);

            const task = this.tasks.find(t => t.id === taskId);
            if (!task) return;

            // 获取任务快照
            const snapshot = task.configSnapshot;

            const setStep = (userIndex, stepIndex, status, detail, progress) =>
                this.setTaskStep(taskId, userIndex, stepIndex, status, detail, progress);

            try {
                setStep(null, 0, 'doing', `开始处理 ${task.totalItems} 个账户`);

                // 清空素材缓存（任务级）
                this.accountMaterialCache.clear();

                // 串行处理每个账户
                for (let i = 0; i < task.totalItems; i++) {
                    while (this.isTaskPaused.get(taskId)) {
                        await this.delay(500);
                        if (signal.aborted) break;
                    }
                    if (this.isTaskStopped.get(taskId) || signal.aborted) {
                        break;
                    }

                    try {
                        await this.createSingleAccountSerial(i, taskId, signal);
                    } catch (error) {
                        console.error(`账户 ${i} 处理失败:`, error);
                        const user = task.userDetails[i];
                        if (user) {
                            // 根据错误类型设置不同的状态
                            if (error.message && (error.message.includes('素材上传失败') || error.message.includes('上传失败'))) {
                                user.status = 'material_failed';
                                user.steps[0].status = 'error';
                                user.steps[0].detail = `素材上传失败: ${error.message}`;
                            } else {
                                user.status = 'failed';
                                user.steps[4].status = 'error';
                                user.steps[4].detail = `处理失败: ${error.message}`;
                            }
                        }
                    }

                    task.currentIndex = i + 1;
                    this.uploadPercent = Math.round(((i + 1) / task.totalItems) * 100);

                    if (i < task.totalItems - 1) {
                        await this.delay(this.accountDelay);
                    }
                }

                if (!this.isTaskStopped.get(taskId) && !signal.aborted) {
                    this.uploadPercent = 100;
                    setStep(null, 1, 'success', '所有任务完成');
                    task.status = 'done';
                }

            } catch (error) {
                if (error.name === 'AbortError') {
                    setStep(null, 0, 'error', '任务被中止');
                } else {
                    setStep(null, 0, 'error', `任务执行异常: ${error.message}`);
                }
            } finally {
                this.taskControllers.delete(taskId);
                this.isTaskStopped.delete(taskId);
                this.isTaskPaused.delete(taskId);
            }
        },

        setTaskStep(taskId, userIndex, stepIndex, status, detail, progress = null) {
            const task = this.tasks.find(t => t.id === taskId);
            if (!task) return;

            if (userIndex === null) {
                const step = task.steps[stepIndex];
                if (!step) return;
                step.status = status;
                step.detail = this.formatDetail(detail);

                if (status === 'doing') task.status = 'running';
                if (status === 'error') task.status = 'failed';
                if (status === 'success') {
                    const allStepsSuccess = task.steps.every(s => s.status === 'success');
                    if (allStepsSuccess) task.status = 'done';
                }
            } else {
                const user = task.userDetails[userIndex];
                if (!user) return;

                const step = user.steps[stepIndex];
                if (!step) return;
                step.status = status;
                step.detail = this.formatDetail(detail);
                if (progress !== null) {
                    step.progress = progress;
                }

                if (status === 'doing') user.status = 'running';
                if (status === 'error') user.status = 'failed';
                if (status === 'success') {
                    const allUserStepsSuccess = user.steps.every(s => s.status === 'success');
                    if (allUserStepsSuccess) user.status = 'done';
                }

                const allUsersDone = task.userDetails.every(u => u.status === 'done' || u.status === 'failed' || u.status === 'material_failed');
                if (allUsersDone) {
                    task.status = 'done';
                    if (task.steps[1]) {
                        task.steps[1].status = 'success';
                        task.steps[1].detail = '所有账户处理完成';
                    }
                }
            }
        },

        // 串行处理单个账户

        async createSingleAccountSerial(index, taskId, signal) {
            const task = this.tasks.find(t => t.id === taskId);
            if (!task) return;

            // 【关键】从任务快照中获取配置，而不是当前页面的响应式数据
            const snapshot = task.configSnapshot;
            const materialFiles = snapshot.materialFiles;

            const setStep = (stepIndex, status, detail, progress) =>
                this.setTaskStep(taskId, index, stepIndex, status, detail, progress);

            try {
                const account = snapshot.ids_list[index];
                const ownerId = account.zzownerid;
                const adGroupCount = parseInt(snapshot.form.adgroupNumber) || 1;
                const creativePerGroup = parseInt(snapshot.form3.number) || 1;
                const totalCreatives = adGroupCount * creativePerGroup;

                this.initGroupLogs(taskId, index, adGroupCount);

                const time1 = Math.floor(Date.now() / 1000);
                const sign = sha1(account.apiid + account.apikey + time1);
                const token = Base64.encode(`${account.ownerid},${account.apiid},${time1},${sign}`);

                const config = {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                };

                // ========== 步骤0: 准备并上传素材 ==========
                setStep(0, 'doing', '准备素材...', 0);

                if (signal.aborted) throw new Error('任务中止');

                // 从快照获取文案列表
                let textList = snapshot.titlesString
                    .split('\n')
                    .map(line => line.trim())
                    .filter(line => line);

                // 从快照获取原始文件列表
                let logoFiles = [...(materialFiles.logo || [])];
                let imageFiles = [...(materialFiles.image || [])];
                let coverFiles = [...(materialFiles.cover || [])];
                let videoFiles = [...(materialFiles.video || [])];

                // 混搭模式：打乱顺序（使用快照配置）
                if (snapshot.mixminvalue) {
                    imageFiles = this.shuffleArray(imageFiles);
                    textList = this.shuffleArray(textList);
                }

                // 重置任务独立索引（每个账户开始前重置）
                task.materialGlobalIndex = {
                    logo: 0,
                    image: 0,
                    video: 0,
                    cover: 0,
                    text: 0
                };

                // 轮询获取该账户需要的素材文件（每个创意需要一份）
                const neededLogoFiles = [];
                const neededImageFiles = [];
                const neededCoverFiles = [];
                const neededVideoFiles = [];

                for (let i = 0; i < totalCreatives; i++) {
                    if (logoFiles.length > 0) {
                        const idx = task.materialGlobalIndex.logo % logoFiles.length;
                        neededLogoFiles.push(logoFiles[idx]);
                        task.materialGlobalIndex.logo++;
                    }

                    if (imageFiles.length > 0) {
                        const idx = task.materialGlobalIndex.image % imageFiles.length;
                        neededImageFiles.push(imageFiles[idx]);
                        task.materialGlobalIndex.image++;
                    }

                    if (videoFiles.length > 0) {
                        const idx = task.materialGlobalIndex.video % videoFiles.length;
                        neededVideoFiles.push(videoFiles[idx]);
                        task.materialGlobalIndex.video++;
                    }

                    if (coverFiles.length > 0) {
                        const idx = task.materialGlobalIndex.cover % coverFiles.length;
                        neededCoverFiles.push(coverFiles[idx]);
                        task.materialGlobalIndex.cover++;
                    }
                }

                // 重置任务独立索引用于后续分配
                task.materialGlobalIndex = {
                    logo: 0,
                    image: 0,
                    video: 0,
                    cover: 0,
                    text: 0
                };

                // ========== 关键修改：直接上传 needed 数组中的文件（不去重） ==========
                // 这样上传数量 = 需要的素材数量，而不是全部素材文件
                setStep(0, 'doing', `需要上传 ${neededLogoFiles.length}个LOGO, ${neededImageFiles.length}个图片, ${neededVideoFiles.length}个视频, ${neededCoverFiles.length}个封面`, 0);

                // 上传LOGO - 直接使用 neededLogoFiles
                const logoCodeMap = new Map();
                for (let i = 0; i < neededLogoFiles.length; i++) {
                    if (signal.aborted) throw new Error('任务中止');
                    const file = neededLogoFiles[i];
                    const progress = (i + 1) / neededLogoFiles.length;
                    setStep(0, 'doing', `上传LOGO ${i + 1}/${neededLogoFiles.length}: ${file.name}`, Math.round(progress * 20));
                    const code = await this.uploadSingleMaterial(file, 'logo', config, ownerId);
                    logoCodeMap.set(file.name, code);
                }

                // 上传图片 - 直接使用 neededImageFiles
                const imageCodeMap = new Map();
                for (let i = 0; i < neededImageFiles.length; i++) {
                    if (signal.aborted) throw new Error('任务中止');
                    const file = neededImageFiles[i];
                    const progress = 20 + (i + 1) / neededImageFiles.length * 30;
                    setStep(0, 'doing', `上传图片 ${i + 1}/${neededImageFiles.length}: ${file.name}`, Math.round(progress));
                    const code = await this.uploadSingleMaterial(file, 'image', config, ownerId);
                    imageCodeMap.set(file.name, code);
                }

                // 上传视频 - 直接使用 neededVideoFiles
                const videoCodeMap = new Map();
                for (let i = 0; i < neededVideoFiles.length; i++) {
                    if (signal.aborted) throw new Error('任务中止');
                    const file = neededVideoFiles[i];
                    const progress = 50 + (i + 1) / neededVideoFiles.length * 30;
                    setStep(0, 'doing', `上传视频 ${i + 1}/${neededVideoFiles.length}: ${file.name}`, Math.round(progress));
                    const code = await this.uploadSingleMaterial(file, 'video', config, ownerId);
                    videoCodeMap.set(file.name, code);
                }

                // 上传封面 - 直接使用 neededCoverFiles
                const coverCodeMap = new Map();
                for (let i = 0; i < neededCoverFiles.length; i++) {
                    if (signal.aborted) throw new Error('任务中止');
                    const file = neededCoverFiles[i];
                    const progress = 80 + (i + 1) / neededCoverFiles.length * 20;
                    setStep(0, 'doing', `上传封面 ${i + 1}/${neededCoverFiles.length}: ${file.name}`, Math.round(progress));
                    const code = await this.uploadSingleMaterial(file, 'cover', config, ownerId);
                    coverCodeMap.set(file.name, code);
                }

                setStep(0, 'success', `素材上传完成: LOGO ${neededLogoFiles.length}, 图片 ${neededImageFiles.length}, 视频 ${neededVideoFiles.length}, 封面 ${neededCoverFiles.length}`, 100);

                // 重置任务独立索引用于创意分配
                task.materialGlobalIndex = {
                    logo: 0,
                    image: 0,
                    video: 0,
                    cover: 0,
                    text: 0
                };

                // 构建每个创意需要的素材ID列表（根据 needed 数组索引直接获取）
                const creativeMaterialsList = [];
                for (let i = 0; i < totalCreatives; i++) {
                    const creativeMaterials = {
                        logoId: null,
                        imageId: null,
                        videoId: null,
                        coverId: null,
                        text: null
                    };

                    if (logoFiles.length > 0) {
                        const file = neededLogoFiles[i];
                        creativeMaterials.logoId = logoCodeMap.get(file.name) || null;
                    }

                    if (imageFiles.length > 0) {
                        const file = neededImageFiles[i];
                        creativeMaterials.imageId = imageCodeMap.get(file.name) || null;
                    }

                    if (videoFiles.length > 0) {
                        const file = neededVideoFiles[i];
                        creativeMaterials.videoId = videoCodeMap.get(file.name) || null;
                    }

                    if (coverFiles.length > 0) {
                        const file = neededCoverFiles[i];
                        creativeMaterials.coverId = coverCodeMap.get(file.name) || null;
                    }

                    if (textList.length > 0) {
                        const idx = task.materialGlobalIndex.text % textList.length;
                        creativeMaterials.text = textList[idx];
                        task.materialGlobalIndex.text++;
                    }

                    creativeMaterialsList.push(creativeMaterials);
                }

                // ========== 步骤1: 创建广告计划 ==========
                let planId = null;

                if (snapshot.form.useLatestPlan) {
                    setStep(1, 'doing', '获取最新广告计划...');
                    const latestPlanResult = await this.fetchLatestPlanId(account, token, config);

                    if (latestPlanResult.success) {
                        planId = latestPlanResult.planId;
                        setStep(1, 'success', `使用最新计划 ID: ${planId}`);
                    } else {
                        setStep(1, 'doing', `未找到最新计划，创建新计划...`);
                        const newPlanData = {
                            planName: `${account.planName}_${snapshot.form.planName}${this.timesname()}${snapshot.form.campaign_name}${this.timesgetFun()}`,
                            deliveryMode: snapshot.form.delivery_mode,
                            extensionType: snapshot.form.extension_type,
                            dayLimit: snapshot.form.dayLimit,
                            ownerId: ownerId,
                        };

                        if (snapshot.form.dayLimit == 1) {
                            newPlanData.dayBudget = snapshot.form.dayBudget * 100;
                        }

                        const planRes = await this.axiosPostWithRetry('apis/v3/plan/add', qs.stringify(newPlanData), config, signal);

                        if (planRes.data.code != 0) {
                            throw new Error(planRes.data.msg || '创建计划失败');
                        }

                        planId = planRes.data.data.planId;
                        // 🔧 新增：保存计划ID到user对象，供重试时复用
                        task.userDetails[index].createdPlanId = planId;
                        setStep(1, 'success', `创建新计划成功 ID: ${planId}`);
                    }
                } else {
                    setStep(1, 'doing', '创建新广告计划...');

                    const newPlanData = {
                        planName: `${account.planName}_${snapshot.form.planName}${this.timesname()}${snapshot.form.campaign_name}${this.timesgetFun()}`,
                        deliveryMode: snapshot.form.delivery_mode,
                        extensionType: snapshot.form.extension_type,
                        dayLimit: snapshot.form.dayLimit,
                        ownerId: ownerId,
                    };

                    if (snapshot.form.dayLimit == 1) {
                        newPlanData.dayBudget = snapshot.form.dayBudget * 100;
                    }

                    const planRes = await this.axiosPostWithRetry('apis/v3/plan/add', qs.stringify(newPlanData), config, signal);

                    if (planRes.data.code != 0) {
                        throw new Error(planRes.data.msg || '创建计划失败');
                    }

                    planId = planRes.data.data.planId;
                    // 🔧 新增：保存计划ID到user对象，供重试时复用
                    task.userDetails[index].createdPlanId = planId;
                    setStep(1, 'success', `计划创建成功 ID: ${planId}`);
                }

                // 处理计划开关（只有新建计划时才控制）
                if (snapshot.form.switchPlan == 1 && !snapshot.form.useLatestPlan) {
                    await axios.post('apis/v3/plan/status',
                        qs.stringify({ planIds: planId, status2: 1, ownerId: ownerId }),
                        config
                    );
                }

                // 获取落地页信息
                let pageInfo = null;
                if (snapshot.parsestatus) {
                    pageInfo = await this.queryWebsideId(token, ownerId);
                }

                // ========== 步骤2: 串行创建广告组和创意 ==========
                let creativeIndex = 0;

                for (let g = 0; g < adGroupCount; g++) {
                    if (signal.aborted) throw new Error('任务中止');

                    setStep(2, 'doing', `创建第${g + 1}/${adGroupCount}个广告组...`);

                    this.initCreativeLogsInGroup(taskId, index, g, creativePerGroup);

                    // 使用快照中的配置构建广告组数据
                    const groupData = {
                        planId: planId,
                        adGroupName: `${account.planName}_${snapshot.form.planName}${this.timesname()}${snapshot.form.campaign_name}_组${g + 1}${this.timesgetFun()}`,
                        extensionFlow: snapshot.form2.extensionFlow,
                        flowScene: snapshot.form2.flowScene,
                        extensionType: snapshot.form.extension_type,
                        targetId: account.targetid,
                        billingType: snapshot.form2.billingType,
                        price: snapshot.isoldgroupprice && account.price ?
                            account.price : snapshot.form2.price * 100,
                        dayLimit: 0,
                        ownerId: ownerId,
                    };




                    if (snapshot.timeLimit == 1) {
                        groupData.timeLimit = 1;
                        groupData.timeSet = snapshot.timeSet;
                    }

                    if ([6, 7, 9, 10, 11].includes(Number(snapshot.form2.flowScene))) {
                        groupData.advertiseType = snapshot.form2.dpaProductType;
                    }

                    if (snapshot.form2.flowScene == 6 && snapshot.form.extension_type == 3) {
                        groupData.linkDeskFlag = snapshot.form2.linkDeskFlag;
                    }

                    // 根据推广类型处理不同参数
                    if (snapshot.form.extension_type == 3) {
                        groupData.pageType = snapshot.form2.pageType;
                        groupData.pageUrl = account.url || '';
                        groupData.instantAppId = account.appid;
                        groupData.instantAppUrl = account.haplink;

                        if (pageInfo) {
                            groupData.pageUrl = pageInfo.pageUrl;
                            groupData.pageId = pageInfo.pageId;
                        }
                    } else if (snapshot.form.extension_type == 1) {
                        if (snapshot.form2.Deeplinktype == 0) {
                            groupData.pageType = snapshot.form2.pageType;
                            groupData.pageUrl = account.url || '';

                            if (pageInfo) {
                                groupData.pageUrl = pageInfo.pageUrl.trim();
                                groupData.pageId = pageInfo.pageId;
                            }

                            if (snapshot.form2.Deeplinkstatus) {
                                groupData.deepUrl = account.haplink;
                            }
                        } else if (snapshot.form2.Deeplinktype == 3) {
                            groupData.Deeplinktype = snapshot.form2.Deeplinktype;
                            groupData.pageType = snapshot.form2.pageType;
                            groupData.pageUrl = account.url || '';
                            groupData.instantAppId = account.appid;
                            groupData.instantAppUrl = account.haplink;

                            if (pageInfo) {
                                groupData.pageUrl = pageInfo.pageUrl.trim();
                                groupData.pageId = pageInfo.pageId;
                            }
                        }
                    } else if (snapshot.form.extension_type == 2) {
                        groupData.appId = account.appid;
                        groupData.pageType = snapshot.form2.pageType;
                        groupData.pageId = account.haplink;
                    }
                    else if (snapshot.form.extension_type == 6) {
                        groupData.appId = account.appid;
                        groupData.deepUrl = account.haplink;
                        groupData.pageType = snapshot.form2.pageType;
                        groupData.pageUrl = account.url;
                    }

                    // OCPC相关参数
                    if (snapshot.form2.billingType == 5) {
                        if (snapshot.form2.ocpcType == 47) {
                            groupData.targetROI = snapshot.form2.targetROI * 1000000;
                            groupData.ocpcType = snapshot.form2.ocpcType;
                            groupData.defaultSecondStage = snapshot.form2.defaultSecondStage;
                        } else {
                            groupData.ocpcPrice = snapshot.isoldgroupprice && account.ocpcPrice ?
                                account.ocpcPrice : snapshot.form2.ocpcPrice * 100;
                            groupData.ocpcType = snapshot.form2.ocpcType;
                            groupData.defaultSecondStage = snapshot.form2.defaultSecondStage;
                        }
                    }

                    // 深度转化
                    if (snapshot.form2.deepOcpcStatus) {
                        groupData.deepOcpcType = snapshot.form2.deepOcpcType;
                        groupData.deepOcpcPrice = Number(snapshot.form2.deepOcpcPrice) * 100;
                        groupData.ocpcOptmType = 1;
                    }
                    console.log(pageInfo);
                    if (this.form2.pageType == 11) {
                        groupData.pageUrl = pageInfo.pageUrl.trim();
                        groupData.pageId = pageInfo.pageId;
                    }

                    // 曝光监测URL
                    if (account.baoguangurl) {
                        groupData.exposeUrl = account.baoguangurl;
                    }

                    const groupRes = await this.axiosPostWithRetry('apis/v3/group/add', qs.stringify(groupData), config, signal);

                    if (groupRes.data.code != 0) {
                        this.setGroupStep(taskId, index, g, 'failed', groupRes.data.msg || '创建失败');
                        creativeIndex += creativePerGroup;
                        continue;
                    }

                    this.setGroupStep(taskId, index, g, 'done', `ID: ${groupRes.data.data.adGroupId}`);

                    // ========== 步骤3: 批量创建创意 ==========
                    setStep(3, 'doing', `为第${g + 1}/${adGroupCount}个广告组创建创意...`);

                    const addList = [];
                    for (let c = 0; c < creativePerGroup; c++) {
                        const materials = creativeMaterialsList[creativeIndex + c];
                        if (!materials) continue;

                        // 使用快照中的配置构建创意
                        const creative = {
                            adGroupId: groupRes.data.data.adGroupId,
                            adPlanId: planId,
                            adName: account.planName + '_' + snapshot.form.planName + this.timesname() + snapshot.form.campaign_name + '_创意' + (c + 1) + '_' + Date.now(),
                            globalSpecId: snapshot.form3.type,
                            brandName: snapshot.form3.brandName,
                            buttonTxt: snapshot.form3.buttonTxt,
                            clickUrl: account.xiaoshuourl || '',
                            status: 0,
                            copywriter: materials.text || '默认文案'
                        };
                        if (snapshot.form2.flowScene == 6) {
  if (snapshot.enableDeriveVideo) {
    // 只有当开启衍生视频时才带入字段
    if (snapshot.form3.type == 1 && snapshot.selectedDeriveTemplates.length > 0) {
      // 横版大图，使用多选模板
      creative.deriveTemplate = snapshot.selectedDeriveTemplates.join(',');
    }
    // 如果需要其他样式但未选模板，可不传 deriveTemplate，只传 dynamicCr: true 即可
    creative.dynamicCr = 1;
  }
}

                        if (materials.logoId) {
                            creative.brandLogoImgId = materials.logoId;
                        }
                        if (account.baoguangurl) {
                            creative.exposeUrl = account.baoguangurl;
                        }

                        const flowScene = Number(snapshot.form2.flowScene);
                        const creativeType = Number(snapshot.form3.type);

                        if ([60, 63].indexOf(creativeType) !== -1) {
                            if (materials.videoId) {
                                creative.videoMatIds = materials.videoId;
                            }
                            if (materials.coverId) {
                                if (flowScene == 11) {
                                    creative.videoBgImgId = materials.coverId;
                                } else if (flowScene != 12 && flowScene != 11) {
                                    creative.videoImgId = materials.coverId;
                                } else if (flowScene == 12 && creativeType == 60 && snapshot.form.extension_type == 1) {
                                    creative.videoImgId = materials.coverId;
                                } else if (flowScene == 12 && creativeType == 63 && snapshot.form.extension_type == 1) {
                                    creative.videoBgImgId = materials.coverId;
                                }
                            }
                        } else if ([1, 20, 30, 50, 71].indexOf(creativeType) !== -1) {
                            if (materials.imageId) {
                                creative.imgMatIds = materials.imageId;
                            }
                        } else if ([5, 34].indexOf(creativeType) !== -1) {
                            if (materials.imageId) {
                                creative.imgMatIds = materials.imageId;
                            }
                        }

                        if (snapshot.form2.flowScene == 6 && snapshot.form2.extensionFlow == 2) {
                            if (account.creativityid) {
                                creative.creativityId = account.creativityid;
                            }
                        }

                        this.setCreativeStepInGroup(taskId, index, g, c, 0, 'success', '素材准备完成');
                        addList.push(creative);
                    }

                    // 批量创建创意
                    if (addList.length > 0) {
                        const batchData = {
                            ownerId: ownerId,
                            addList: addList,
                            immediatelyRefresh: 0
                        };

                        try {
                            const res = await this.axiosPostWithRetry('apis/v3/ad/batch',
                                qs.stringify(batchData, { allowDots: true }),
                                config,
                                signal
                            );

                            if (res.data.code == 0) {
                                const createdIds = res.data.data || [];
                                for (let c = 0; c < addList.length; c++) {
                                    this.setCreativeStepInGroup(taskId, index, g, c, 1, 'success',
                                        '创意创建成功 ID: ' + (createdIds[c] || ''));
                                }
                            } else {
                                const errorMsg = res.data.msg || '批量创建创意失败';
                                for (let c = 0; c < addList.length; c++) {
                                    this.setCreativeStepInGroup(taskId, index, g, c, 1, 'error', errorMsg);
                                }
                                throw new Error(errorMsg);
                            }
                        } catch (error) {
                            if (error.name !== 'AbortError') {
                                for (let c = 0; c < addList.length; c++) {
                                    this.setCreativeStepInGroup(taskId, index, g, c, 1, 'error', error.message || '创建异常');
                                }
                            }
                            throw error;
                        }
                    }

                    creativeIndex += creativePerGroup;

                    if (g < adGroupCount - 1) {
                        await this.delay(this.groupDelay);
                    }
                }

                setStep(2, 'success', `所有广告组创建成功，共创建 ${adGroupCount} 个广告组`);
                setStep(3, 'success', `广告组创建完成，共创建 ${adGroupCount} 个广告组，每个包含 ${creativePerGroup} 个创意`);
                setStep(4, 'success', '账户搭建完成');

            } catch (error) {
                if (error.name === 'AbortError') {
                    setStep(4, 'error', '任务被中止');
                } else {
                    setStep(4, 'error', `处理失败: ${error.message}`);
                }
                throw error;
            }
        },
        syncMaterialFileLists() {
            // 确保 materialFileList 与 txfileList 同步
            this.materialFileList.logo = this.txfileList.map(item => item.raw || item.file).filter(f => f);
            this.materialFileList.image = this.tpfileList.map(item => item.raw || item.file).filter(f => f);
            this.materialFileList.cover = this.videotpfileList.map(item => item.raw || item.file).filter(f => f);
            this.materialFileList.video = this.videofileList.map(item => item.raw || item.file).filter(f => f);

            console.log('素材同步完成:', {
                logo: this.materialFileList.logo.length,
                image: this.materialFileList.image.length,
                cover: this.materialFileList.cover.length,
                video: this.materialFileList.video.length
            });
        },

        // 串行创建创意
        async createCreativesSerial(adGroupId, planId, account, token, accountIndex, groupIndex, taskId, signal, materials) {
            const config = {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };

            // 获取文案列表
            let textList = this.titlesString
                .split('\n')
                .map(line => line.trim())
                .filter(line => line);

            // 获取各类素材列表
            let logoList = [...(materials.logoCode || [])];
            let imgList = [...(materials.imageCodes || [])];
            let coverList = [...(materials.coverCodes || [])];
            let videoList = [...(materials.videoCodes || [])];

            if (this.mixminvalue) {
                // 混搭模式：打乱顺序
                imgList = this.shuffleArray(imgList);
                textList = this.shuffleArray(textList);
            }

            const creativeCount = parseInt(this.form3.number) || 1;
            const totalAccounts = this.ids_list.length;

            // 准备批量创建的 addList
            const addList = [];

            for (let i = 0; i < creativeCount; i++) {
                if (signal.aborted) throw new Error('任务中止');

                this.setCreativeStepInGroup(taskId, accountIndex, groupIndex, i, 0, 'doing', '准备素材...');

                // 使用全局轮询获取素材
                const logoResult = logoList.length > 0 ? this.getMaterialByGlobalIndex('logo', logoList, true) : null;
                const textResult = textList.length > 0 ? this.getMaterialByGlobalIndex('text', textList, true) : null;
                const imgResult = imgList.length > 0 ? this.getMaterialByGlobalIndex('image', imgList, true) : null;
                const videoResult = videoList.length > 0 ? this.getMaterialByGlobalIndex('video', videoList, true) : null;
                const coverResult = coverList.length > 0 ? this.getMaterialByGlobalIndex('cover', coverList, true) : null;

                // 构建单个创意对象
                const creative = {
                    adGroupId: adGroupId,                           // 广告组ID[新增时必填]
                    adPlanId: planId,                               // 计划ID[新增时必填]
                    adName: account.planName + '_' + this.form.planName + this.timesname() + this.form.campaign_name + '_创意' + (i + 1) + '_' + Date.now(),  // 广告名称[新增时必填]
                    globalSpecId: this.form3.type,                  // 统一规格ID[新增时必填]
                    brandName: this.form3.brandName,                // 品牌名称
                    buttonTxt: this.form3.buttonTxt,                // 按钮文案
                    clickUrl: account.xiaoshuourl || '',            // 点击监测链接
                    status: 0                                       // 广告状态 0-开启
                };

                // 添加品牌LOGO
                if (logoResult && logoResult.value) {
                    creative.brandLogoImgId = logoResult.value;
                }

                // 添加文案
                creative.copywriter = textResult ? textResult.value : (textList[0] || '默认文案');

                const flowScene = Number(this.form2.flowScene);
                const creativeType = Number(this.form3.type);

                // 根据创意类型添加素材
                if ([60, 63].indexOf(creativeType) !== -1) {
                    // 视频类创意
                    if (videoResult && videoResult.value) {
                        creative.videoMatIds = videoResult.value;
                    }

                    if (coverResult && coverResult.value) {
                        if (flowScene == 11) {
                            creative.videoBgImgId = coverResult.value;
                        } else if (flowScene != 12 && flowScene != 11) {
                            creative.videoImgId = coverResult.value;
                        } else if (flowScene == 12 && creativeType == 60 && this.form.extension_type == 1) {
                            creative.videoImgId = coverResult.value;
                        } else if (flowScene == 12 && creativeType == 63 && this.form.extension_type == 1) {
                            creative.videoBgImgId = coverResult.value;
                        }
                    }

                    if (creativeType == 63 || flowScene == 11) {
                        creative.buttonTxt = this.form3.buttonTxt;
                    }
                } else if ([1, 20, 30, 50, 71].indexOf(creativeType) !== -1) {
                    // 图片类创意
                    if (imgResult && imgResult.value) {
                        creative.imgMatIds = imgResult.value;
                    }
                    creative.buttonTxt = this.form3.buttonTxt;
                } else if ([5, 34].indexOf(creativeType) !== -1) {
                    // 开屏类创意
                    if (imgResult && imgResult.value) {
                        creative.imgMatIds = imgResult.value;
                    }
                    if (creativeType == 34) {
                        creative.copywriter = textResult ? textResult.value : (textList[0] || '默认文案');
                    }
                }

                // 添加互动创意ID（如果需要）
                if (this.form2.flowScene == 6 && this.form2.extensionFlow == 2) {
                    if (account.creativityid) {
                        creative.creativityId = account.creativityid;
                    }
                }

                var logoIndexText = (logoResult && logoResult.globalIndex !== undefined && logoResult.globalIndex !== null) ? logoResult.globalIndex : '无';
                var textIndexText = (textResult && textResult.globalIndex !== undefined && textResult.globalIndex !== null) ? textResult.globalIndex : '无';

                this.setCreativeStepInGroup(taskId, accountIndex, groupIndex, i, 0, 'success',
                    '素材准备完成 (LOGO索引:' + logoIndexText + ', 文案索引:' + textIndexText + ')');

                addList.push(creative);
            }

            // 批量创建创意
            if (addList.length > 0) {
                this.setCreativeStepInGroup(taskId, accountIndex, groupIndex, 0, 1, 'doing', '批量创建创意中...');

                const batchData = {
                    ownerId: account.zzownerid,
                    addList: addList,
                    immediatelyRefresh: 0  // 0表示不刷新ES数据，提高接口性能
                };

                try {
                    const res = await this.axiosPostWithRetry('apis/v3/ad/batch',
                        qs.stringify(batchData, { allowDots: true }),
                        config,
                        signal
                    );

                    if (res.data.code == 0) {
                        // 批量创建成功
                        const createdIds = res.data.data || [];
                        for (let i = 0; i < addList.length; i++) {
                            this.setCreativeStepInGroup(taskId, accountIndex, groupIndex, i, 1, 'success',
                                '创意创建成功 ID: ' + (createdIds[i] || '') + ' (素材索引: ' + i + ')');
                        }
                        this.setCreativeStepInGroup(taskId, accountIndex, groupIndex, 0, 1, 'success',
                            '批量创建创意成功，共创建 ' + addList.length + ' 个创意');
                    } else {
                        // 批量创建失败
                        const errorMsg = res.data.msg || '批量创建创意失败';
                        for (let i = 0; i < addList.length; i++) {
                            this.setCreativeStepInGroup(taskId, accountIndex, groupIndex, i, 1, 'error',
                                '创建失败: ' + errorMsg);
                        }
                        throw new Error(errorMsg);
                    }
                } catch (error) {
                    if (error.name === 'AbortError') throw error;
                    for (let i = 0; i < addList.length; i++) {
                        this.setCreativeStepInGroup(taskId, accountIndex, groupIndex, i, 1, 'error',
                            '创建异常: ' + (error.message || ''));
                    }
                    throw error;
                }
            }

            // 创意间延迟（批量创建后不需要单独延迟）
            await this.delay(this.creativeDelay);
        },

        async fetchLatestPlanId(account, token, config) {
            try {
                const planData = {
                    limit: 1,
                    page: 1
                };

                const response = await this.axiosPostWithRetry('apis/v3/plan/page',
                    qs.stringify(planData),
                    config,
                    new AbortController().signal
                );

                if (response.data.code === 0 &&
                    response.data.data &&
                    response.data.data.records &&
                    response.data.data.records.length > 0) {
                    const latestPlan = response.data.data.records[0];
                    return {
                        planId: latestPlan.planId,
                        planName: latestPlan.planName,
                        success: true
                    };
                } else {
                    return {
                        success: false,
                        message: '没有找到任何计划'
                    };
                }
            } catch (error) {
                console.error('获取最新计划失败:', error);
                return {
                    success: false,
                    message: error.message || '获取计划失败'
                };
            }
        },

        stopTask(taskId) {
            const controller = this.taskControllers.get(taskId);
            if (controller) {
                controller.abort();
                this.isTaskStopped.set(taskId, true);
                this.isTaskPaused.set(taskId, false);

                const task = this.tasks.find(t => t.id === taskId);
                if (task) {
                    task.status = 'stopped';
                    task.userDetails.forEach(user => {
                        if (user.status === 'running') {
                            user.status = 'stopped';
                            user.steps.forEach(step => {
                                if (step.status === 'doing') {
                                    step.status = 'error';
                                    step.detail = '任务被停止';
                                }
                            });
                        }
                    });
                }
                this.$message.warning(`任务 #${taskId} 已停止`);
            }
        },

        pauseTask(taskId) {
            this.isTaskPaused.set(taskId, true);
            const task = this.tasks.find(t => t.id === taskId);
            if (task) {
                task.status = 'paused';
                this.$message.info(`任务 #${taskId} 已暂停`);
            }
        },

        resumeTask(taskId) {
            this.isTaskPaused.set(taskId, false);
            const task = this.tasks.find(t => t.id === taskId);
            if (task) {
                task.status = 'running';
                this.$message.success(`任务 #${taskId} 已继续`);
            }
        },

        deleteTask(taskId) {
            const task = this.tasks.find(t => t.id === taskId);
            if (!task) return;

            if (task.status === 'running') {
                this.$message.warning('请先停止运行中的任务');
                return;
            }

            this.$confirm('确定删除该任务吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.stopTask(taskId);
                this.tasks = this.tasks.filter(t => t.id !== taskId);
                this.taskControllers.delete(taskId);
                this.isTaskStopped.delete(taskId);
                this.isTaskPaused.delete(taskId);
                this.$message.success('任务已删除');
            }).catch(() => { });
        },

        clearCompletedTasks() {
            this.tasks = this.tasks.filter(t => t.status === 'running' || t.status === 'paused');
        },

        opencreatedanyuanlist() {
            this.opencreatedanyuanliststatus = true;
        },

        // ========== 失败账户汇总方法 ==========
        getFailedAccounts(task) {
            const failedUsers = [];
            if (!task.userDetails) return failedUsers;

            task.userDetails.forEach((user, idx) => {
                if (user.status === 'material_failed' || user.status === 'failed') {
                    // 获取错误详情
                    let errorDetail = '';
                    if (user.status === 'material_failed') {
                        errorDetail = user.steps[0].detail || '素材上传失败';
                    } else {
                        errorDetail = user.steps[4].detail || '搭建失败';
                    }
                    failedUsers.push({
                        user: user,
                        userIndex: idx,
                        errorDetail: errorDetail
                    });
                }
            });
            return failedUsers;
        },

        // 一键重试所有失败账户
        async retryAllFailedAccounts(taskId) {
            const task = this.tasks.find(t => t.id === taskId);
            if (!task) {
                this.$message.error('任务不存在');
                return;
            }

            const failedAccounts = this.getFailedAccounts(task);
            if (failedAccounts.length === 0) {
                this.$message.warning('没有需要重试的失败账户');
                return;
            }

            this.$confirm(`确定要重试 ${failedAccounts.length} 个失败账户吗？`, '批量重试', {
                confirmButtonText: '确定重试',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                task.retryingAll = true;
                let successCount = 0;
                let failCount = 0;

                // 显示加载提示
                const loading = this.$loading({
                    lock: true,
                    text: `正在批量重试 ${failedAccounts.length} 个账户...`,
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                try {
                    for (let i = 0; i < failedAccounts.length; i++) {
                        const failInfo = failedAccounts[i];
                        loading.text = `正在重试 ${i + 1}/${failedAccounts.length}: ${failInfo.user.accountName}`;

                        try {
                            await this.retryFailedAccount(taskId, failInfo.userIndex);
                            successCount++;
                            // 等待1秒避免请求过快
                            await this.delay(1000);
                        } catch (error) {
                            console.error(`重试账户 ${failInfo.user.accountName} 失败:`, error);
                            failCount++;
                        }
                    }

                    this.$message.success(`批量重试完成！成功: ${successCount}，失败: ${failCount}`);
                } catch (error) {
                    console.error('批量重试出错:', error);
                    this.$message.error('批量重试过程中发生错误');
                } finally {
                    loading.close();
                    task.retryingAll = false;
                }
            }).catch(() => {
                this.$message.info('已取消批量重试');
            });
        },

        // ========== 重试失败账户功能 ==========

        async retryFailedAccount(taskId, userIndex) {
            const task = this.tasks.find(t => t.id === taskId);
            if (!task) {
                this.$message.error('任务不存在');
                return;
            }

            const user = task.userDetails[userIndex];
            if (!user || (user.status !== 'material_failed' && user.status !== 'failed')) {
                this.$message.warning('该账户状态不是失败状态，无法重试');
                return;
            }

            // 获取快照等上下文
            const snapshot = task.configSnapshot;
            const account = snapshot.ids_list[userIndex];
            const existingPlanId = user.createdPlanId;
            const isMaterialFailed = user.status === 'material_failed';
            const shouldSkipPlanCreation = isMaterialFailed && existingPlanId;

            // 设置重试中状态
            this.$set(user, 'retrying', true);

            try {
                // 重置用户状态
                user.status = 'running';
                user.steps.forEach(step => {
                    step.status = 'wait';
                    step.detail = null;
                    if (step.name === '上传素材') {
                        step.progress = 0;
                    }
                });

                // 创建步骤更新器
                const setStep = (stepIndex, status, detail, progress) => {
                    this.setTaskStep(taskId, userIndex, stepIndex, status, detail, progress);
                };

                // 获取账户配置
                const ownerId = account.zzownerid;
                const adGroupCount = parseInt(snapshot.form.adgroupNumber) || 1;
                const creativePerGroup = parseInt(snapshot.form3.number) || 1;
                const totalCreatives = adGroupCount * creativePerGroup;

                // 重新初始化该账户的日志结构
                this.initGroupLogs(taskId, userIndex, adGroupCount);

                // 生成token
                const time1 = Math.floor(Date.now() / 1000);
                const sign = sha1(account.apiid + account.apikey + time1);
                const token = Base64.encode(`${account.ownerid},${account.apiid},${time1},${sign}`);

                const config = {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                };

                // ========== 步骤0: 准备并上传素材（仅当素材失败时需要重新上传） ==========
                if (isMaterialFailed) {
                    setStep(0, 'doing', '重新上传素材...', 0);

                    // 从快照获取文案列表
                    let textList = snapshot.titlesString
                        .split('\n')
                        .map(line => line.trim())
                        .filter(line => line);

                    // 从快照获取原始文件列表
                    let logoFiles = [...(snapshot.materialFiles.logo || [])];
                    let imageFiles = [...(snapshot.materialFiles.image || [])];
                    let coverFiles = [...(snapshot.materialFiles.cover || [])];
                    let videoFiles = [...(snapshot.materialFiles.video || [])];

                    // 混搭模式：打乱顺序
                    if (snapshot.mixminvalue) {
                        imageFiles = this.shuffleArray(imageFiles);
                        textList = this.shuffleArray(textList);
                    }

                    // 重置任务独立索引用于素材分配
                    if (!task.materialGlobalIndex) {
                        task.materialGlobalIndex = { logo: 0, image: 0, video: 0, cover: 0, text: 0 };
                    }

                    // 计算该账户需要的素材数量
                    let totalCreativesForAccount = adGroupCount * creativePerGroup;

                    // 收集需要上传的素材文件（去重后上传）
                    const neededLogoFiles = [];
                    const neededImageFiles = [];
                    const neededCoverFiles = [];
                    const neededVideoFiles = [];

                    for (let i = 0; i < totalCreativesForAccount; i++) {
                        if (logoFiles.length > 0) {
                            const idx = task.materialGlobalIndex.logo % logoFiles.length;
                            neededLogoFiles.push(logoFiles[idx]);
                            task.materialGlobalIndex.logo++;
                        }
                        if (imageFiles.length > 0) {
                            const idx = task.materialGlobalIndex.image % imageFiles.length;
                            neededImageFiles.push(imageFiles[idx]);
                            task.materialGlobalIndex.image++;
                        }
                        if (videoFiles.length > 0) {
                            const idx = task.materialGlobalIndex.video % videoFiles.length;
                            neededVideoFiles.push(videoFiles[idx]);
                            task.materialGlobalIndex.video++;
                        }
                        if (coverFiles.length > 0) {
                            const idx = task.materialGlobalIndex.cover % coverFiles.length;
                            neededCoverFiles.push(coverFiles[idx]);
                            task.materialGlobalIndex.cover++;
                        }
                    }

                    // 重置索引用于创意分配
                    task.materialGlobalIndex = { logo: 0, image: 0, video: 0, cover: 0, text: 0 };

                    // 去重
                    const uniqueLogoFiles = [...new Map(neededLogoFiles.map(f => [f.name, f])).values()];
                    const uniqueImageFiles = [...new Map(neededImageFiles.map(f => [f.name, f])).values()];
                    const uniqueVideoFiles = [...new Map(neededVideoFiles.map(f => [f.name, f])).values()];
                    const uniqueCoverFiles = [...new Map(neededCoverFiles.map(f => [f.name, f])).values()];

                    // 上传LOGO
                    const logoCodeMap = new Map();
                    for (let i = 0; i < uniqueLogoFiles.length; i++) {
                        const file = uniqueLogoFiles[i];
                        const progress = (i + 1) / uniqueLogoFiles.length;
                        setStep(0, 'doing', `上传LOGO ${i + 1}/${uniqueLogoFiles.length}: ${file.name}`, Math.round(progress * 20));
                        const code = await this.uploadSingleMaterial(file, 'logo', config, ownerId);
                        logoCodeMap.set(file.name, code);
                    }

                    // 上传图片
                    const imageCodeMap = new Map();
                    for (let i = 0; i < uniqueImageFiles.length; i++) {
                        const file = uniqueImageFiles[i];
                        const progress = 20 + (i + 1) / uniqueImageFiles.length * 30;
                        setStep(0, 'doing', `上传图片 ${i + 1}/${uniqueImageFiles.length}: ${file.name}`, Math.round(progress));
                        const code = await this.uploadSingleMaterial(file, 'image', config, ownerId);
                        imageCodeMap.set(file.name, code);
                    }

                    // 上传视频
                    const videoCodeMap = new Map();
                    for (let i = 0; i < uniqueVideoFiles.length; i++) {
                        const file = uniqueVideoFiles[i];
                        const progress = 50 + (i + 1) / uniqueVideoFiles.length * 30;
                        setStep(0, 'doing', `上传视频 ${i + 1}/${uniqueVideoFiles.length}: ${file.name}`, Math.round(progress));
                        const code = await this.uploadSingleMaterial(file, 'video', config, ownerId);
                        videoCodeMap.set(file.name, code);
                    }

                    // 上传封面
                    const coverCodeMap = new Map();
                    for (let i = 0; i < uniqueCoverFiles.length; i++) {
                        const file = uniqueCoverFiles[i];
                        const progress = 80 + (i + 1) / uniqueCoverFiles.length * 20;
                        setStep(0, 'doing', `上传封面 ${i + 1}/${uniqueCoverFiles.length}: ${file.name}`, Math.round(progress));
                        const code = await this.uploadSingleMaterial(file, 'cover', config, ownerId);
                        coverCodeMap.set(file.name, code);
                    }

                    setStep(0, 'success', `素材上传完成: LOGO ${uniqueLogoFiles.length}, 图片 ${uniqueImageFiles.length}, 视频 ${uniqueVideoFiles.length}, 封面 ${uniqueCoverFiles.length}`, 100);

                    // 重置索引用于创意分配
                    task.materialGlobalIndex = { logo: 0, image: 0, video: 0, cover: 0, text: 0 };

                    // 构建每个创意需要的素材ID列表
                    const creativeMaterialsList = [];
                    for (let i = 0; i < totalCreativesForAccount; i++) {
                        const creativeMaterials = {
                            logoId: null,
                            imageId: null,
                            videoId: null,
                            coverId: null,
                            text: null
                        };

                        if (logoFiles.length > 0) {
                            const idx = task.materialGlobalIndex.logo % logoFiles.length;
                            const file = logoFiles[idx];
                            creativeMaterials.logoId = logoCodeMap.get(file.name) || null;
                            task.materialGlobalIndex.logo++;
                        }

                        if (imageFiles.length > 0) {
                            const idx = task.materialGlobalIndex.image % imageFiles.length;
                            const file = imageFiles[idx];
                            creativeMaterials.imageId = imageCodeMap.get(file.name) || null;
                            task.materialGlobalIndex.image++;
                        }

                        if (videoFiles.length > 0) {
                            const idx = task.materialGlobalIndex.video % videoFiles.length;
                            const file = videoFiles[idx];
                            creativeMaterials.videoId = videoCodeMap.get(file.name) || null;
                            task.materialGlobalIndex.video++;
                        }

                        if (coverFiles.length > 0) {
                            const idx = task.materialGlobalIndex.cover % coverFiles.length;
                            const file = coverFiles[idx];
                            creativeMaterials.coverId = coverCodeMap.get(file.name) || null;
                            task.materialGlobalIndex.cover++;
                        }

                        if (textList.length > 0) {
                            const idx = task.materialGlobalIndex.text % textList.length;
                            creativeMaterials.text = textList[idx];
                            task.materialGlobalIndex.text++;
                        }

                        creativeMaterialsList.push(creativeMaterials);
                    }

                    // 存储素材列表供后续使用
                    task.creativeMaterialsListForRetry = creativeMaterialsList;
                } else {
                    // 非素材失败，跳过素材上传步骤
                    setStep(0, 'success', '素材无需重新上传', 100);
                }

                // ========== 步骤1: 创建或获取广告计划 (修复后逻辑) ==========
                let planId = existingPlanId;

                // 判断是否可以跳过创建计划 (素材失败 + 已有计划ID)
                if (shouldSkipPlanCreation && planId) {
                    setStep(1, 'success', `复用已有计划 ID: ${planId}`);
                }
                // 开启了“使用最新广告计划”开关，先查询最新计划
                else if (snapshot.form.useLatestPlan) {
                    setStep(1, 'doing', '获取最新广告计划...');
                    const latestPlanResult = await this.fetchLatestPlanId(account, token, config);
                    if (latestPlanResult.success) {
                        planId = latestPlanResult.planId;
                        user.createdPlanId = planId;
                        setStep(1, 'success', `使用最新计划 ID: ${planId}`);
                    } else {
                        // 获取不到，创建新计划
                        setStep(1, 'doing', '未找到最新计划，创建新计划...');
                        const newPlanData = {
                            planName: `${account.planName}_${snapshot.form.planName}${this.timesname()}${snapshot.form.campaign_name}_retry_${Date.now()}`,
                            deliveryMode: snapshot.form.delivery_mode,
                            extensionType: snapshot.form.extension_type,
                            dayLimit: snapshot.form.dayLimit,
                            ownerId: ownerId,
                        };
                        if (snapshot.form.dayLimit == 1) {
                            newPlanData.dayBudget = snapshot.form.dayBudget * 100;
                        }
                        const planRes = await this.axiosPostWithRetry('apis/v3/plan/add', qs.stringify(newPlanData), config, null);
                        if (planRes.data.code != 0) {
                            throw new Error(planRes.data.msg || '创建计划失败');
                        }
                        planId = planRes.data.data.planId;
                        user.createdPlanId = planId;
                        setStep(1, 'success', `计划创建成功 ID: ${planId}`);
                    }
                }
                // 未开启开关，直接创建新计划
                else {
                    setStep(1, 'doing', '创建新广告计划...');
                    const newPlanData = {
                        planName: `${account.planName}_${snapshot.form.planName}${this.timesname()}${snapshot.form.campaign_name}_retry_${Date.now()}`,
                        deliveryMode: snapshot.form.delivery_mode,
                        extensionType: snapshot.form.extension_type,
                        dayLimit: snapshot.form.dayLimit,
                        ownerId: ownerId,
                    };
                    if (snapshot.form.dayLimit == 1) {
                        newPlanData.dayBudget = snapshot.form.dayBudget * 100;
                    }
                    const planRes = await this.axiosPostWithRetry('apis/v3/plan/add', qs.stringify(newPlanData), config, null);
                    if (planRes.data.code != 0) {
                        throw new Error(planRes.data.msg || '创建计划失败');
                    }
                    planId = planRes.data.data.planId;
                    user.createdPlanId = planId;
                    setStep(1, 'success', `计划创建成功 ID: ${planId}`);
                }

                // 处理计划开关（仅在新建计划且开关为关闭时执行）
                const isNewPlanCreated = !shouldSkipPlanCreation || (snapshot.form.useLatestPlan && !existingPlanId);
                if (isNewPlanCreated && snapshot.form.switchPlan == 1) {
                    await axios.post('apis/v3/plan/status',
                        qs.stringify({ planIds: planId, status2: 1, ownerId: ownerId }),
                        config
                    );
                }

                // 获取落地页信息
                let pageInfo = null;
                if (snapshot.parsestatus) {
                    pageInfo = await this.queryWebsideId(token, ownerId);
                }

                // 获取素材列表
                const creativeMaterialsList = task.creativeMaterialsListForRetry || [];

                // ========== 步骤2: 创建广告组和创意 ==========
                let creativeIndex = 0;

                for (let g = 0; g < adGroupCount; g++) {
                    setStep(2, 'doing', `创建第${g + 1}/${adGroupCount}个广告组...`);

                    // 构建广告组数据
                    const groupData = {
                        planId: planId,
                        adGroupName: `${account.planName}_${snapshot.form.planName}${this.timesname()}${snapshot.form.campaign_name}_组${g + 1}${this.timesgetFun()}`,
                        extensionFlow: snapshot.form2.extensionFlow,
                        flowScene: snapshot.form2.flowScene,
                        extensionType: snapshot.form.extension_type,
                        targetId: account.targetid,
                        billingType: snapshot.form2.billingType,
                        price: snapshot.isoldgroupprice && account.price ?
                            account.price : snapshot.form2.price * 100,
                        dayLimit: 0,
                        ownerId: ownerId,
                    };

                    if (snapshot.timeLimit == 1) {
                        groupData.timeLimit = 1;
                        groupData.timeSet = snapshot.timeSet;
                    }

                    if ([6, 7, 9, 10, 11].includes(Number(snapshot.form2.flowScene))) {
                        groupData.advertiseType = snapshot.form2.dpaProductType;
                    }

                    if (snapshot.form2.flowScene == 6 && snapshot.form.extension_type == 3) {
                        groupData.linkDeskFlag = snapshot.form2.linkDeskFlag;
                    }

                    // 根据推广类型处理不同参数
                    if (snapshot.form.extension_type == 3) {
                        groupData.pageType = snapshot.form2.pageType;
                        groupData.pageUrl = account.url || '';
                        groupData.instantAppId = account.appid;
                        groupData.instantAppUrl = account.haplink;

                        if (pageInfo) {
                            groupData.pageUrl = pageInfo.pageUrl;
                            groupData.pageId = pageInfo.pageId;
                        }
                    } else if (snapshot.form.extension_type == 1) {
                        if (snapshot.form2.Deeplinktype == 0) {
                            groupData.pageType = snapshot.form2.pageType;
                            groupData.pageUrl = account.url || '';

                            if (pageInfo) {
                                groupData.pageUrl = pageInfo.pageUrl.trim();
                                groupData.pageId = pageInfo.pageId;
                            }

                            if (snapshot.form2.Deeplinkstatus) {
                                groupData.deepUrl = account.haplink;
                            }
                        } else if (snapshot.form2.Deeplinktype == 3) {
                            groupData.Deeplinktype = snapshot.form2.Deeplinktype;
                            groupData.pageType = snapshot.form2.pageType;
                            groupData.pageUrl = account.url || '';
                            groupData.instantAppId = account.appid;
                            groupData.instantAppUrl = account.haplink;

                            if (pageInfo) {
                                groupData.pageUrl = pageInfo.pageUrl.trim();
                                groupData.pageId = pageInfo.pageId;
                            }
                        }
                    } else if (snapshot.form.extension_type == 2) {
                        groupData.appId = account.appid;
                        groupData.pageType = snapshot.form2.pageType;
                        groupData.pageId = account.haplink;
                    }

                    // OCPC相关参数
                    if (snapshot.form2.billingType == 5) {
                        if (snapshot.form2.ocpcType == 47) {
                            groupData.targetROI = snapshot.form2.targetROI * 1000000;
                            groupData.ocpcType = snapshot.form2.ocpcType;
                            groupData.defaultSecondStage = snapshot.form2.defaultSecondStage;
                        } else {
                            groupData.ocpcPrice = snapshot.isoldgroupprice && account.ocpcPrice ?
                                account.ocpcPrice : snapshot.form2.ocpcPrice * 100;
                            groupData.ocpcType = snapshot.form2.ocpcType;
                            groupData.defaultSecondStage = snapshot.form2.defaultSecondStage;
                        }
                    }

                    // 深度转化
                    if (snapshot.form2.deepOcpcStatus) {
                        groupData.deepOcpcType = snapshot.form2.deepOcpcType;
                        groupData.deepOcpcPrice = Number(snapshot.form2.deepOcpcPrice) * 100;
                        groupData.ocpcOptmType = 1;
                    }

                    if (account.baoguangurl) {
                        groupData.exposeUrl = account.baoguangurl;
                    }

                    const groupRes = await this.axiosPostWithRetry('apis/v3/group/add', qs.stringify(groupData), config, null);

                    if (groupRes.data.code != 0) {
                        this.setGroupStep(taskId, userIndex, g, 'failed', groupRes.data.msg || '创建失败');
                        creativeIndex += creativePerGroup;
                        continue;
                    }

                    this.setGroupStep(taskId, userIndex, g, 'done', `ID: ${groupRes.data.data.adGroupId}`);

                    // 步骤3: 批量创建创意
                    setStep(3, 'doing', `为第${g + 1}/${adGroupCount}个广告组创建创意...`);

                    const addList = [];
                    for (let c = 0; c < creativePerGroup; c++) {
                        const materials = creativeMaterialsList[creativeIndex + c];
                        if (!materials) continue;

                        const creative = {
                            adGroupId: groupRes.data.data.adGroupId,
                            adPlanId: planId,
                            adName: account.planName + '_' + snapshot.form.planName + this.timesname() + snapshot.form.campaign_name + '_创意' + (c + 1) + '_' + Date.now(),
                            globalSpecId: snapshot.form3.type,
                            brandName: snapshot.form3.brandName,
                            buttonTxt: snapshot.form3.buttonTxt,
                            clickUrl: account.xiaoshuourl || '',
                            status: 0,
                            copywriter: materials.text || '默认文案'
                        };
                        if (snapshot.form2.flowScene == 6) {
  if (snapshot.enableDeriveVideo) {
    if (snapshot.form3.type == 1 && snapshot.selectedDeriveTemplates.length > 0) {
      creative.deriveTemplate = snapshot.selectedDeriveTemplates.join(',');
    }
    creative.dynamicCr = 1;
  }
}

                        if (materials.logoId) {
                            creative.brandLogoImgId = materials.logoId;
                        }
                        if (account.baoguangurl) {
                            creative.exposeUrl = account.baoguangurl;
                        }

                        const flowScene = Number(snapshot.form2.flowScene);
                        const creativeType = Number(snapshot.form3.type);

                        if ([60, 63].indexOf(creativeType) !== -1) {
                            if (materials.videoId) {
                                creative.videoMatIds = materials.videoId;
                            }
                            if (materials.coverId) {
                                if (flowScene == 11) {
                                    creative.videoBgImgId = materials.coverId;
                                } else if (flowScene != 12 && flowScene != 11) {
                                    creative.videoImgId = materials.coverId;
                                } else if (flowScene == 12 && creativeType == 60 && snapshot.form.extension_type == 1) {
                                    creative.videoImgId = materials.coverId;
                                } else if (flowScene == 12 && creativeType == 63 && snapshot.form.extension_type == 1) {
                                    creative.videoBgImgId = materials.coverId;
                                }
                            }
                        } else if ([1, 20, 30, 50, 71].indexOf(creativeType) !== -1) {
                            if (materials.imageId) {
                                creative.imgMatIds = materials.imageId;
                            }
                        } else if ([5, 34].indexOf(creativeType) !== -1) {
                            if (materials.imageId) {
                                creative.imgMatIds = materials.imageId;
                            }
                        }

                        if (snapshot.form2.flowScene == 6 && snapshot.form2.extensionFlow == 2) {
                            if (account.creativityid) {
                                creative.creativityId = account.creativityid;
                            }
                        }

                        addList.push(creative);
                    }

                    // 批量创建创意
                    if (addList.length > 0) {
                        const batchData = {
                            ownerId: ownerId,
                            addList: addList,
                            immediatelyRefresh: 0
                        };

                        const res = await this.axiosPostWithRetry('apis/v3/ad/batch',
                            qs.stringify(batchData, { allowDots: true }),
                            config,
                            null
                        );

                        if (res.data.code == 0) {
                            const createdIds = res.data.data || [];
                            for (let c = 0; c < addList.length; c++) {
                                this.setCreativeStepInGroup(taskId, userIndex, g, c, 1, 'success',
                                    '创意创建成功 ID: ' + (createdIds[c] || ''));
                            }
                        } else {
                            const errorMsg = res.data.msg || '批量创建创意失败';
                            for (let c = 0; c < addList.length; c++) {
                                this.setCreativeStepInGroup(taskId, userIndex, g, c, 1, 'error', errorMsg);
                            }
                            throw new Error(errorMsg);
                        }
                    }

                    creativeIndex += creativePerGroup;

                    if (g < adGroupCount - 1) {
                        await this.delay(this.groupDelay);
                    }
                }

                // 更新最终状态
                setStep(2, 'success', `所有广告组创建成功，共创建 ${adGroupCount} 个广告组`);
                setStep(3, 'success', `广告组创建完成，共创建 ${adGroupCount} 个广告组，每个包含 ${creativePerGroup} 个创意`);
                setStep(4, 'success', '账户搭建完成');

                user.status = 'done';

                // 清理重试临时数据
                delete task.creativeMaterialsListForRetry;

                this.$message.success(`账户 ${user.accountName} 重试成功！`);

            } catch (error) {
                console.error(`重试账户 ${user.accountName} 失败:`, error);
                user.status = 'material_failed';
                user.steps[0].status = 'error';
                user.steps[0].detail = `重试失败: ${error.message || '未知错误'}`;
                this.$message.error(`账户 ${user.accountName} 重试失败: ${error.message || '未知错误'}`);
                throw error;
            } finally {
                this.$set(user, 'retrying', false);
            }
        },

        toggleGroupExpand(user, userIndex) {
            this.$set(user, 'groupExpanded', !user.groupExpanded);
        },

        toggleCreativeExpand(group, groupIndex) {
            this.$set(group, 'creativeExpanded', !group.creativeExpanded);
        },

        getGroupSuccessCount(groupDetails) {
            return groupDetails.filter(g => g.status === 'done').length;
        },

        getGroupFailCount(groupDetails) {
            return groupDetails.filter(g => g.status === 'failed').length;
        },

        getCreativeSuccessCount(creatives) {
            return creatives.filter(c => c.status === 'done').length;
        },

        getCreativeFailCount(creatives) {
            return creatives.filter(c => c.status === 'failed').length;
        },

        getCreativeTotalCount(user) {
            if (!user.groupDetails) return 0;
            return user.groupDetails.reduce((total, group) => {
                return total + (group.creatives ? group.creatives.length : 0);
            }, 0);
        },

        formatDetail(detail) {
            if (!detail) return '';
            if (typeof detail === 'string') return detail;
            return JSON.stringify(detail);
        },

        delay(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },

        getTaskStatusType(status) {
            const map = {
                'waiting': 'info',
                'running': 'warning',
                'paused': 'info',
                'done': 'success',
                'failed': 'danger',
                'stopped': 'info',
                'error': 'danger'
            };
            return map[status] || 'info';
        },

        getTaskStatusText(status) {
            const map = {
                'waiting': '等待中',
                'running': '运行中',
                'paused': '已暂停',
                'done': '已完成',
                'failed': '失败',
                'stopped': '已停止',
                'error': '错误'
            };
            return map[status] || status;
        },

        getUserStatusType(status) {
            const map = {
                'waiting': 'info',
                'running': 'warning',
                'done': 'success',
                'failed': 'danger',
                'stopped': 'info',
                'material_failed': 'danger'
            };
            return map[status] || 'info';
        },

        getUserStatusText(status) {
            const map = {
                'waiting': '等待',
                'running': '进行中',
                'done': '成功',
                'failed': '失败',
                'stopped': '停止',
                'material_failed': '素材失败'
            };
            return map[status] || status;
        },

        getGroupStatusType(status) {
            const map = {
                'waiting': 'info',
                'running': 'warning',
                'done': 'success',
                'failed': 'danger'
            };
            return map[status] || 'info';
        },

        getGroupStatusText(status) {
            const map = {
                'waiting': '等待',
                'running': '进行中',
                'done': '成功',
                'failed': '失败'
            };
            return map[status] || status;
        },

        getCreativeStatusType(status) {
            const map = {
                'waiting': 'info',
                'running': 'warning',
                'done': 'success',
                'failed': 'danger'
            };
            return map[status] || 'info';
        },

        getCreativeStatusText(status) {
            const map = {
                'waiting': '等待',
                'running': '进行中',
                'done': '成功',
                'failed': '失败'
            };
            return map[status] || status;
        },

        getStepStatusType(status) {
            const map = {
                'wait': 'info',
                'doing': 'warning',
                'success': 'success',
                'error': 'danger'
            };
            return map[status] || 'info';
        },

        getStepStatusText(status) {
            const map = {
                'wait': '等待',
                'doing': '进行中',
                'success': '成功',
                'error': '失败'
            };
            return map[status] || status;
        },

        getProgressStatus(status) {
            const map = {
                'done': 'success',
                'failed': 'exception',
                'error': 'exception'
            };
            return map[status] || null;
        },

        getStepStatus(status) {
            const map = {
                'wait': 'wait',
                'doing': 'process',
                'success': 'success',
                'error': 'error'
            };
            return map[status] || 'wait';
        },

        async axiosPostWithRetry(url, data, config, signal, maxRetries = 3) {
            for (let retry = 0; retry < maxRetries; retry++) {
                try {
                    return await axios.post(url, data, { ...config, signal });
                } catch (error) {
                    if (retry === maxRetries - 1) throw error;
                    if (error.name === 'AbortError') throw error;
                    await this.delay(2000 * (retry + 1));
                }
            }
        },

        // ========== 素材处理方法 ==========

        txhandleFileChange(file, fileList) {
            if (file.status !== 'ready') return;
            // 保存原始文件对象到 materialFileList
            this.materialFileList.logo = fileList.map(item => item.raw).filter(f => f);
            this.txfileList = fileList.map(item => ({
                ...item,
                url: item.url || URL.createObjectURL(item.raw),
                file: item
            }));
            console.log('LOGO素材已更新，数量:', this.materialFileList.logo.length);
        },

        tphandleFileChange(file, fileList) {
            if (file.status !== 'ready') return;
            this.materialFileList.image = fileList.map(item => item.raw).filter(f => f);
            this.tpfileList = fileList.map(item => ({
                ...item,
                url: item.url || URL.createObjectURL(item.raw),
                file: item
            }));
            console.log('图片素材已更新，数量:', this.materialFileList.image.length);
        },


        videotphandleFileChange(file, fileList) {
            if (file.status !== 'ready') return;

            this.materialFileList.cover = fileList.map(item => item.raw).filter(f => f);

            if (this.replacingIndex !== null && this.replacingIndex !== undefined) {
                this.videotpfileList.splice(this.replacingIndex, 1, {
                    ...file,
                    url: file.url || URL.createObjectURL(file.raw),
                    file: file,
                    uid: file.uid || Date.now()
                });
                this.replacingIndex = null;
            } else {
                this.videotpfileList.push({
                    ...file,
                    url: file.url || URL.createObjectURL(file.raw),
                    file: file,
                    uid: file.uid || Date.now()
                });
            }
            console.log('封面素材已更新，数量:', this.materialFileList.cover.length);
        },

        videohandleFileChange(file, fileList) {
            if (file.status !== 'ready') return;

            this.materialFileList.video = fileList.map(item => item.raw).filter(f => f);
            this.videofileList = fileList.map(item => ({
                ...item,
                url: item.url || URL.createObjectURL(item.raw),
                file: item,
                selected: false,
                coverExtracted: false
            }));
            console.log('视频素材已更新，数量:', this.materialFileList.video.length);
        },// 批量处理视频抽帧（等所有视频加载完成后再抽帧）
        async batchExtractFramesForVideos(videoFiles) {
            if (!this.autoGenerateCover || !videoFiles || videoFiles.length === 0) {
                return [];
            }

            console.log('开始批量抽帧，共 ' + videoFiles.length + ' 个视频...');

            // 显示加载提示
            const loading = this.$loading({
                lock: true,
                text: '正在加载 ' + videoFiles.length + ' 个视频并提取封面...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            try {
                // 第一步：预加载所有视频的元数据
                const videoElements = [];
                for (let i = 0; i < videoFiles.length; i++) {
                    const file = videoFiles[i];
                    const videoItem = file.raw || file.file || file;

                    if (!videoItem || !videoItem.type.startsWith('video/')) {
                        console.warn('文件 ' + file.name + ' 不是视频格式');
                        continue;
                    }

                    const video = document.createElement('video');
                    video.preload = 'metadata';
                    video.muted = true;

                    const videoURL = URL.createObjectURL(videoItem);
                    video.src = videoURL;

                    // 等待视频元数据加载完成
                    await new Promise(function (resolve, reject) {
                        var timeout = setTimeout(function () {
                            reject(new Error('视频 ' + file.name + ' 加载超时'));
                        }, 15000);

                        video.addEventListener('loadedmetadata', function () {
                            clearTimeout(timeout);
                            resolve();
                        }, { once: true });

                        video.addEventListener('error', function () {
                            clearTimeout(timeout);
                            reject(new Error('视频 ' + file.name + ' 加载失败'));
                        }, { once: true });
                    });

                    videoElements.push({
                        file: file,
                        video: video,
                        url: videoURL,
                        videoItem: videoItem
                    });
                }

                // 第二步：批量抽帧
                console.log('所有视频加载完成，开始抽帧...');
                loading.text = '正在提取 ' + videoElements.length + ' 个视频的封面...';

                const coverResults = [];
                for (var i = 0; i < videoElements.length; i++) {
                    var item = videoElements[i];

                    loading.text = '正在提取封面 ' + (i + 1) + '/' + videoElements.length + ': ' + item.file.name;

                    try {
                        var frameBlob = await this.extractSingleFrame(item.video, item.file, i);
                        if (frameBlob) {
                            coverResults.push({
                                frameFile: frameBlob,
                                videoIndex: i,
                                videoName: item.file.name,
                                videoFile: item.videoItem
                            });
                        }
                    } catch (error) {
                        console.error('视频 "' + item.file.name + '" 抽帧失败:', error);
                    } finally {
                        // 清理视频资源
                        item.video.pause();
                        item.video.src = '';
                        item.video.load();
                        URL.revokeObjectURL(item.url);
                    }

                    // 每抽一帧稍微延迟，避免内存占用过高
                    if (i < videoElements.length - 1) {
                        await this.delay(100);
                    }
                }

                console.log('抽帧完成，成功 ' + coverResults.length + '/' + videoElements.length + ' 个');
                return coverResults;

            } catch (error) {
                console.error('批量抽帧失败:', error);
                this.$message.error('视频抽帧失败: ' + error.message);
                return [];
            } finally {
                loading.close();
            }
        },

        // 提取单帧画面
        async extractSingleFrame(video, file, index) {
            var self = this;
            return new Promise(function (resolve, reject) {
                var canvas = document.createElement('canvas');
                var ctx = canvas.getContext('2d');

                // 判断是否为联盟流量+激励视频场景
                const isUnionIncentiveVideo = (self.form2.extensionFlow == '3' && self.form2.flowScene == 11);

                // 判断是否为激励视频场景（联盟流量的激励视频）
                const isIncentiveVideoScene = (self.form2.flowScene == 11);

                if (isUnionIncentiveVideo || isIncentiveVideoScene) {
                    // 联盟流量+激励视频场景：强制使用720x1280竖版封面
                    canvas.width = 720;
                    canvas.height = 1280;
                } else {
                    // 其他场景：使用视频原始尺寸
                    canvas.width = video.videoWidth || 640;
                    canvas.height = video.videoHeight || 360;
                }

                // 跳转到第1秒
                video.currentTime = 1;

                var seekHandler = function () {
                    try {
                        if (isUnionIncentiveVideo || isIncentiveVideoScene) {
                            // 激励视频场景：将横版视频居中裁剪为720x1280竖版
                            var targetWidth = 720;
                            var targetHeight = 1280;
                            var videoRatio = video.videoWidth / video.videoHeight;
                            var targetRatio = targetWidth / targetHeight;

                            var drawWidth, drawHeight, dx, dy;

                            if (videoRatio > targetRatio) {
                                // 视频更宽，以高度为准，左右裁剪
                                drawHeight = targetHeight;
                                drawWidth = drawHeight * videoRatio;
                                dx = (targetWidth - drawWidth) / 2;
                                dy = 0;
                            } else {
                                // 视频更高，以宽度为准，上下裁剪
                                drawWidth = targetWidth;
                                drawHeight = drawWidth / videoRatio;
                                dx = 0;
                                dy = (targetHeight - drawHeight) / 2;
                            }

                            ctx.drawImage(video, dx, dy, drawWidth, drawHeight);
                        } else {
                            // 其他场景：正常绘制
                            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                        }

                        // 转换为 Blob
                        canvas.toBlob(function (blob) {
                            if (!blob) {
                                reject(new Error('Canvas转换失败'));
                                return;
                            }

                            var frameFile = new File(
                                [blob],
                                '封面_' + file.name.replace(/\.[^/.]+$/, '') + '.jpg',
                                { type: 'image/jpeg' }
                            );

                            resolve(frameFile);
                        }, 'image/jpeg', 0.85);

                    } catch (error) {
                        reject(error);
                    } finally {
                        video.removeEventListener('seeked', seekHandler);
                    }
                };

                video.addEventListener('seeked', seekHandler, { once: true });

                // 设置超时
                setTimeout(function () {
                    video.removeEventListener('seeked', seekHandler);
                    reject(new Error('抽帧超时'));
                }, 10000);
            });
        },

        // 手动触发批量抽帧（可在选择素材后调用）
        async manualExtractFrames() {
            if (!this.videofileList || this.videofileList.length === 0) {
                this.$message.warning('没有视频需要抽帧');
                return;
            }

            var self = this;
            var loading = this.$loading({
                lock: true,
                text: '正在处理 ' + this.videofileList.length + ' 个视频...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            try {
                var results = await this.batchExtractFramesForVideos(this.videofileList);

                // 将抽帧得到的封面添加到封面列表
                for (var i = 0; i < results.length; i++) {
                    var result = results[i];
                    var coverFileItem = {
                        uid: 'frame_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9),
                        name: result.frameFile.name,
                        size: result.frameFile.size,
                        type: result.frameFile.type,
                        raw: result.frameFile,
                        url: URL.createObjectURL(result.frameFile),
                        status: 'success',
                        isFrame: true,
                        sourceVideoIndex: result.videoIndex,
                        sourceVideoName: result.videoName
                    };

                    // 添加到界面显示
                    this.videotpfileList.push(coverFileItem);

                    // 【关键修复】同时添加到 materialFileList.cover，这样上传时才能获取到
                    this.materialFileList.cover.push(result.frameFile);

                    // 标记视频已抽帧
                    if (this.videofileList[result.videoIndex]) {
                        this.$set(this.videofileList[result.videoIndex], 'coverExtracted', true);
                    }
                }

                this.$message.success('成功提取 ' + results.length + ' 个视频封面');
                this.$forceUpdate();

            } catch (error) {
                console.error('批量抽帧失败:', error);
                this.$message.error('抽帧失败: ' + error.message);
            } finally {
                loading.close();
            }
        },

        handleRemove(file) {
            const index = this.txfileList.findIndex(item => item.uid === file.uid);
            if (index !== -1) {
                this.txfileList.splice(index, 1);
                this.txfileCode = [];
                // 同步更新 materialFileList
                this.materialFileList.logo = this.txfileList.map(item => item.raw || item.file).filter(f => f);
            }
        },

        tphandleRemove(file) {
            const index = this.tpfileList.findIndex(item => item.uid === file.uid);
            if (index !== -1) {
                this.tpfileList.splice(index, 1);
                this.tpfileListcode = [];
                // 同步更新 materialFileList
                this.materialFileList.image = this.tpfileList.map(item => item.raw || item.file).filter(f => f);
            }
        },

        videotphandleRemove(file) {
            const index = this.videotpfileList.findIndex(item => item.uid === file.uid);
            if (index !== -1) {
                this.videotpfileList.splice(index, 1);
                this.videotpfileListcode = [];
                // 同步更新 materialFileList
                this.materialFileList.cover = this.videotpfileList.map(item => item.raw || item.file).filter(f => f);
            }
        },

        handleRemove2(file) {
            const index = this.videofileList.findIndex(item => item.uid === file.uid);
            if (index !== -1) {
                this.videofileList.splice(index, 1);
                this.videofileListcode = [];
                // 同步更新 materialFileList
                this.materialFileList.video = this.videofileList.map(item => item.raw || item.file).filter(f => f);
            }
        },

        handleReplaceFile(file, index) {
            this.replacingIndex = index;
            this.$refs.uploadCover.$el.querySelector('.el-upload--picture-card').click();
        },

        toggleSelect(file) {
            this.$set(file, 'selected', !file.selected);
        },

        deleteSelected() {
            this.videofileList = this.videofileList.filter(file => !file.selected);
        },

        clearMaterial(type) {
            this.$confirm('确定清空吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                switch (type) {
                    case 'logo':
                        this.txfileList = [];
                        this.txfileCode = [];
                        this.materialFileList.logo = [];  // 同步清空
                        break;
                    case 'image':
                        this.tpfileList = [];
                        this.tpfileListcode = [];
                        this.materialFileList.image = [];  // 同步清空
                        break;
                    case 'cover':
                        this.videotpfileList = [];
                        this.videotpfileListcode = [];
                        this.materialFileList.cover = [];  // 同步清空
                        break;
                    case 'video':
                        this.videofileList = [];
                        this.videofileListcode = [];
                        this.materialFileList.video = [];  // 同步清空
                        break;
                }
                this.$message.success('清空成功');
                // 同步完成后输出日志
                this.syncMaterialFileLists();
            }).catch(() => { });
        },

        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },

        tphandlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },

        videotphandlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },

        handleAutoCoverChange(value) {
            console.log('自动生成封面:', value);
        },

        async extractFrameForNewVideo(file) {
            if (!this.autoGenerateCover) return;

            try {
                const fileIndex = this.videofileList.findIndex(item => item.uid === file.uid);
                if (fileIndex === -1) return;

                const frameResult = await this.extractFrameFromVideoFile(file, fileIndex);
                if (frameResult) {
                    this.addFrameToCoverList(frameResult, fileIndex);
                    this.$message.success(`视频 "${file.name}" 抽帧成功`);
                }
            } catch (error) {
                console.warn(`视频 "${file.name}" 抽帧失败:`, error);
                this.$message.warning(`视频 "${file.name}" 抽帧失败`);
            }
        },

        async extractFrameFromVideoFile(videoItem, index) {
            var self = this;
            return new Promise((resolve, reject) => {
                const video = document.createElement('video');
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

                const videoFile = videoItem.raw;
                if (!videoFile || !videoFile.type.startsWith('video/')) {
                    reject(new Error('不是有效的视频文件'));
                    return;
                }

                // 判断是否为联盟流量+激励视频场景
                const isUnionIncentiveVideo = (self.form2.extensionFlow == '3' && self.form2.flowScene == 11);
                const isIncentiveVideoScene = (self.form2.flowScene == 11);

                const videoURL = URL.createObjectURL(videoFile);
                video.src = videoURL;
                video.muted = true;
                video.crossOrigin = 'anonymous';

                video.addEventListener('loadeddata', () => {
                    if (isUnionIncentiveVideo || isIncentiveVideoScene) {
                        // 联盟流量+激励视频场景：强制使用720x1280
                        canvas.width = 720;
                        canvas.height = 1280;
                    } else {
                        canvas.width = video.videoWidth || 640;
                        canvas.height = video.videoHeight || 360;
                    }
                    video.currentTime = 1;
                });

                video.addEventListener('seeked', () => {
                    try {
                        if (isUnionIncentiveVideo || isIncentiveVideoScene) {
                            // 激励视频场景：将横版视频居中裁剪为720x1280竖版
                            const targetWidth = 720;
                            const targetHeight = 1280;
                            const videoRatio = video.videoWidth / video.videoHeight;

                            let drawWidth, drawHeight, dx, dy;

                            if (videoRatio > (targetWidth / targetHeight)) {
                                // 视频更宽，以高度为准，左右裁剪
                                drawHeight = targetHeight;
                                drawWidth = drawHeight * videoRatio;
                                dx = (targetWidth - drawWidth) / 2;
                                dy = 0;
                            } else {
                                // 视频更高，以宽度为准，上下裁剪
                                drawWidth = targetWidth;
                                drawHeight = drawWidth / videoRatio;
                                dx = 0;
                                dy = (targetHeight - drawHeight) / 2;
                            }

                            ctx.drawImage(video, dx, dy, drawWidth, drawHeight);
                        } else {
                            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                        }

                        canvas.toBlob((blob) => {
                            if (!blob) {
                                reject(new Error('Canvas转换失败'));
                                return;
                            }

                            const frameFile = new File([blob],
                                `封面_${videoFile.name.replace(/\.[^/.]+$/, '')}.jpg`,
                                { type: 'image/jpeg' }
                            );

                            URL.revokeObjectURL(videoURL);
                            resolve({
                                frameFile: frameFile,
                                videoIndex: index,
                                videoName: videoFile.name
                            });
                        }, 'image/jpeg', 0.85);

                    } catch (error) {
                        URL.revokeObjectURL(videoURL);
                        reject(error);
                    }
                });

                video.addEventListener('error', () => {
                    URL.revokeObjectURL(videoURL);
                    reject(new Error('视频加载失败'));
                });

                setTimeout(() => {
                    URL.revokeObjectURL(videoURL);
                    reject(new Error('视频帧提取超时'));
                }, 10000);
            });
        },

        addFrameToCoverList(frameResult, videoIndex) {
            const { frameFile, videoName } = frameResult;

            const coverFileItem = {
                uid: `frame_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
                name: `封面_${videoName}.jpg`,
                size: frameFile.size,
                type: frameFile.type,
                raw: frameFile,
                url: URL.createObjectURL(frameFile),
                status: 'success',
                isFrame: true,
                sourceVideoIndex: videoIndex,
                sourceVideoName: videoName
            };

            this.videotpfileList.push(coverFileItem);
            this.$forceUpdate();
        },

        shuffleArray(array) {
            const newArray = [...array];
            for (let i = newArray.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
            }
            return newArray;
        },

        timesname() {
            const now = new Date();
            const formattedDate = `${now.getFullYear()}/${String(now.getMonth() + 1).padStart(2, '0')}/${String(now.getDate()).padStart(2, '0')}`;
            const formattedTime = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`;
            return `_${formattedDate}_${formattedTime}`;
        },

        timesgetFun() {
            return Date.now();
        },

        getBuildIndexForAccount(index, listLength) {
            if (!listLength) return 0;
            return index % listLength;
        },

        // ========== 其他业务方法 ==========

        useLatestPlanChange(value) {
            console.log('使用最新广告计划:', value);
        },

        extensionTypeChange(value) {
            const item = this.extensionType_goal_group.find(item => item.value == value);
            this.form.planName = item ? item.label : '';

            this.form2.ocpcTypeoptions = this.ocpcTypeoptions.filter(item => item.index ==
                (value === 2 ? 2 : value === 3 ? 3 : 1));

            if (value == 2) {
                this.form2.flowScene_list = [
                    { value: "1", list: [{ value: "1", label: "全流量场景" }] },
                    { value: "2", list: [{ value: "13", label: "展示优选" }, { value: "6", label: "信息流" }] },
                    {
                        value: "3", list: [
                            { value: "12", label: "联盟通投" },
                            { value: "7", label: "Banner" },
                            { value: "9", label: "插屏" },
                            { value: "10", label: "原生" },
                            { value: "11", label: "激励视频" }
                        ]
                    }
                ];
            }
        },

        changeextensionFlow(value) {
            const flowSceneList = this.form2.flowScene_list.find(item => item.value == value);
            this.form2.flowScene_choose_list = flowSceneList ? flowSceneList.list : [];

            if (value == "1") {
                this.form2.flowScene = '1';
            } else if (value == "2") {
                this.form2.flowScene = '13';
            } else if (value == "3") {
                this.form2.flowScene = '12';
            }
        },

        flowScenechange(value) {
            let res = this.styleCategorieslist.filter(item => item.value == value);
            if (res.length > 0) {
                this.styleCategories = res[0].list;
            } else {
                this.styleCategories = this.styleCategorieslist[0].list;
            }
        },

        pageTypechang(value) {
            this.form2.pageTypelabel = this.pageType_list.find(item => item.value == value) ? this.pageType_list.find(item => item.value == value).label : '';
            this.form2.pageType = value;
        },

        isoldgrouppriceChang(value) {
            console.log('使用最新出价:', value);
        },

        parsestatusChang(value) {
            console.log('自动获取落地页:', value);
        },

        handleInput() {
            this.form3.title = this.titlesString
                .split('\n')
                .map(line => line.trim())
                .filter(line => line);

            this.linesWithLimitError = this.form3.title
                .filter(line => line.length < 1 || line.length > 35);
        },

        form3Numberchange(value) {
            console.log('创意搭建数量:', value);
        },
        form4Numberchange(value) {
            console.log('创意搭建数量:', value);
        },

        openStyleDialog() {
            this.createTypedialog = true;
        },

        selectStyle(style) {
            this.selectedStyle = style.value;

            let materialType;
            switch (Number(style.value)) {
                case 63:
                    materialType = '竖版视频';
                    break;
                case 60:
                    materialType = '横版视频';
                    break;
                case 20:
                    materialType = '横版小图';
                    break;
                case 1:
                    materialType = '横版大图';
                    break;
                case 50:
                    materialType = '竖版大图';
                    break;
                case 30:
                    materialType = '横版组图';
                    break;
                case 71:
                    materialType = '图标大图';
                    break;
                case 5:
                    materialType = '开屏横图';
                    break;
                case 34:
                    materialType = '开屏竖图';
                    break;
                default:
                    materialType = '';
            }
            this.material_type = materialType;
            this.selectedStylelabel = style.label;
        },

        CreativeTypechang() {
            this.form3.type = this.selectedStyle;
            this.createTypedialog = false;
        },

        handleMaterialsdialog() {
            if (!this.form3.type) {
                this.$message.warning('请先选择创意样式');
                return;
            }

            // 统计各类素材数量
            this.materialTotalCount = {
                logo: this.txfileList.length,
                image: this.tpfileList.length,
                video: this.videofileList.length,
                cover: this.videotpfileList.length,
                text: this.titlesString.split('\n').filter(line => line.trim()).length
            };

            this.creativeMaterials = true;
        }, resetMaterialGlobalIndex() {
            // 每次开始新任务时重置全局索引
            this.materialGlobalIndex = {
                logo: 0,
                image: 0,
                video: 0,
                cover: 0,
                text: 0
            };
            this.currentTaskMaterialStartIndex = { ...this.materialGlobalIndex };
        }, getMaterialFileByGlobalIndex(type, fileList) {
            if (!fileList || fileList.length === 0) return null;

            var index;
            switch (type) {
                case 'logo':
                    index = this.materialGlobalIndex.logo % fileList.length;
                    this.materialGlobalIndex.logo = this.materialGlobalIndex.logo + 1;
                    break;
                case 'image':
                    index = this.materialGlobalIndex.image % fileList.length;
                    this.materialGlobalIndex.image = this.materialGlobalIndex.image + 1;
                    break;
                case 'video':
                    index = this.materialGlobalIndex.video % fileList.length;
                    this.materialGlobalIndex.video = this.materialGlobalIndex.video + 1;
                    break;
                case 'cover':
                    index = this.materialGlobalIndex.cover % fileList.length;
                    this.materialGlobalIndex.cover = this.materialGlobalIndex.cover + 1;
                    break;
                case 'text':
                    index = this.materialGlobalIndex.text % fileList.length;
                    this.materialGlobalIndex.text = this.materialGlobalIndex.text + 1;
                    break;
                default:
                    index = 0;
            }

            return {
                index: index,
                file: fileList[index],
                globalIndex: index
            };
        }, async uploadSingleMaterial(file, type, config, ownerId) {
            const materialId = this.addUploadingMaterial(file.name, type);

            return new Promise((resolve, reject) => {
                const formData = new FormData();
                formData.append('files', file);

                // 判断是否为联盟流量+激励视频场景
                const isUnionIncentiveVideo = (this.form2.extensionFlow == '3' && this.form2.flowScene == 11);

                // 确定 matSpecId
                let matSpecId = this.form3.type;

                // 激励视频场景下，封面上传使用竖版视频规格 63
                if (isUnionIncentiveVideo && type === 'cover') {
                    matSpecId = 63;
                }

                formData.append('matSpecId', matSpecId);
                formData.append('ownerId', ownerId);

                if (type === 'logo') {
                    formData.append('picType', 'brandLogo');
                } else if (type === 'image') {
                    formData.append('picType', 'imgs');
                } else if (type === 'cover') {
                    formData.append('picType', 'videoImg');
                }

                axios.post('apis/v3/creative/material/communal/upload', formData, {
                    ...config,
                    onUploadProgress: (progressEvent) => {
                        if (progressEvent.total) {
                            const percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                            this.updateUploadProgress(materialId, percent, 'uploading', `上传中 ${percent}%`);
                        }
                    }
                }).then(res => {
                    if (res.data.code === 0 && res.data.data && res.data.data.id) {
                        this.updateUploadProgress(materialId, 100, 'success', '上传成功');
                        setTimeout(() => this.removeUploadingMaterial(materialId), 2000);
                        resolve(res.data.data.id);
                    } else {
                        const errMsg = res.data.msg || '上传失败';
                        this.updateUploadProgress(materialId, 0, 'error', errMsg);
                        reject(new Error(errMsg));
                    }
                }).catch(error => {
                    const errMsg = error.message || '上传失败';
                    this.updateUploadProgress(materialId, 0, 'error', errMsg);
                    reject(new Error(errMsg));
                });
            });
        }, saveMaterialGlobalIndex() {
            localStorage.setItem('oppo_material_global_index', JSON.stringify(this.materialGlobalIndex));
        },
        getAccountMaterialRange(accountIndex, totalAccounts) {
            // 每个账户分配多少个素材
            const logoPerAccount = Math.ceil(this.materialTotalCount.logo / totalAccounts);
            const imagePerAccount = Math.ceil(this.materialTotalCount.image / totalAccounts);
            const videoPerAccount = Math.ceil(this.materialTotalCount.video / totalAccounts);
            const coverPerAccount = Math.ceil(this.materialTotalCount.cover / totalAccounts);
            const textPerAccount = Math.ceil(this.materialTotalCount.text / totalAccounts);

            return {
                logoStart: accountIndex * logoPerAccount,
                logoEnd: Math.min((accountIndex + 1) * logoPerAccount, this.materialTotalCount.logo),
                imageStart: accountIndex * imagePerAccount,
                imageEnd: Math.min((accountIndex + 1) * imagePerAccount, this.materialTotalCount.image),
                videoStart: accountIndex * videoPerAccount,
                videoEnd: Math.min((accountIndex + 1) * videoPerAccount, this.materialTotalCount.video),
                coverStart: accountIndex * coverPerAccount,
                coverEnd: Math.min((accountIndex + 1) * coverPerAccount, this.materialTotalCount.cover),
                textStart: accountIndex * textPerAccount,
                textEnd: Math.min((accountIndex + 1) * textPerAccount, this.materialTotalCount.text)
            };
        },

        // 新增：从全局索引获取素材（轮询，支持断点续传）
        getMaterialByGlobalIndex(type, materialList, useGlobalIndex) {
            if (!materialList || materialList.length === 0) return null;

            var index;
            if (useGlobalIndex) {
                // 使用全局索引（轮询分配）
                switch (type) {
                    case 'logo':
                        index = this.materialGlobalIndex.logo % materialList.length;
                        this.materialGlobalIndex.logo = this.materialGlobalIndex.logo + 1;
                        break;
                    case 'image':
                        index = this.materialGlobalIndex.image % materialList.length;
                        this.materialGlobalIndex.image = this.materialGlobalIndex.image + 1;
                        break;
                    case 'video':
                        index = this.materialGlobalIndex.video % materialList.length;
                        this.materialGlobalIndex.video = this.materialGlobalIndex.video + 1;
                        break;
                    case 'cover':
                        index = this.materialGlobalIndex.cover % materialList.length;
                        this.materialGlobalIndex.cover = this.materialGlobalIndex.cover + 1;
                        break;
                    case 'text':
                        index = this.materialGlobalIndex.text % materialList.length;
                        this.materialGlobalIndex.text = this.materialGlobalIndex.text + 1;
                        break;
                    default:
                        index = 0;
                }
            } else {
                // 使用账户专属范围（分段分配）
                index = 0;
            }

            return {
                index: index,
                value: materialList[index],
                globalIndex: index
            };
        },


        async queryWebsideId(token, ownerId) {
            const config = {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };

            console.log('========== queryWebsideId 开始 ==========');
            console.log('当前 pageType:', this.form2.pageType);
            console.log('传入的 ownerId:', ownerId);

            // 如果是萤火虫应用模板下载页 (pageType == 11)，使用模板列表接口
            if (this.form2.pageType == 11) {
                console.log('进入萤火虫应用模板下载页逻辑');
                console.log('用户输入的模板名称:', this.form2.templateName);
                console.log('当前推广流量 extensionFlow:', this.form2.extensionFlow);
                console.log('当前流量场景 flowScene:', this.form2.flowScene);

                const params = {
                    ownerId: ownerId,
                    extensionFlow: this.form2.extensionFlow,
                    flowScene: this.form2.flowScene
                };

                console.log('请求参数 params:', params);

                try {
                    console.log('开始请求模板列表接口...');
                    const res = await axios.post('apis/v3/communal/h5Template/list', qs.stringify(params), config);
                    console.log('模板列表接口返回完整数据:', JSON.stringify(res.data, null, 2));
                    console.log('返回码 code:', res.data.code);
                    console.log('返回消息 msg:', res.data.msg);
                    console.log('返回数据 data:', res.data.data);

                    if (res.data.code == 0 && res.data.data && res.data.data.length > 0) {
                        console.log('========== 遍历所有模板 ==========');
                        res.data.data.forEach((item, idx) => {
                            console.log(`模板${idx + 1}:`, {
                                h5Id: item.h5Id,
                                h5Name: item.h5Name,
                                h5Url: item.h5Url
                            });
                        });

                        console.log('可用模板名称列表:', res.data.data.map(t => `"${t.h5Name}"`));

                        // 如果有模板名称输入框的值，就按名称匹配，否则取第一个
                        let template = res.data.data[0];
                        console.log('默认取第一个模板:', template.h5Name);

                        if (this.form2.templateName && this.form2.templateName.trim()) {
                            const inputName = this.form2.templateName.trim();
                            console.log(`尝试匹配模板名称: "${inputName}"`);

                            const matched = res.data.data.find(item => item.h5Name === inputName);
                            if (matched) {
                                template = matched;
                                console.log(`✅ 匹配成功！模板名称: "${template.h5Name}", h5Id: ${template.h5Id}`);
                            } else {
                                console.warn(`❌ 未找到模板名称: "${inputName}"`);
                                console.log('请检查输入的名称是否与上面列表中的名称完全一致（包括大小写、空格）');
                                this.$message.warning(`未找到模板名称"${inputName}"，将使用第一个模板`);
                            }
                        } else {
                            console.log('用户未输入模板名称，使用第一个模板');
                        }

                        console.log('最终返回的模板:', {
                            pageId: template.h5Id,
                            pageUrl: template.h5Url
                        });
                        console.log('========== queryWebsideId 结束 ==========');

                        return {
                            pageId: template.h5Id,
                            pageUrl: template.h5Url
                        };
                    } else {
                        console.warn('模板列表为空或请求失败');
                        console.log('code:', res.data.code);
                        console.log('msg:', res.data.msg);
                        console.log('data:', res.data.data);
                        this.$message.warning('未获取到可用模板，请检查流量场景配置');
                    }
                } catch (error) {
                    console.error('获取模板列表失败:', error);
                    console.error('错误详情:', error.response.data || error.message);
                    this.$message.error('获取模板列表失败');
                }
                console.log('========== queryWebsideId 结束（返回null） ==========');
                return null;
            }

            // 原有的其他 pageType 逻辑
            console.log('进入其他 pageType 逻辑');
            const params = {
                ownerId: ownerId,
                pageType: this.form2.pageType
            };
            console.log('请求参数:', params);

            try {
                const res = await axios.post('apis/v2/communal/ad/sparkPageNew/list', qs.stringify(params), config);
                console.log('落地页接口返回:', res.data);

                if (res.data.code == 0 && res.data.data && res.data.data.length > 0) {
                    console.log('获取到落地页:', res.data.data[0]);
                    return {
                        pageId: res.data.data[0].pageId,
                        pageUrl: res.data.data[0].pageUrl
                    };
                } else {
                    console.warn('未获取到落地页');
                }
            } catch (error) {
                console.error('获取落地页失败:', error);
            }
            console.log('========== queryWebsideId 结束（返回null） ==========');
            return null;
        },

        // ========== 模板管理方法 ==========

        templateDialogVisibleChange() {
            this.templateDialogVisible = true;
            this.fetchData();
        },

        async fetchData() {
            try {
                const res = await axios.get('https://control.zjwec.cn/oppotemplate/query_template_list', {
                    params: this.queryParams
                });
                this.templateList = res.data.records || [];
                this.templatetotal = res.data.total || 0;
            } catch (error) {
                console.error('获取模板失败:', error);
                this.$message.error('获取模板失败');
            }
        },

        handletemplateQuery() {
            this.queryParams.page_no = 1;
            this.fetchData();
        },

        resettemplateQuery() {
            this.queryParams = {
                model_name: '',
                page_no: 1,
                page_size: 10
            };
            this.fetchData();
        },

        handleSizeChange(size) {
            this.queryParams.page_size = size;
            this.fetchData();
        },

        handletamplateCurrentChange(page) {
            this.queryParams.page_no = page;
            this.fetchData();
        },

        async handletemplateDelete(row) {
            this.$confirm('确定删除该模板吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const res = await axios.delete(`https://control.zjwec.cn/oppotemplate/delete/${row.id}`);
                if (res.data.code == 0) {
                    this.$message.success('删除成功');
                    this.fetchData();
                } else {
                    this.$message.error('删除失败');
                }
            }).catch(() => { });
        },

        async templateInfoChange(row) {
            let loading = this.$loading({
                lock: true,
                text: '正在录入...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            try {
                let res = this.deepParseObject(row);

                this.form = {
                    ...this.form,
                    extension_type: res.extension_type,
                    delivery_mode: res.delivery_mode,
                    dayLimit: res.day_limit,
                    switchPlan: res.switch_plan,
                    dayBudget: res.day_limit > 0 ? res.day_budget / 100 : this.form.dayBudget,
                    campaign_name: res.campaign_name || '',
                    adgroupNumber: res.adgroup_number || 1,
                    useLatestPlan: res.use_latest_plan || false
                };

                this.changeextensionFlow(res.extension_flow);
                this.flowScenechange(res.flow_scene);

                this.form2.pageTypelabel = this.pageType_list.find(item => item.value == res.page_type) ? this.pageType_list.find(item => item.value == res.page_type).label : '';

                this.form2 = {
                    ...this.form2,
                    extensionFlow: res.extension_flow,
                    flowScene: res.flow_scene,
                    pageType: res.page_type,
                    Deeplinktype: res.deeplink_type,
                    Deeplinkstatus: res.deeplink_status,
                    linkDeskFlag: res.link_desk_flag,
                    billingType: res.billing_type,
                    defaultSecondStage: res.default_second_stage,
                    price: res.price,
                    ocpcType: res.ocpc_type,
                    ocpcPrice: res.ocpc_price,
                    deepOcpcStatus: res.deep_ocpc_status,
                    deepOcpcType: res.deep_ocpc_type,
                    deepOcpcPrice: res.deep_ocpc_price
                };

                this.form3 = {
                    ...this.form3,
                    number: res.number,
                    buttonTxt: res.button_txt,
                    brandName: res.brand_name
                };

                this.parsestatus = res.parsestatus || false;
                this.isoldgroupprice = res.isoldgroupprice || false;
                this.mixminvalue = res.mixminvalue || false;
                this.mixminvaluelate = res.mixminvaluelate || '轮询';
                this.material_type = res.material_type || '';
                this.titlesString = res.titles_string || '';

                this.$message.success('模板加载成功');
                this.templateDialogVisible = false;

            } catch (error) {
                console.error('加载模板失败:', error);
                this.$message.error('加载模板失败');
            } finally {
                loading.close();
            }
        },

        deepParseObject(obj) {
            if (typeof obj !== 'object' || obj === null) return obj;

            Object.keys(obj).forEach(key => {
                let value = obj[key];
                if (typeof value == 'string') {
                    try {
                        const parsed = JSON.parse(value);
                        obj[key] = this.deepParseObject(parsed);
                    } catch (e) { }
                } else if (typeof value === 'object' && value !== null) {
                    obj[key] = this.deepParseObject(value);
                }
            });
            return obj;
        },

        shallowStringifyAll(obj) {
            const result = {};
            for (const key in obj) {
                if (obj.hasOwnProperty(key)) {
                    const value = obj[key];
                    if (value === null || value === undefined) {
                        result[key] = '';
                    } else if (typeof value === 'object') {
                        result[key] = JSON.stringify(value);
                    } else {
                        result[key] = String(value);
                    }
                }
            }
            return result;
        },

        async templateSave() {
            if (this.form.campaign_name == "") {
                this.$message.warning('广告计划名称为空');
                return;
            }
            if (this.form.adgroupNumber == "" || this.form.adgroupNumber < 1) {
                this.$message.warning('广告组搭建数量不能为空且至少为1');
                return;
            }
            if (this.form2.pageType == "") {
                this.$message.warning('网页地址类型为空');
                return;
            }
            if (!this.isoldgroupprice && !this.form2.price) {
                this.$message.warning('基础出价为空');
                return;
            }
            if (this.form3.number == '') {
                this.$message.warning('创意搭建数量为空');
                return;
            }
            if (this.material_type == '') {
                this.$message.warning('创意样式为空');
                return;
            }
            if (this.form3.buttonTxt == '') {
                this.$message.warning('按钮文案为空');
                return;
            }
            if (this.form3.brandName == '') {
                this.$message.warning('品牌名称为空');
                return;
            }
            if (this.titlesString == '') {
                this.$message.warning('文案为空');
                return;
            }

            let arr = {
                "extension_type": this.form.extension_type,
                "delivery_mode": this.form.delivery_mode,
                "day_limit": this.form.dayLimit,
                "switch_plan": this.form.switchPlan,
                "campaign_name": this.form.campaign_name,
                "adgroup_number": this.form.adgroupNumber,
                "use_latest_plan": this.form.useLatestPlan,
                "extension_flow": this.form2.extensionFlow,
                "flow_scene": this.form2.flowScene,
                "parsestatus": this.parsestatus,
                "page_type": this.form2.pageType,
                "deeplink_type": this.form2.Deeplinktype,
                "deeplink_status": this.form2.Deeplinkstatus,
                "link_desk_flag": this.form2.linkDeskFlag,
                "billing_type": this.form2.billingType,
                "default_second_stage": this.form2.defaultSecondStage,
                "isoldgroupprice": this.isoldgroupprice,
                "price": this.form2.price,
                "ocpc_type": this.form2.ocpcType,
                "ocpc_price": this.form2.ocpcPrice,
                "deep_ocpc_status": this.form2.deepOcpcStatus,
                "deep_ocpc_type": this.form2.deepOcpcType,
                "deep_ocpc_price": this.form2.deepOcpcPrice,
                "mixminvalue": this.mixminvalue,
                "mixminvaluelate": this.mixminvaluelate,
                "number": this.form3.number,
                "material_type": this.material_type,
                "button_txt": this.form3.buttonTxt,
                "brand_name": this.form3.brandName,
                "titles_string": this.titlesString
            };

            if (this.form.dayLimit == 1) {
                arr = { ...arr, day_budget: this.form.dayBudget * 100 };
            } else {
                arr = { ...arr, day_budget: 0 };
            }

            this.$prompt('请输入模板名称', '保存模板', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValidator: (value) => {
                    return value && value.trim() !== '';
                },
                inputErrorMessage: '模板名称不能为空'
            }).then(async ({ value }) => {
                let loading = this.$loading({
                    lock: true,
                    text: '正在保存模板...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                try {
                    let templateData = {
                        ...arr,
                        model_name: value.trim()
                    };
                    templateData = this.shallowStringifyAll(templateData);

                    const res = await axios.post('https://control.zjwec.cn/oppotemplate/save', templateData);
                    if (res.data.code == 0) {
                        this.$message.success('保存成功');
                    } else {
                        this.$message.error(res.data.msg || '保存失败');
                    }
                } catch (error) {
                    console.error('保存出错:', error);
                    this.$message.error('保存过程中出错');
                } finally {
                    loading.close();
                }
            }).catch(() => { });
        },

        handleDialogClose() { },

        // ========== 定时任务管理方法 ==========

        dsDialogVisibleChange() {
            this.dsDialogVisible = true;
            this.fetchdsData();
        },

        async fetchdsData() {
            try {
                const res = await axios.get('https://control.zjwec.cn/api/v1/oppo/pd/task/page', {
                    params: this.dsqueryParams
                });
                this.dstemplateList = res.data.data && res.data.data.records ? res.data.data.records : [];
                this.dstemplatetotal = res.data.data && res.data.data.total ? res.data.data.total : 0;
            } catch (error) {
                console.error('获取定时任务失败:', error);
                this.$message.error('获取定时任务失败');
            }
        },

        dshandletemplateQuery() {
            this.dsqueryParams.current = 1;
            this.fetchdsData();
        },

        handledsSizeChange(size) {
            this.dsqueryParams.size = size;
            this.fetchdsData();
        },

        handledstamplateCurrentChange(page) {
            this.dsqueryParams.current = page;
            this.fetchdsData();
        },

        async dshandletemplateDelete(row) {
            this.$confirm('确定删除该定时任务吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const res = await axios.post(`https://control.zjwec.cn/api/v1/oppo/pd/task/delete?id=${row.id}`);
                if (res.data.code == 0) {
                    this.$message.success('删除成功');
                    this.fetchdsData();
                } else {
                    this.$message.error('删除失败');
                }
            }).catch(() => { });
        },

        templatedsChange(row) {
            this.dschangeCurrentId = row.id;
            this.dschangeCurrentStatus = row.status;
            this.dschangeForm = {
                dschangeTaskName: row.taskName || '',
                dschangeExecuteTime: row.executeTime || '',
                dschangeStatus: row.status || 0
            };
            this.dschangeDialogVisible = true;

            this.$nextTick(() => {
                if (this.$refs.dschangeFormRef) {
                    this.$refs.dschangeFormRef.clearValidate();
                }
            });
        },

        async dschangeHandleSubmit() {
            this.$refs.dschangeFormRef.validate(async (valid) => {
                if (!valid) return;

                if (this.dschangeCurrentStatus === 0) {
                    const selectedTime = new Date(this.dschangeForm.dschangeExecuteTime);
                    if (selectedTime <= new Date()) {
                        this.$message.error('待执行的任务必须设置未来的时间');
                        return;
                    }
                }

                this.dschangeLoading = true;

                try {
                    const submitData = {
                        id: this.dschangeCurrentId,
                        taskName: this.dschangeForm.dschangeTaskName.trim(),
                        executeTime: this.dschangeForm.dschangeExecuteTime,
                        status: this.dschangeForm.dschangeStatus
                    };

                    const res = await axios.post('https://control.zjwec.cn/api/v1/oppo/pd/task/update', submitData);

                    if (res.data.code == 0) {
                        this.$message.success('更新成功');
                        this.dschangeDialogVisible = false;
                        this.fetchdsData();
                    } else {
                        this.$message.error(res.data.msg || '更新失败');
                    }
                } catch (error) {
                    console.error('更新任务失败:', error);
                    this.$message.error('更新失败');
                } finally {
                    this.dschangeLoading = false;
                }
            });
        },

        dschangeHandleDialogClose() {
            this.dschangeCurrentId = null;
            this.dschangeCurrentStatus = 0;
            this.dschangeForm = {
                dschangeTaskName: '',
                dschangeExecuteTime: '',
                dschangeStatus: 0
            };
        },

        // ========== 日志查看方法 ==========

        async templatedslogChange(row) {
            this.dslogLoading = true;
            this.dslogDialogVisible = true;

            try {
                const logData = await this.dslogFetchLogData(row.id);
                this.dslogCurrentData = Array.isArray(logData) ? logData : [logData];
            } catch (error) {
                console.error('获取日志失败:', error);
                this.$message.error('获取日志失败');
                this.dslogCurrentData = [];
            } finally {
                this.dslogLoading = false;
            }
        },

        async dslogFetchLogData(taskId) {
            try {
                const response = await axios.get('https://control.zjwec.cn/api/v1/oppo/pd/task/log', {
                    params: { id: String(taskId) }
                });

                if (response.data && response.data.code == 200) {
                    return response.data.data || [];
                }
                return [];
            } catch (error) {
                throw error;
            }
        },

        formatAccountName(row) {
            return row.idsname || `账户${this.dslogCurrentData.indexOf(row) + 1}`;
        },

        getStatusClass(message) {
            if (!message) return 'status-wait';
            if (message.includes('成功')) return 'status-success';
            if (message.includes('失败') || message.includes('错误')) return 'status-error';
            return 'status-wait';
        },

        getOverallStatus(row) {
            if (row.createMsg && row.createMsg.includes('成功')) {
                return '成功';
            } else if (!row.createMsg && !row.planMsg && !row.groupMsg) {
                return '待执行';
            } else {
                return '失败';
            }
        },

        getOverallStatusType(row) {
            if (row.createMsg && row.createMsg.includes('成功')) {
                return 'success';
            } else if (!row.createMsg && !row.planMsg && !row.groupMsg) {
                return 'warning';
            } else {
                return 'danger';
            }
        },

        getSuccessCount() {
            return this.dslogCurrentData.filter(row =>
                row.createMsg && row.createMsg.includes('成功')
            ).length;
        },

        getErrorCount() {
            return this.dslogCurrentData.filter(row =>
                !(row.createMsg && row.createMsg.includes('成功'))
            ).length;
        },

        dslogExportLog() {
            const logContent = this.dslogGenerateLogContent();
            this.dslogDownloadLogFile(logContent, `任务日志_${Date.now()}.txt`);
            this.$message.success('日志导出成功');
        },

        dslogGenerateLogContent() {
            let content = `任务执行日志报告\n================\n\n总体统计:\n--------\n总账户数: ${this.dslogCurrentData.length}\n成功账户: ${this.getSuccessCount()}\n失败账户: ${this.getErrorCount()}\n生成时间: ${new Date().toLocaleString()}\n\n详细日志:\n--------\n`;

            this.dslogCurrentData.forEach((row, index) => {
                content += `\n${index + 1}. ${row.idsname || `账户${index + 1}`}\n   计划: ${row.planMsg || '等待执行'}\n   广告组: ${row.groupMsg || '等待执行'}\n   创意: ${row.createMsg || '等待执行'}\n   总体: ${this.getOverallStatus(row)}\n`;
            });
            return content;
        },

        dslogDownloadLogFile(content, filename) {
            const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href);
        },

        dslogHandleClose() {
            this.dslogCurrentData = [];
            this.dslogLoading = false;
        },

        // ========== 定时任务创建 ==========

        showTimerDialog() {
            return new Promise((resolve) => {
                this.timerDialogVisible = true;
                this.timerForm = {
                    name: '',
                    time: ''
                };

                const now = new Date();
                now.setHours(now.getHours() + 1);
                this.timerForm.time = now.toISOString().slice(0, 16).replace('T', ' ') + ':00';

                this.timerResolve = resolve;

                this.$nextTick(() => {
                    if (this.$refs.timerFormRef) {
                        this.$refs.timerFormRef.clearValidate();
                    }
                });
            });
        },

        handleTimerConfirm() {
            this.$refs.timerFormRef.validate((valid) => {
                if (!valid) return;

                const selectedTime = new Date(this.timerForm.time);
                if (selectedTime <= new Date()) {
                    this.$message.error('请选择未来的时间');
                    return;
                }

                this.timerDialogVisible = false;
                this.timerResolve({
                    timerName: this.timerForm.name.trim(),
                    executeTime: this.timerForm.time
                });
            });
        },

        handleTimerCancel() {
            this.timerDialogVisible = false;
            if (this.timerResolve) {
                this.timerResolve(null);
            }
        },

        // ========== 账户相关方法 ==========

        async recordsChange() {
            await this.GetRo();
        },

        async GetRo() {
            if (!this.btgjc) return;

            try {
                const res = await axios.post('https://test.nbweiou.cn/api/oppo/get_vivo_user', {
                    username: this.btgjc
                });
                this.two = res.data;
            } catch (error) {
                console.error('获取账户失败:', error);
                this.$message.error('获取账户失败');
            }
        },

        async GetRoChange() {
            await this.findIds();
        },

        async findIds() {
            if (!this.btgjc || !this.towName) {
                this.$message.warning('请选择项目和账户');
                return;
            }

            try {
                const res = await axios.post('https://test.nbweiou.cn/api/oppo/get_ids', {
                    username: this.btgjc,
                    twoname: this.towName
                });

                this.ids_list = res.data;
                await this.fetchLatestPrices();

            } catch (error) {
                console.error('获取账户信息失败:', error);
                this.$message.error('获取账户信息失败');
            }
        },

        ocpcTypechange(type) {
            console.log(type);
            if (type == 8) {
                this.form2.deepOcpcTypeoptions = [{ value: "10", label: "回传留存" },
                { value: "39", label: "回传留存率" }, { value: "40", label: "应用付费率" }];
            }
        },

        async fetchLatestPrices() {
            const now = new Date();
            const year = now.getFullYear();
            const month = now.getMonth() + 1;
            const pad = (n) => (n < 10 ? '0' + n : n);
            const beginTime = Number(`${year}${pad(month)}01`);
            const endTime = Number(`${year}${pad(month)}${pad(now.getDate())}`);

            const promises = this.ids_list.map(async (item, index) => {
                const time1 = Math.floor(Date.now() / 1000);
                const sign = sha1(item.apiid + item.apikey + time1);
                const token = Base64.encode(item.ownerid + "," + item.apiid + "," + time1 + "," + sign);

                const config = {
                    headers: {
                        'Authorization': "Bearer " + token,
                        'Content-Type': "application/x-www-form-urlencoded"
                    }
                };

                try {
                    const resp = await axios.post(
                        "apis/v3/group/page",
                        qs.stringify({
                            ownerId: item.zzownerid,
                            page: 1,
                            limit: 25,
                            needStats: 1,
                            beginTime,
                            endTime,
                            deleteFlag: 0,
                            asc: "DESC"
                        }),
                        config
                    );

                    if (resp.data.data && resp.data.data.records && resp.data.data.records.length > 0) {
                        this.ids_list[index].price = resp.data.data.records[0].price;
                        this.ids_list[index].ocpcPrice = resp.data.data.records[0].ocpxPrice || resp.data.data.records[0].ocpcPrice;
                    } else {
                        this.$message.warning(`账户 ${item.idsname} 无法获取最新广告组出价`);
                    }
                } catch (error) {
                    console.error(`获取账户 ${item.idsname} 出价失败:`, error);
                }
            });

            await Promise.all(promises);
        },

        // ========== 搭建广告 ==========

        validateBeforeCreate() {
            if (!this.ids_list.length) {
                this.$message.warning('请选择账户');
                return false;
            }
            if (!this.form.campaign_name) {
                this.$message.warning('请填写广告计划名称');
                return false;
            }
            if (!this.form.adgroupNumber || this.form.adgroupNumber < 1) {
                this.$message.warning('广告组搭建数量不能为空且至少为1');
                return false;
            }
            if (!this.form2.pageType) {
                this.$message.warning('请选择网页地址类型');
                return false;
            }
            if (!this.isoldgroupprice && !this.form2.price) {
                this.$message.warning('请填写基础出价');
                return false;
            }
            if (!this.form3.number || this.form3.number < 1) {
                this.$message.warning('创意搭建数量不能为空且至少为1');
                return false;
            }
            if (!this.material_type) {
                this.$message.warning('请选择创意样式');
                return false;
            }
            if (!this.form3.buttonTxt) {
                this.$message.warning('请填写按钮文案');
                return false;
            }
            if (!this.form3.brandName) {
                this.$message.warning('请填写品牌名称');
                return false;
            }
            if (!this.titlesString) {
                this.$message.warning('请填写文案');
                return false;
            }
            return true;
        },

        checkClickInterval() {
            const now = Date.now();
            if (now - this.lastClickTime < 5000) {
                const remaining = Math.ceil((5000 - (now - this.lastClickTime)) / 1000);
                this.$message.warning(`请等待${remaining}秒后再试`);
                return false;
            }
            this.lastClickTime = now;
            return true;
        },

        async createdsdanyuan() {
            if (!this.validateBeforeCreate()) return;
            if (!this.checkClickInterval()) return;

            this.isdsLoading = true;

            try {
                const timerInfo = await this.showTimerDialog();
                if (!timerInfo) {
                    this.$message.info('已取消定时计划设置');
                    this.isdsLoading = false;
                    return;
                }

                this.uploadPercent = 0;
                this.showProgress = true;

                const { timerName, executeTime } = timerInfo;
                this.dingshiobj = {
                    ids_list: [...this.ids_list],
                    timerName,
                    executeTime,
                    data1: {},
                    data2: {},
                    data3: []
                };

                const label = this.extensionType_goal_group.find(item => item.value == this.form.extension_type).label;

                for (let key = 0; key < this.ids_list.length; key++) {
                    this.steps = [
                        { name: '广告计划', status: 'wait' },
                        { name: '广告组', status: 'wait' },
                        { name: '广告创意', status: 'wait' }
                    ];
                    this.activeStep = 0;
                    this.uploadPercent = Math.round((key / this.ids_list.length) * 100);
                    this.$message.success(`正在准备第${key + 1}条定时指令`);

                    this.updatePlanName(label);
                    this.setStepStatus(0, 'process');

                    const time1 = Math.floor(Date.now() / 1000);
                    const sign = sha1(this.ids_list[key].apiid + this.ids_list[key].apikey + time1);
                    const token = Base64.encode(`${this.ids_list[key].ownerid},${this.ids_list[key].apiid},${time1},${sign}`);

                    const config = {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/x-www-form-urlencoded'
                        }
                    };

                    const planData = {
                        planName: this.form.campaign_name,
                        deliveryMode: this.form.delivery_mode,
                        extensionType: this.form.extension_type,
                        dayLimit: this.form.dayLimit,
                        status2: this.form.switchPlan,
                        useLatestPlan: this.form.useLatestPlan
                    };

                    if (this.form.dayLimit == 1) {
                        planData.dayBudget = this.form.dayBudget * 100;
                    }

                    const groupData = {
                        extensionFlow: this.form2.extensionFlow,
                        flowScene: this.form2.flowScene,
                        targetId: this.ids_list[key].targetid,
                        billingType: this.form2.billingType,
                        price: this.isoldgroupprice && this.ids_list[key].price ?
                            this.ids_list[key].price : this.form2.price * 100,
                        dayLimit: 0,
                        ownerId: this.ids_list[key].zzownerid,
                        extensionType: this.form.extension_type
                    };

                    if (this.timeLimit == 1) {
                        groupData.timeLimit = 1;
                        groupData.timeSet = this.timeSet;
                    } else {
                        groupData.timeLimit = 0;
                    }

                    if ([6, 7, 9, 10, 11].includes(Number(this.form2.flowScene))) {
                        groupData.advertiseType = this.form2.dpaProductType;
                    }

                    if (this.form2.flowScene == 6 && this.form.extension_type == 3) {
                        groupData.linkDeskFlag = this.form2.linkDeskFlag;
                    }

                    if (this.form2.Deeplinkstatus) {
                        this.dingshiobj.ids_list[key].haplink = this.ids_list[key].haplink;
                    }

                    let pageInfo = null;
                    if (this.parsestatus) {
                        pageInfo = await this.queryWebsideId(token, this.ids_list[key].zzownerid);
                    }

                    if (this.form.extension_type == 3) {
                        groupData.pageType = this.form2.pageType;
                        groupData.instantAppId = this.ids_list[key].appid;
                        groupData.instantAppUrl = this.ids_list[key].haplink;

                        this.dingshiobj.ids_list[key] = {
                            ...this.dingshiobj.ids_list[key],
                            instantAppId: this.ids_list[key].appid,
                            instantAppUrl: this.ids_list[key].haplink,
                            haplink: ""
                        };

                        if (pageInfo && pageInfo.pageUrl && pageInfo.pageId) {
                            this.dingshiobj.ids_list[key].url = pageInfo.pageUrl;
                            this.dingshiobj.ids_list[key].pageId = pageInfo.pageId;
                        }
                    } else if (this.form.extension_type == 1) {
                        if (this.form2.Deeplinktype == 0) {
                            groupData.pageType = this.form2.pageType;

                            if (pageInfo && pageInfo.pageUrl && pageInfo.pageId) {
                                this.dingshiobj.ids_list[key].url = pageInfo.pageUrl;
                                this.dingshiobj.ids_list[key].pageId = pageInfo.pageId;
                            }
                        } else if (this.form2.Deeplinktype == 3) {
                            groupData.Deeplinktype = this.form2.Deeplinktype;
                            groupData.pageType = this.form2.pageType;
                            groupData.instantAppId = this.ids_list[key].appid;
                            groupData.instantAppUrl = this.ids_list[key].haplink;

                            this.dingshiobj.ids_list[key] = {
                                ...this.dingshiobj.ids_list[key],
                                instantAppId: this.ids_list[key].appid,
                                instantAppUrl: this.ids_list[key].haplink,
                                haplink: ""
                            };

                            if (pageInfo && pageInfo.pageUrl && pageInfo.pageId) {
                                this.dingshiobj.ids_list[key].url = pageInfo.pageUrl;
                                this.dingshiobj.ids_list[key].pageId = pageInfo.pageId;
                            }
                        }
                    }

                    if (this.form2.billingType == 5) {
                        if (this.form2.ocpcType == 47) {
                            groupData.targetROI = this.form2.targetROI * 1000000;
                            groupData.ocpcType = this.form2.ocpcType;
                            groupData.defaultSecondStage = this.form2.defaultSecondStage;
                        } else {
                            groupData.ocpcPrice = this.isoldgroupprice && this.ids_list[key].ocpcPrice ?
                                this.ids_list[key].ocpcPrice : this.form2.ocpcPrice * 100;
                            groupData.ocpcType = this.form2.ocpcType;
                            groupData.defaultSecondStage = this.form2.defaultSecondStage;
                        }
                    }

                    this.dingshiobj.data1 = planData;
                    this.dingshiobj.data2 = groupData;

                    const creativeData = {
                        ownerId: this.ids_list[key].zzownerid
                    };

                    await this.prepareCreativesData(creativeData, token, key);
                }

                const res = await axios.post("https://control.zjwec.cn/api/v1/oppo/pd/task/insert", this.dingshiobj);
                console.log('定时任务创建结果:', res);

                if (res.data.code == 0) {
                    this.$message.success("创建定时任务成功");
                    this.uploadPercent = 100;
                } else {
                    this.$message.error("创建定时任务失败: " + (res.data.message || '未知错误'));
                }

            } catch (error) {
                console.error('创建定时任务失败:', error);
                this.$message.error('创建定时任务失败: ' + (error.message || '未知错误'));
            } finally {
                setTimeout(() => {
                    this.showProgress = false;
                    this.isdsLoading = false;
                }, 31500);
            }
        },

        async prepareCreativesData(data, token, accountIndex) {
            let textList = this.titlesString
                .split('\n')
                .map(line => line.trim())
                .filter(line => line);

            const addList = [];
            const adGroupCount = parseInt(this.form.adgroupNumber) || 1;
            const creativeCount = parseInt(this.form3.number) || 1;

            for (let g = 0; g < adGroupCount; g++) {
                for (let i = 0; i < creativeCount; i++) {
                    const creative = {
                        ...data,
                        brandName: this.form3.brandName,
                        globalSpecId: this.form3.type,
                        clickUrl: this.ids_list[accountIndex].xiaoshuourl
                    };

                    const textIndex = i % textList.length;
                    creative.copywriter = textList[textIndex] || textList[0];

                    const flowScene = Number(this.form2.flowScene);
                    const creativeType = Number(this.form3.type);

                    if ([60, 63].includes(creativeType)) {
                        if (creativeType == 63 || flowScene == 11) {
                            creative.buttonTxt = this.form3.buttonTxt;
                        }
                    } else if ([1, 20, 30, 50, 71].includes(creativeType)) {
                        creative.buttonTxt = this.form3.buttonTxt;
                    } else if ([5, 34].includes(creativeType)) {
                        if (creativeType == 34) {
                            creative.copywriter = textList[i % textList.length] || textList[0];
                        }
                    }

                    addList.push(creative);
                }
            }

            this.dingshiobj.data3 = [...this.dingshiobj.data3, ...addList];
        },

        setStepStatus(index, status) {
            if (this.steps[index]) {
                this.steps[index].status = status;
                this.activeStep = index;
            }
        },

        updatePlanName(typeText) {
            this.form.planName = `${typeText}`;
        },

        // ========== 时段设置方法 ==========

        handleTimeLimitChange() {
            if (this.timeLimit === 0) {
                this.startTime = null;
                this.endTime = null;
                this.errorMessage = '';
                this.timeSet = '';
            }
        },

        validateAndGenerateTimeSet() {
            if (this.startTime && this.endTime) {
                if (this.startTime >= this.endTime) {
                    this.errorMessage = '开始时间不能大于或等于结束时间';
                    this.timeSet = '';
                } else {
                    this.errorMessage = '';
                    this.generateTimeSet();
                }
            }
        },

        convertTimeToHalfHours(time) {
            const [hour, minute] = time.split(':').map(Number);
            return hour * 2 + (minute === 30 ? 1 : 0);
        },

        generateTimeSet() {
            const startHalfHour = this.convertTimeToHalfHours(this.startTime);
            const endHalfHour = this.convertTimeToHalfHours(this.endTime) - 1;

            const halfHourArray = [];
            for (let i = startHalfHour; i <= endHalfHour; i++) {
                halfHourArray.push(i);
            }
            const halfHourString = halfHourArray.join(',');

            const timeSetObj = {};
            this.days.forEach(day => {
                timeSetObj[day] = halfHourString;
            });

            this.timeSet = JSON.stringify(timeSetObj);
        },

        removeAccount(index) {
            this.ids_list.splice(index, 1);
        },

        clearAllImages() {
            this.tpfileList = [];
            this.tpfileListcode = [];
            this.$message.success('已清空所有图片');
        },

        clearAllvideos() {
            this.videofileList = [];
            this.videofileListcode = [];
            this.$message.success('已清空所有视频');
        },

        clearAllcoverImages() {
            this.videotpfileList = [];
            this.videotpfileListcode = [];
            this.$message.success('已清空所有封面图片');
        }
    }
};
</script>

<style scoped>
/* 原有样式保持不变，添加任务管理相关样式 */

.ad-flow {
    position: fixed;
    height: 450px;
    top: 150px;
    right: 150px;
    padding: 15px 0;
    background: #fff;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    text-align: center;
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
}

.el-step__title {
    font-size: 14px;
}

.step-detail {
    font-size: 12px;
    color: #909399;
    margin-top: 4px;
}

.progress-percent {
    margin-top: 16px;
    font-weight: bold;
    color: #409EFF;
}

.plan-container {
    text-align: left;
    padding: 20px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    margin-bottom: 50px;
}

.el-form-item__label {
    margin-right: 50px;
}

.demo-ruleForm {
    max-width: 1000px;
}

.el-form-item {
    margin-bottom: 22px;
}

.el-radio-group {
    margin-right: 15px;
}

.el-input {
    width: 280px;
}

.el-button {
    margin-right: 10px;
}

.adgroup-item {
    color: #1890ff;
    line-height: 20px;
    font-size: 16px;
    border-left: 2px solid #1890ff;
    padding-left: 8px;
    font-family: PingFangSC-Regular;
    margin-top: 40px;
    margin-bottom: 40px;
}

.adgroup-item2 {
    color: #606266;
    line-height: 20px;
    font-size: 12px;
    border-left: 2px solid #606266;
    padding-left: 8px;
    font-family: PingFangSC-Regular;
    margin-top: 40px;
    margin-bottom: 40px;
}

.adgroup-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 15px 0;
    background: #fff;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    text-align: center;
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
}

.item-orient {
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.image-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding: 12px 16px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 8px;
    color: white;
}

.image-count {
    font-size: 14px;
    font-weight: 500;
}

.image-count i {
    margin-right: 8px;
}

.upload-trigger {
    cursor: pointer;
}

.file-item {
    position: relative;
    width: 100%;
    height: 100%;
}

.file-item .el-upload-list__item-actions {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    opacity: 0;
    transition: opacity 0.3s;
}

.file-item:hover .el-upload-list__item-actions {
    opacity: 1;
}

.file-item .el-upload-list__item-actions span {
    margin: 0 8px;
    cursor: pointer;
}

.media-gallery {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin: 20px 0;
}

.media-item {
    width: 150px;
    position: relative;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    overflow: hidden;
}

.media-content {
    position: relative;
}

.media-thumbnail {
    width: 100%;
    height: 100px;
    object-fit: cover;
}

.file-info {
    padding: 8px;
    background: #f5f7fa;
}

.file-name {
    font-size: 12px;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.media-actions {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    background: rgba(0, 0, 0, 0.5);
    opacity: 0;
    transition: opacity 0.3s;
}

.media-item:hover .media-actions {
    opacity: 1;
}

.media-actions span {
    color: white;
    cursor: pointer;
    font-size: 18px;
}

.position-index {
    position: absolute;
    top: 5px;
    left: 5px;
    background: rgba(0, 0, 0, 0.6);
    color: white;
    padding: 2px 6px;
    border-radius: 10px;
    font-size: 12px;
}

.video-list {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin: 20px 0;
}

.video-item {
    flex: 0 0 calc(25% - 12px);
    box-sizing: border-box;
    position: relative;
}

.video-content {
    position: relative;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 12px;
    transition: all 0.3s;
}

.video-content:hover {
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.selection-checkbox {
    position: absolute;
    top: 8px;
    left: 8px;
    z-index: 2;
}

.selection-checkbox input {
    width: 16px;
    height: 16px;
    cursor: pointer;
}

.video-title {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: 20px;
}

.video-thumbnail {
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
    position: relative;
    overflow: hidden;
    background: #f5f7fa;
}

.video-thumbnail video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.delete-btn {
    position: absolute;
    top: 8px;
    right: 8px;
    color: #f56c6c;
}

.style-selector {
    width: 100%;
}

.category {
    margin-bottom: 20px;
}

.category-title {
    font-size: 14px;
    color: #606266;
    margin-bottom: 10px;
    font-weight: bold;
}

.style-list {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    padding: 0;
    margin: 0 -8px;
}

.style-list li {
    width: 20%;
    padding: 15px 8px;
    margin-left: 15px;
    margin-bottom: 16px;
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    border: 1px solid #e6e7eb;
}

.style-list li.selected {
    border: 1px solid #409eff;
    border-radius: 4px;
}

.bg-image {
    width: 48px;
    height: 48px;
}

.style-info {
    display: block;
    margin-top: 8px;
    text-align: center;
    font-size: 12px;
    color: #606266;
}

.auto-cover-option {
    display: flex;
    align-items: center;
    gap: 8px;
}

.auto-cover-option .el-icon-question {
    color: #909399;
    cursor: help;
}

.material-stats {
    margin-left: 16px;
}

.material-tag {
    margin-right: 8px;
}

.task-card {
    margin-bottom: 20px;
}

.task-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.task-list {
    max-height: 300px;
    overflow-y: auto;
}

.task-item {
    margin-bottom: 12px;
    padding: 10px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
}

.task-title {
    margin-bottom: 8px;
}

.status-tag {
    margin-left: 8px;
}

.task-actions {
    text-align: right;
}

.task-progress {
    margin-top: 8px;
}

.task-progress span {
    font-size: 12px;
    color: #909399;
    margin-right: 10px;
}

.task-list-container {
    max-height: 600px;
    overflow-y: auto;
}

.task-detail-card {
    margin-bottom: 20px;
    padding: 15px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
}

.task-detail-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
}

.task-detail-title {
    display: flex;
    align-items: center;
    gap: 10px;
}

.task-tag {
    margin-right: 5px;
}

.task-detail-meta {
    display: flex;
    align-items: center;
    gap: 15px;
}

/* 失败账户汇总样式 */
.failed-accounts-summary {
    margin-bottom: 20px;
    padding: 12px 16px;
    background: #fef0f0;
    border: 1px solid #fbc4c4;
    border-radius: 8px;
}

.summary-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid #fbc4c4;
}

.summary-title {
    font-size: 14px;
    font-weight: bold;
    color: #f56c6c;
}

.summary-title i {
    margin-right: 6px;
}

.failed-accounts-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.failed-account-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 12px;
    background: #fff;
    border-radius: 6px;
    border: 1px solid #f5d4d4;
}

.fail-account-info {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}

.fail-account-name {
    font-weight: 500;
    color: #606266;
}

.fail-reason {
    font-size: 12px;
    color: #909399;
    max-width: 400px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.user-tasks-container {
    margin-top: 10px;
}

.user-task-detail {
    margin-bottom: 15px;
    padding: 10px;
    background: #f9f9f9;
    border-radius: 4px;
}

.user-header {
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.user-info {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.user-account-name {
    font-size: 14px;
}

.user-campaign {
    color: #909399;
    font-size: 12px;
}

.user-status-tag {
    margin-left: auto;
}

.user-stats {
    font-size: 12px;
    color: #606266;
}

.user-stats span {
    margin-left: 5px;
}

.user-steps-timeline {
    padding-left: 20px;
}

.user-timeline-item {
    display: flex;
    margin-bottom: 15px;
    position: relative;
}

.user-timeline-marker {
    width: 30px;
    position: relative;
}

.user-marker-icon {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    border: 1px solid #dcdfe6;
}

.user-marker-icon.wait {
    color: #909399;
}

.user-marker-icon.doing {
    color: #e6a23c;
    animation: rotating 2s linear infinite;
}

.user-marker-icon.success {
    color: #67c23a;
    border-color: #67c23a;
}

.user-marker-icon.error {
    color: #f56c6c;
    border-color: #f56c6c;
}

.user-timeline-connector {
    position: absolute;
    top: 20px;
    left: 9px;
    width: 2px;
    height: calc(100% + 5px);
    background: #dcdfe6;
}

.user-timeline-content {
    flex: 1;
}

.user-step-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 4px;
}

.user-step-name {
    font-weight: 500;
}

.user-step-status {
    font-size: 12px;
}

.user-step-detail {
    font-size: 12px;
    color: #909399;
}

.step-progress {
    margin-top: 8px;
    width: 200px;
}

.group-list {
    margin-top: 15px;
    padding: 10px;
    background: #fff;
    border-radius: 4px;
}

.group-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    font-size: 13px;
    color: #606266;
    cursor: pointer;
    padding: 5px;
    background: #f5f7fa;
    border-radius: 4px;
}

.group-title:hover {
    background: #e4e7ed;
}

.group-items {
    margin-left: 10px;
}

.group-item {
    margin-bottom: 12px;
    padding: 10px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
}

.group-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    cursor: pointer;
    padding: 5px;
}

.group-header:hover {
    background: #f5f7fa;
    border-radius: 4px;
}

.group-name-wrapper {
    display: flex;
    align-items: center;
    gap: 5px;
}

.group-name {
    font-size: 13px;
    font-weight: 500;
}

.group-status-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
}

.group-id {
    font-size: 11px;
    color: #909399;
}

.creative-list {
    margin-top: 10px;
    padding: 8px;
    background: #f9f9f9;
    border-radius: 4px;
    margin-left: 20px;
}

.creative-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    font-size: 12px;
    color: #606266;
}

.creative-item {
    margin-bottom: 8px;
    padding: 8px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
}

.creative-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
}

.creative-id {
    font-size: 12px;
    font-weight: 500;
}

.creative-steps {
    padding-left: 15px;
}

.creative-step {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 4px;
    font-size: 12px;
}

.creative-step-marker {
    width: 16px;
}

.creative-marker {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
}

.creative-marker.wait {
    color: #909399;
}

.creative-marker.doing {
    color: #e6a23c;
    animation: rotating 2s linear infinite;
}

.creative-marker.success {
    color: #67c23a;
}

.creative-marker.error {
    color: #f56c6c;
}

.creative-step-content {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.creative-step-name {
    color: #606266;
}

.creative-step-detail {
    color: #909399;
    font-size: 11px;
}

@keyframes rotating {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.message-content {
    word-break: break-all;
    line-height: 1.4;
}

.multi-line-ellipsis {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 4.2em;
}

.status-success {
    color: #67c23a;
    font-weight: bold;
}

.status-error {
    color: #f56c6c;
    font-weight: bold;
}

.status-wait {
    color: #909399;
    font-weight: bold;
}

.pagination {
    margin-top: 20px;
    text-align: right;
}

.query-form {
    margin-bottom: 20px;
}

.error {
    color: #f56c6c;
    font-size: 12px;
    margin-left: 10px;
}

/* 素材上传进度面板 */
.upload-progress-panel {
    margin-bottom: 20px;
    padding: 15px;
    background: #f5f7fa;
    border-radius: 8px;
    border: 1px solid #e4e7ed;
}

.progress-title {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 12px;
    color: #303133;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.progress-stats {
    font-size: 12px;
    color: #909399;
    font-weight: normal;
}

.upload-progress-item {
    margin-bottom: 12px;
    padding: 8px;
    background: #fff;
    border-radius: 6px;
}

.progress-info {
    display: flex;
    justify-content: space-between;
    margin-bottom: 6px;
    font-size: 12px;
}

.material-name {
    color: #606266;
    word-break: break-all;
    max-width: 70%;
}

.material-status {
    font-weight: 500;
}

.material-status.pending {
    color: #909399;
}

.material-status.uploading {
    color: #e6a23c;
}

.material-status.success {
    color: #67c23a;
}

.material-status.error {
    color: #f56c6c;
}

.progress-detail {
    font-size: 11px;
    color: #909399;
    margin-top: 4px;
}

@media (max-width: 768px) {
    .adgroup-footer {
        flex-direction: column;
        padding: 10px;
    }

    .adgroup-footer .el-button {
        margin: 5px 0 !important;
        width: 100%;
    }

    .video-item {
        flex: 0 0 calc(50% - 12px);
    }

    .style-list li {
        width: 33.33%;
    }
}

.el-checkbox__label {
    color: white !important;
}
</style>


// WEBPACK FOOTER //
// src/components/oppo/oppopida.vue